
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("9h92o", function(module, exports) {

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $5BRby = parcelRequire("5BRby");

var $2apnq = parcelRequire("2apnq");

var $49235 = parcelRequire("49235");

var $12NzK = parcelRequire("12NzK");

var $geFaw = parcelRequire("geFaw");

var $gd0Sp = parcelRequire("gd0Sp");
(0, $2apnq.provideHealthcheck)();
const $2e164b6c775efd10$var$container = document.createElement('div');
$2e164b6c775efd10$var$container.id = 'profilecard-app';
document.body && document.body.appendChild($2e164b6c775efd10$var$container);
(0, $lEfVV.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $geFaw.StrictMode), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $49235.JiraContextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5BRby.default), {
    id: "profilecard-next"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $12NzK.ProfileCardLegacy), {
    TenantContextSubscriber: (0, $gd0Sp.TenantContextSubscriber)
})))), $2e164b6c775efd10$var$container);

});
parcelRegister("2apnq", function(module, exports) {

$parcel$export(module.exports, "provideHealthcheck", () => $2d3550a09830cc5e$export$90dcee7ddb8a0c0c);

var $1ybV0 = parcelRequire("1ybV0");
const $2d3550a09830cc5e$var$globalObj = window || $parcel$global;
const $2d3550a09830cc5e$var$defaultHealthcheck = (callback)=>callback({
        isSuccess: true
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2d3550a09830cc5e$var$failingHealthcheck = (callback)=>callback({
        isSuccess: false
    });
const $2d3550a09830cc5e$export$90dcee7ddb8a0c0c = (healthcheck = $2d3550a09830cc5e$var$defaultHealthcheck)=>{
    const isHealthcheckAllFailEnabled = (0, $1ybV0.ff)('fe.platform.healthcheck.allfail.enabled');
    if (isHealthcheckAllFailEnabled) {
        $2d3550a09830cc5e$var$globalObj.performHealthcheck = $2d3550a09830cc5e$var$failingHealthcheck;
        return;
    }
    $2d3550a09830cc5e$var$globalObj.performHealthcheck = healthcheck;
};

});

parcelRegister("12NzK", function(module, exports) {

$parcel$export(module.exports, "ProfileCard", () => $c05a2c6fef331800$export$bed540ccfa8743c4);
$parcel$export(module.exports, "ProfileCardLegacy", () => $c05a2c6fef331800$export$dd0591e04a6e8ce6);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $k8Qyf = parcelRequire("k8Qyf");

var $4ksts = parcelRequire("4ksts");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");

var $kJlBc = parcelRequire("kJlBc");


var $dIJJY = parcelRequire("dIJJY");

var $4w3h5 = parcelRequire("4w3h5");

var $NILIK = parcelRequire("NILIK");

var $bv8gI = parcelRequire("bv8gI");
const $c05a2c6fef331800$export$bed540ccfa8743c4 = (props)=>{
    const { TenantContextSubscriber: TenantContextSubscriberComponent, externalProfileClient: externalProfileClient, accountId: accountId, actions: actions, analyticsData: analyticsData, children: children, position: position, testId: testId, trigger: trigger, prepopulatedData: prepopulatedData } = props;
    const intl = (0, $4ksts.useIntlV2)();
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: (0, $2f37035f7aaf1787$export$81319ffa9c0d18d7),
        attributes: analyticsData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $NILIK.default), {
        TenantContextSubscriber: TenantContextSubscriberComponent,
        externalProfileClient: externalProfileClient,
        analyticsData: analyticsData
    }, (atlassianAccountId, profileClient, cloudId, baseUrl)=>{
        if (atlassianAccountId !== '') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.RouterActions), null, ({ push: push })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dIJJY.default), {
                profileClient: profileClient,
                cloudId: cloudId,
                accountId: accountId,
                actions: (0, $bv8gI.getSpaActions)(accountId, baseUrl, intl, push, actions),
                position: position,
                onProfileClick: (profileAccountId)=>push(`${baseUrl}/jira/people/${profileAccountId}`),
                addFlag: showFlag,
                dismissFlag: dismissFlag,
                testId: testId,
                trigger: trigger,
                prepopulatedData: prepopulatedData
            }, children));
        return children;
    }));
};
const $c05a2c6fef331800$export$dd0591e04a6e8ce6 = (props)=>{
    const { TenantContextSubscriber: TenantContextSubscriberComponent, externalProfileClient: externalProfileClient, actions: actions } = props;
    const intl = (0, $4ksts.useIntlV2)();
    const onLoadError = (error, analyticsEvent)=>{
        if (analyticsEvent) (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, `${analyticsEvent.payload.actionSubject} ${analyticsEvent.payload.action}`, `${analyticsEvent.payload.actionSubject}${analyticsEvent.payload.action}`, {
            error: error
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: (0, $2f37035f7aaf1787$export$50632e21ea714398)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $NILIK.default), {
        TenantContextSubscriber: TenantContextSubscriberComponent,
        externalProfileClient: externalProfileClient,
        onLoadError: onLoadError
    }, (atlassianAccountId, profileClient, cloudId, baseUrl)=>// @ts-expect-error - TS2769 - No overload matches this call.
        atlassianAccountId !== null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c05a2c6fef331800$var$LegacyProfileCardStyled, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.RouterActions), null, ({ push: push })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4w3h5.default), {
                profileClient: profileClient,
                cloudId: cloudId,
                baseUrl: baseUrl,
                onGetActions: (accountId, onActionCleanup)=>(0, $bv8gI.getSpaActions)(accountId, baseUrl, intl, push, actions, onActionCleanup),
                onProfileClick: (profileAccountId)=>push(`${baseUrl}/jira/people/${profileAccountId}`)
            }))) : null));
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c05a2c6fef331800$var$LegacyProfileCardStyled = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1pbyb4wl",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4ksts", function(module, exports) {

$parcel$export(module.exports, "useIntlV2", () => $32efc9cfc8f5c011$export$d82607073b68786);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1IqwQ = parcelRequire("1IqwQ");
const $32efc9cfc8f5c011$export$d82607073b68786 = ()=>{
    const { messages: messages, locale: locale, formats: formats, formatDate: formatDate, formatMessage: formatMessage, formatRelativeTime: formatRelativeTime, formatNumber: formatNumber, formatPlural: formatPlural, formatTime: formatTime } = (0, $5JgJ2.default)();
    // Only recreate intl object if reference to originral intl changes.
    const memoisedIntl = (0, $eUqFw.useMemo)(()=>{
        const modifiedIntl = {
            // Now is deprecated since version 2: https://github.com/formatjs/formatjs/issues/1409
            now: ()=>Date.now(),
            messages: // @ts-expect-error - TS2322 - Type 'Record<string, string> | Record<string, MessageFormatElement[]>' is not assignable to type '{ [id: string]: string; }'.
            messages,
            locale: locale,
            formats: formats,
            formatDate: formatDate,
            formatMessage: formatMessage,
            formatHTMLMessage: (descriptor, values)=>formatMessage(descriptor, values, {
                    ignoreTag: true
                }),
            formatNumber: formatNumber,
            formatRelative: (date, opts)=>{
                const { time: time, unit: unit } = (0, $1IqwQ.getRelativeTimeAndUnit)(date);
                return formatRelativeTime(time, unit, opts);
            },
            formatPlural: formatPlural,
            formatTime: formatTime
        };
        return modifiedIntl;
    }, [
        formatDate,
        formatMessage,
        formatPlural,
        formatRelativeTime,
        formatTime,
        formatNumber,
        formats,
        locale,
        messages
    ]);
    return memoisedIntl;
};

});
parcelRegister("1IqwQ", function(module, exports) {

$parcel$export(module.exports, "getRelativeTimeAndUnit", () => $6a7dda3450af4d49$export$307c4b8ee56b97bb);
$parcel$export(module.exports, "FormattedRelativeV2", () => $6a7dda3450af4d49$export$7317ee2f88fd1276);

var $eUqFw = parcelRequire("eUqFw");

var $9KU0P = parcelRequire("9KU0P");

var $8M1qS = parcelRequire("8M1qS");
const $6a7dda3450af4d49$var$getTimeInUnits = (unitValue)=>{
    const seconds = unitValue / 1000;
    const minutes = seconds / 60;
    const hours = minutes / 60;
    const days = hours / 24;
    const weeks = days / 7;
    const months = weeks / 4;
    const years = months / 12;
    return {
        seconds: seconds,
        minutes: minutes,
        hours: hours,
        days: days,
        weeks: weeks,
        months: months,
        years: years
    };
};
const $6a7dda3450af4d49$export$307c4b8ee56b97bb = (value, units)=>{
    const timeInMilliseconds = new Date(value);
    // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
    const delta = timeInMilliseconds - Date.now();
    let valueInUnit;
    if (!units) {
        const { value: time, unit: unit } = (0, $9KU0P.selectUnit)(timeInMilliseconds, new Date());
        return {
            time: time,
            unit: unit
        };
    }
    const { seconds: seconds, minutes: minutes, hours: hours, days: days, weeks: weeks, months: months, years: years } = $6a7dda3450af4d49$var$getTimeInUnits(delta);
    switch(units){
        case 'second':
            valueInUnit = seconds;
            break;
        case 'minute':
            valueInUnit = minutes;
            break;
        case 'hour':
            valueInUnit = hours;
            break;
        case 'day':
            valueInUnit = days;
            break;
        case 'week':
            valueInUnit = weeks;
            break;
        case 'month':
            valueInUnit = months;
            break;
        case 'year':
            valueInUnit = years;
            break;
        default:
            valueInUnit = 0;
            break;
    }
    return {
        time: Math.ceil(valueInUnit),
        unit: units
    };
};
const $6a7dda3450af4d49$export$7317ee2f88fd1276 = ({ value: value, units: units, children: children, style: style, format: format, updateInterval: updateInterval })=>{
    const { time: time, unit: unit } = $6a7dda3450af4d49$export$307c4b8ee56b97bb(value, units);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8M1qS.default), {
        value: time,
        unit: unit,
        numeric: style === 'numeric' ? 'always' : 'auto',
        format: format,
        updateIntervalInSeconds: updateInterval
    }, children);
};
$6a7dda3450af4d49$export$7317ee2f88fd1276.displayName = 'FormattedRelative';

});


// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';

// values which are passed into the tracking callback by atlaskit
const $2f37035f7aaf1787$export$febebefae5a09065 = 'profile-card.loaded';
const $2f37035f7aaf1787$export$3ca1936ee743bd18 = 'profile-card.view';
const $2f37035f7aaf1787$export$25bd35f2cd9ae0ea = 'profile-card.reload';
const $2f37035f7aaf1787$export$86aa8b9c379ebbbd = 'profile-card.error';
const $2f37035f7aaf1787$export$4442e31da6ba4127 = 'profile-card.click';
const $2f37035f7aaf1787$export$7ecd9c56ca354ac0 = 'profileCardNext';
const $2f37035f7aaf1787$export$81319ffa9c0d18d7 = 'profileCardNext';
const $2f37035f7aaf1787$export$3145fc6c544ad7bf = 'profileCardNextLegacy';
const $2f37035f7aaf1787$export$50632e21ea714398 = 'profileCardNextLegacy';
const $2f37035f7aaf1787$export$d053e144c034c8aa = 'teamProfileCardNextLegacy';
const $2f37035f7aaf1787$export$2549357601611c61 = 'loadError';
const $2f37035f7aaf1787$export$23cedd3261bd8015 = 'viewProfile';
const $2f37035f7aaf1787$export$6bef782d14a92db8 = 'assignedIssues';
const $2f37035f7aaf1787$export$6b36f20db7a18a86 = 'reportedIssues';
const $2f37035f7aaf1787$export$56da0dd0b0aa67b9 = 'viewFilters';

parcelRegister("dIJJY", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fccd41ace13b158$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
parcelRequire("j2NCp");
var $1I4cW = parcelRequire("1I4cW");

var $1ybV0 = parcelRequire("1ybV0");

var $cCFSU = parcelRequire("cCFSU");
var $eo17r = parcelRequire("eo17r");

var $g8JvH = parcelRequire("g8JvH");

const $7fccd41ace13b158$var$PEOPLE_PROFILE_PATH = '/people/';
const $7fccd41ace13b158$var$ProfileCardTriggerWithAnalyticsNew = (0, $g8JvH.AnalyticsEventToProps)((0, $7543475b40b0a31d$export$a1455360a24a2234), {
    analytics: ''
})((0, $1I4cW.default));
// eslint-disable-next-line jira/react/no-class-components
class $7fccd41ace13b158$var$ProfileCardView extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            position: 'top-start',
            trigger: 'hover'
        };
    }
    render() {
        const { children: children, position: position, trigger: trigger, accountId: accountId, cloudId: cloudId, profileClient: profileClient, actions: actions, onProfileClick: onProfileClick, addFlag: addFlag, dismissFlag: dismissFlag, testId: testId, prepopulatedData: prepopulatedData } = this.props;
        const ProfileCardComponent = $7fccd41ace13b158$var$ProfileCardTriggerWithAnalyticsNew;
        return(// Stop the propagation of the click event when clicking on the profile card pop up,
        // to avoid closing the popup and opening the people picker when clicking the info inside.
        // Don't stop propagation when clicking the people picker directly.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fccd41ace13b158$var$Wrapper, {
            ref: this.profileCardWrapperRef,
            onClick: (event)=>{
                if (this.profileCardWrapperRef?.current !== null && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                !this.profileCardWrapperRef?.current?.contains(event.target)) event.stopPropagation();
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ProfileCardComponent, {
            cloudId: cloudId,
            userId: accountId,
            resourceClient: profileClient,
            position: position,
            trigger: trigger,
            testId: testId,
            actions: actions,
            reportingLinesProfileUrl: $7fccd41ace13b158$var$PEOPLE_PROFILE_PATH,
            prepopulatedData: prepopulatedData,
            onReportingLinesClick: // @ts-expect-error - TS7006 - Parameter 'user' implicitly has an 'any' type.
            onProfileClick ? (user)=>onProfileClick(user.accountIdentifier) : null,
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            addFlag: (flag)=>{
                const flagId = (0, $eo17r.toFlagId)(flag.id);
                addFlag({
                    id: flagId,
                    render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cCFSU.default), {
                            ...flag,
                            onDismissed: ()=>{
                                dismissFlag(flagId);
                            },
                            ...props
                        })
                });
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            "data-testid": "profilecard-next.ui.profilecard.profilecard-trigger"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children)))));
    }
    constructor(...args){
        super(...args);
        this.profileCardWrapperRef = /*#__PURE__*/ (0, $eUqFw.createRef)();
    }
}
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$7fccd41ace13b158$export$2e2bcd8739ae039 = $7fccd41ace13b158$var$ProfileCardView;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7fccd41ace13b158$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_ibjraq": (0, $9t7rW.default)((0, $1ybV0.ff)('nin-resizable-columns_8z4eo') && '100%')
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f4g5r _1l8r1osq",
            __cmplp.className
        ])
    });
});
$7fccd41ace13b158$var$Wrapper.displayName = 'Wrapper';

});
parcelRegister("j2NCp", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce5f762d9b5740e9$export$2e2bcd8739ae039);
$parcel$export(module.exports, "withOuterListeners", () => (parcelRequire("icLG8")).default);
$parcel$export(module.exports, "TeamProfileCard", () => (parcelRequire("g8DVf")).default);
$parcel$export(module.exports, "ProfileCardTrigger", () => (parcelRequire("1I4cW")).default);
$parcel$export(module.exports, "ProfileClient", () => (parcelRequire("lsiAJ")).default);
$parcel$export(module.exports, "UserProfileClient", () => (parcelRequire("b4hs7")).default);
$parcel$export(module.exports, "DELAY_MS_SHOW", () => $515c9dbc88c31cf4$export$5b956b542f1bc1b3);
// Avoid exporting new components in this file as they will affect the bundle size of all consumers
// importing directly from @atlaskit/profilecard.

var $lsiAJ = parcelRequire("lsiAJ");

var $kWhjG = parcelRequire("kWhjG");

var $b4hs7 = parcelRequire("b4hs7");

var $94Fw4 = parcelRequire("94Fw4");

var $ehM5E = parcelRequire("ehM5E");

var $6aOtB = parcelRequire("6aOtB");

var $1I4cW = parcelRequire("1I4cW");


var $icLG8 = parcelRequire("icLG8");

var $g8DVf = parcelRequire("g8DVf");
var $ce5f762d9b5740e9$export$2e2bcd8739ae039 = (0, $6aOtB.default);

});
parcelRegister("lsiAJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $84b7dde52ef02eed$export$2e2bcd8739ae039);

var $dfBCt = parcelRequire("dfBCt");

var $kmpkL = parcelRequire("kmpkL");

var $kWhjG = parcelRequire("kWhjG");

var $b4hs7 = parcelRequire("b4hs7");
class $84b7dde52ef02eed$var$ProfileCardClient {
    constructor(config, clients){
        this.userClient = clients?.userClient || new (0, $b4hs7.default)(config);
        this.teamClient = clients?.teamClient || new (0, $kWhjG.default)(config);
        this.tcClient = $84b7dde52ef02eed$var$maybeCreateTeamCentralClient(config, clients);
    }
    flushCache() {
        this.userClient.flushCache();
        this.teamClient.flushCache();
        this.tcClient?.flushCache();
    }
    getProfile(cloudId, userId, analytics) {
        return this.userClient.getProfile(cloudId, userId, analytics);
    }
    getTeamProfile(teamId, orgId, analytics) {
        return this.teamClient.getProfile(teamId, orgId, analytics);
    }
    getReportingLines(userId) {
        return this.tcClient?.getReportingLines(userId) || Promise.resolve({
            managers: [],
            reports: []
        });
    }
    getTeamCentralBaseUrl() {
        return this.tcClient?.options.teamCentralBaseUrl;
    }
    shouldShowGiveKudos() {
        if (!this.tcClient || !this.getTeamCentralBaseUrl()) return Promise.resolve(false);
        return this.tcClient.checkWorkspaceExists();
    }
}
function $84b7dde52ef02eed$var$maybeCreateTeamCentralClient(config, clients) {
    if ((0, $dfBCt.isFedRamp)()) return undefined;
    if (clients?.teamCentralClient) return clients.teamCentralClient;
    const teamCentralUrl = config.teamCentralUrl;
    return teamCentralUrl ? new (0, $kmpkL.default)({
        ...config,
        teamCentralUrl: teamCentralUrl
    }) : undefined;
}
var $84b7dde52ef02eed$export$2e2bcd8739ae039 = $84b7dde52ef02eed$var$ProfileCardClient;

});
parcelRegister("kmpkL", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab8fb2ad4171564c$export$2e2bcd8739ae039);

var $4eGN1 = parcelRequire("4eGN1");

var $6WG70 = parcelRequire("6WG70");
const $ab8fb2ad4171564c$export$1862ef0c3880ca8d = (aaid)=>({
        query: `
    fragment ReportingLinesUserPII on UserPII {
      name
      picture
    }

    fragment ReportingLinesUserFragment on ReportingLinesUser {
      accountIdentifier
      identifierType
      pii {
        ...ReportingLinesUserPII
      }
    }

    query ReportingLines($aaid: String) {
      reportingLines(aaidOrHash: $aaid) {
        managers {
          ...ReportingLinesUserFragment
        }
        reports {
          ...ReportingLinesUserFragment
        }
      }
    }
  `,
        variables: {
            aaid: aaid
        }
    });
const $ab8fb2ad4171564c$export$f8c05b360e45cd0 = (featureKey, context)=>({
        query: `
    query isFeatureKeyEnabled($featureKey: String!, $context: [IsFeatureEnabledContextInput]) {
      isFeatureEnabled(featureKey: $featureKey, context: $context) {
        enabled
      }
    }
  `,
        variables: {
            featureKey: featureKey,
            context: context || []
        }
    });
function $ab8fb2ad4171564c$var$hasTCWorkspace(config) {
    return config.cloudId ? fetch(`/gateway/api/watermelon/organization/containsAnyWorkspace?cloudId=${config.cloudId}`).then((res)=>{
        return !res || res && res.ok;
    }) : Promise.resolve(false);
}
let $ab8fb2ad4171564c$var$isTCReadyPromiseMap = new Map();
class $ab8fb2ad4171564c$var$TeamCentralCardClient extends (0, $4eGN1.default) {
    constructor(options){
        super(options);
        this.options = options;
        this.bypassOnFailure = false;
        this.featureFlagKeys = new Map();
        this.isTCReadyPromise = this.createTcReadyPromise(options);
    }
    createTcReadyPromise(config) {
        if (config.cloudId) {
            let promise = $ab8fb2ad4171564c$var$isTCReadyPromiseMap.get(config.cloudId);
            if (!promise) {
                promise = $ab8fb2ad4171564c$var$hasTCWorkspace(config);
                $ab8fb2ad4171564c$var$isTCReadyPromiseMap.set(config.cloudId, promise);
            }
            return promise;
        }
        return Promise.resolve(true);
    }
    async makeFeatureFlagCheckRequest(featureKey, context) {
        if (!this.options.teamCentralUrl) throw new Error('options.teamCentralUrl is a required parameter for retrieving Team Central data');
        const query = $ab8fb2ad4171564c$export$f8c05b360e45cd0(featureKey, context);
        const response = await (0, $6WG70.directoryGraphqlQuery)(`${this.options.teamCentralUrl}?operationName=isFeatureKeyEnabled`, query);
        return response.isFeatureEnabled.enabled;
    }
    async makeRequest(userId) {
        if (!this.options.teamCentralUrl) throw new Error('options.teamCentralUrl is a required parameter for retrieving Team Central data');
        const query = $ab8fb2ad4171564c$export$1862ef0c3880ca8d(userId);
        const response = await (0, $6WG70.directoryGraphqlQuery)(`${this.options.teamCentralUrl}?operationName=ReportingLines`, query);
        return response.reportingLines;
    }
    getReportingLines(userId) {
        return this.isTCReadyPromise.then((workSpaceExists)=>{
            if (workSpaceExists) {
                if (!userId) return Promise.reject(new Error('userId missing'));
                const cache = this.getCachedProfile(userId);
                if (cache) return Promise.resolve(cache);
                if (this.bypassOnFailure) return Promise.resolve({});
                return new Promise((resolve)=>{
                    this.makeRequest(userId).then((data)=>{
                        const enhancedData = {
                            managers: this.filterReportingLinesUser(data?.managers),
                            reports: this.filterReportingLinesUser(data?.reports)
                        };
                        if (this.cache) this.setCachedProfile(userId, enhancedData);
                        resolve(enhancedData);
                    }).catch((error)=>{
                        if (error?.status === 401 || error?.status === 403) // Trigger circuit breaker
                        this.bypassOnFailure = true;
                        /**
								 * Reporting lines aren't part of the critical path of profile card.
								 * Just resolve with empty values instead of bubbling up the error.
								 */ resolve({});
                    });
                });
            }
            return Promise.resolve({
                managers: [],
                reports: []
            });
        }, ()=>Promise.resolve({
                managers: [],
                reports: []
            }));
    }
    getFlagEnabled(featureKey, productIdentifier) {
        return this.isTCReadyPromise.then((workSpaceExists)=>{
            if (workSpaceExists) {
                if (!featureKey) return Promise.reject(new Error('featureKey missing'));
                if (this.featureFlagKeys.has(featureKey)) return Promise.resolve(this.featureFlagKeys.get(featureKey));
                if (this.bypassOnFailure) return Promise.resolve(false);
                const context = [
                    {
                        key: 'productIdentifier',
                        value: productIdentifier || 'unset'
                    }
                ];
                return new Promise((resolve)=>{
                    this.makeFeatureFlagCheckRequest(featureKey, context).then((enabled)=>{
                        this.featureFlagKeys.set(featureKey, enabled);
                        resolve(enabled);
                    }).catch((error)=>{
                        if (error?.status === 401 || error?.status === 403) // Trigger circuit breaker
                        this.bypassOnFailure = true;
                        resolve(false);
                    });
                });
            }
            return Promise.resolve(false);
        }, ()=>Promise.resolve(false));
    }
    checkWorkspaceExists() {
        return this.isTCReadyPromise.then((workSpaceExists)=>{
            if (workSpaceExists) return Promise.resolve(true);
            return Promise.resolve(false);
        }, ()=>Promise.resolve(false));
    }
    filterReportingLinesUser(users = []) {
        return users.filter((user)=>user.identifierType === 'ATLASSIAN_ID');
    }
}
var $ab8fb2ad4171564c$export$2e2bcd8739ae039 = $ab8fb2ad4171564c$var$TeamCentralCardClient;

});
parcelRegister("4eGN1", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c3adc3d48b40454$export$2e2bcd8739ae039);

var $6roQF = parcelRequire("6roQF");
class $7c3adc3d48b40454$export$2e2bcd8739ae039 {
    constructor(config){
        const defaults = {
            cacheSize: 10,
            cacheMaxAge: 0
        };
        this.config = {
            ...defaults,
            ...config
        };
        // never set cacheSize or cacheMaxAge to negative numbers
        this.config.cacheSize = Math.max(this.config.cacheSize || 0, 0);
        this.config.cacheMaxAge = Math.max(this.config.cacheMaxAge || 0, 0);
        // DIR-474: cap cache at 30 days.
        if (this.config.cacheMaxAge) this.config.cacheMaxAge = Math.min(this.config.cacheMaxAge, 2592000000);
        // Only set cache if maxCacheAge and cacheSize are set
        this.cache = !this.config.cacheMaxAge || !this.config.cacheSize ? null : new (0, $6roQF.LRUMap)(this.config.cacheSize);
    }
    setCachedProfile(cacheIdentifier, profile) {
        this.cache && this.cache.set(cacheIdentifier, {
            expire: Date.now() + this.config.cacheMaxAge,
            profile: profile
        });
    }
    getCachedProfile(cacheIdentifier) {
        if (!this.cache) return null;
        const cached = this.cache.get(cacheIdentifier);
        if (!cached) return null;
        if (cached.expire < Date.now()) {
            this.cache.delete(cacheIdentifier);
            return null;
        }
        // Extend expiry "date"
        this.setCachedProfile(cacheIdentifier, cached.profile);
        return cached.profile;
    }
    flushCache() {
        if (this.cache) this.cache.clear();
    }
}

});
parcelRegister("6roQF", function(module, exports) {
!function(g, c) {
    c(module.exports);
}(module.exports, function(g) {
    const c = Symbol("newer"), e = Symbol("older");
    class n {
        constructor(a, b){
            typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
        }
        _markEntryAsUsed(a) {
            if (a === this.newest) return;
            a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
        }
        assign(a) {
            let b, d = this.limit || Number.MAX_VALUE;
            this._keymap.clear();
            let m = a[Symbol.iterator]();
            for(let h = m.next(); !h.done; h = m.next()){
                let f = new l(h.value[0], h.value[1]);
                this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                if (d-- == 0) throw new Error("overflow");
            }
            this.newest = b, this.size = this._keymap.size;
        }
        get(a) {
            var b = this._keymap.get(a);
            return b ? (this._markEntryAsUsed(b), b.value) : void 0;
        }
        set(a, b) {
            var d = this._keymap.get(a);
            return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
        }
        shift() {
            var a = this.oldest;
            if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                a.key,
                a.value
            ];
        }
        find(a) {
            let b = this._keymap.get(a);
            return b ? b.value : void 0;
        }
        has(a) {
            return this._keymap.has(a);
        }
        delete(a) {
            var b = this._keymap.get(a);
            return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
        }
        clear() {
            this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
        }
        keys() {
            return new j(this.oldest);
        }
        values() {
            return new k(this.oldest);
        }
        entries() {
            return this;
        }
        [Symbol.iterator]() {
            return new i(this.oldest);
        }
        forEach(a, b) {
            typeof b !== "object" && (b = this);
            let d = this.oldest;
            for(; d;)a.call(b, d.value, d.key, this), d = d[c];
        }
        toJSON() {
            for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                key: d.key,
                value: d.value
            }, d = d[c];
            return a;
        }
        toString() {
            for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
            return a;
        }
    }
    g.LRUMap = n;
    function l(a, b) {
        this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
    }
    function i(a) {
        this.entry = a;
    }
    i.prototype[Symbol.iterator] = function() {
        return this;
    }, i.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: [
                a.key,
                a.value
            ]
        }) : {
            done: !0,
            value: void 0
        };
    };
    function j(a) {
        this.entry = a;
    }
    j.prototype[Symbol.iterator] = function() {
        return this;
    }, j.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.key
        }) : {
            done: !0,
            value: void 0
        };
    };
    function k(a) {
        this.entry = a;
    }
    k.prototype[Symbol.iterator] = function() {
        return this;
    }, k.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.value
        }) : {
            done: !0,
            value: void 0
        };
    };
});

});


parcelRegister("6WG70", function(module, exports) {

$parcel$export(module.exports, "directoryGraphqlQuery", () => $415b57eeeceb8e81$export$a5b5995619d4fe36);
$parcel$export(module.exports, "AGGQuery", () => $415b57eeeceb8e81$export$a14afb5f82fe705);

var $j4C9S = parcelRequire("j4C9S");

var $bl3OJ = parcelRequire("bl3OJ");
const $415b57eeeceb8e81$var$buildHeaders = ()=>{
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return headers;
};
const $415b57eeeceb8e81$var$id = (headers)=>headers;
async function $415b57eeeceb8e81$export$a5b5995619d4fe36(serviceUrl, query, processHeaders = $415b57eeeceb8e81$var$id) {
    return $415b57eeeceb8e81$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $bl3OJ.handleDirectoryGraphQLErrors));
}
async function $415b57eeeceb8e81$export$a14afb5f82fe705(serviceUrl, query, processHeaders = $415b57eeeceb8e81$var$id) {
    return $415b57eeeceb8e81$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $bl3OJ.handleAGGErrors));
}
async function $415b57eeeceb8e81$var$graphQLQuery(serviceUrl, query, processHeaders = $415b57eeeceb8e81$var$id, handleErrors) {
    const headers = processHeaders($415b57eeeceb8e81$var$buildHeaders());
    const response = await fetch(new Request(serviceUrl, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: headers,
        body: JSON.stringify(query)
    }));
    const traceIdFromHeaders = response?.headers?.get('atl-traceid');
    if (!response.ok) throw new (0, $j4C9S.HttpError)(response.status, response.statusText, traceIdFromHeaders);
    const json = await response.json();
    if (json.errors) handleErrors(json.errors, json.extensions?.gateway?.request_id ?? traceIdFromHeaders);
    return json.data;
}

});
parcelRegister("j4C9S", function(module, exports) {

$parcel$export(module.exports, "HttpError", () => $343a8316fe4e3587$export$65bd6083489bd8bb);
$parcel$export(module.exports, "DirectoryGraphQLError", () => $343a8316fe4e3587$export$c1e4d0de940c06a2);
$parcel$export(module.exports, "DirectoryGraphQLErrors", () => $343a8316fe4e3587$export$5a5fbfed34a590a1);
$parcel$export(module.exports, "AGGError", () => $343a8316fe4e3587$export$4a696f048dcc929);
$parcel$export(module.exports, "AGGErrors", () => $343a8316fe4e3587$export$60d8267243755b9c);
class $343a8316fe4e3587$export$65bd6083489bd8bb extends Error {
    constructor(code, reason, traceId){
        super(reason);
        this.code = code;
        this.traceId = traceId;
    }
}
class $343a8316fe4e3587$export$c1e4d0de940c06a2 extends Error {
    constructor(message, category, type, extensions = {}, path = []){
        super(message);
        this.category = category;
        this.type = type;
        this.path = path.join('.');
        const { errorNumber: errorNumber, ...unknownExtension } = extensions;
        this.errorNumber = extensions.errorNumber;
        this.extensions = unknownExtension;
    }
}
class $343a8316fe4e3587$export$5a5fbfed34a590a1 extends Error {
    constructor(errors, traceId){
        super('DirectoryGraphQLErrors');
        this.traceId = traceId;
        if (Array.isArray(errors)) this.errors = errors.map((error)=>new $343a8316fe4e3587$export$c1e4d0de940c06a2(error.message, error.category, error.type, error.extensions, error.path));
        else this.errors = [];
    }
}
class $343a8316fe4e3587$export$4a696f048dcc929 extends Error {
    constructor(message, extensions, path = []){
        super(message);
        this.path = path?.join('.');
        const { statusCode: statusCode, errorType: errorType, classification: classification, ...unknownExtension } = extensions;
        this.statusCode = statusCode;
        this.errorType = errorType;
        this.classification = classification;
        this.extensions = unknownExtension;
    }
}
class $343a8316fe4e3587$export$60d8267243755b9c extends Error {
    constructor(errors, traceId){
        super('AGGErrors');
        this.traceId = traceId;
        if (Array.isArray(errors)) this.errors = errors.map((error)=>new $343a8316fe4e3587$export$4a696f048dcc929(error.message, error.extensions, error.path));
        else this.errors = [];
    }
}

});

parcelRegister("bl3OJ", function(module, exports) {

$parcel$export(module.exports, "getErrorAttributes", () => $d2cc0f3532818141$export$6ad9e7706a4ee0f8);
$parcel$export(module.exports, "handleDirectoryGraphQLErrors", () => $d2cc0f3532818141$export$7642af465ceb7f05);
$parcel$export(module.exports, "handleAGGErrors", () => $d2cc0f3532818141$export$d9ad65d422ee3f8c);

var $j4C9S = parcelRequire("j4C9S");
const $d2cc0f3532818141$var$IGNORED_ERROR_REASONS_DIRECTORY = [
    // Error categories from pf-directory
    'NotPermitted',
    'Gone',
    'IdentityUserNotFoundError'
];
const $d2cc0f3532818141$var$IGNORE_ERROR_TYPES_AGG = [
    'IdentityUserNotFoundError',
    'TEAMS_FORBIDDEN',
    'TEAMS_TEAM_DELETED'
];
const $d2cc0f3532818141$var$IGNORE_ERROR_CLASSIFICATIONS_AGG = [
    'Gone'
];
function $d2cc0f3532818141$var$isIgnoredError(error) {
    if (!error) return false;
    if (error instanceof (0, $j4C9S.DirectoryGraphQLError)) return !!error && $d2cc0f3532818141$var$IGNORED_ERROR_REASONS_DIRECTORY.includes(error.type);
    else if (error instanceof (0, $j4C9S.AGGError)) return !!error.errorType && $d2cc0f3532818141$var$IGNORE_ERROR_TYPES_AGG.includes(error.errorType) || !!error.classification && $d2cc0f3532818141$var$IGNORE_ERROR_CLASSIFICATIONS_AGG.includes(error.classification);
    return false;
}
const $d2cc0f3532818141$export$6ad9e7706a4ee0f8 = (error)=>{
    if (error instanceof (0, $j4C9S.DirectoryGraphQLErrors)) return {
        errorMessage: error.message,
        errorCount: error.errors.length,
        errorDetails: error.errors.map($d2cc0f3532818141$export$6ad9e7706a4ee0f8),
        isSLOFailure: !error.errors.every($d2cc0f3532818141$var$isIgnoredError),
        traceId: error.traceId
    };
    else if (error instanceof (0, $j4C9S.DirectoryGraphQLError)) return {
        errorMessage: error.message,
        errorCategory: error.category,
        errorType: error.type,
        errorPath: error.path,
        errorNumber: error.errorNumber,
        isSLOFailure: !$d2cc0f3532818141$var$isIgnoredError(error)
    };
    else if (error instanceof (0, $j4C9S.AGGErrors)) return {
        errorMessage: error.message,
        errorCount: error.errors.length,
        errorDetails: error.errors.map($d2cc0f3532818141$export$6ad9e7706a4ee0f8),
        isSLOFailure: !error.errors.every($d2cc0f3532818141$var$isIgnoredError),
        traceId: error.traceId
    };
    else if (error instanceof (0, $j4C9S.AGGError)) return {
        errorMessage: error.message,
        errorType: error.errorType,
        errorStatusCode: error.statusCode,
        isSLOFailure: !$d2cc0f3532818141$var$isIgnoredError(error),
        errorCategory: error.classification
    };
    else if (error instanceof Error) {
        // Jira custom profile card client error, they wrap the error & put the underlying error in the cause property
        if (error.message.startsWith('Unable to fetch user:')) {
            if (error.hasOwnProperty('cause')) {
                const causeError = error.cause;
                if (causeError instanceof (0, $j4C9S.DirectoryGraphQLErrors) || causeError instanceof (0, $j4C9S.AGGErrors)) return $d2cc0f3532818141$export$6ad9e7706a4ee0f8(causeError);
            }
            return {
                errorMessage: error.message,
                isSLOFailure: false
            };
        }
        return {
            errorMessage: error.message,
            isSLOFailure: true
        };
    }
    // Unknown
    return {
        errorMessage: 'Unknown error',
        isSLOFailure: true
    };
};
const $d2cc0f3532818141$export$7642af465ceb7f05 = (errors, traceId)=>{
    throw new (0, $j4C9S.DirectoryGraphQLErrors)(errors, traceId);
};
const $d2cc0f3532818141$export$d9ad65d422ee3f8c = (errors, traceId)=>{
    throw new (0, $j4C9S.AGGErrors)(errors, traceId);
};

});



parcelRegister("kWhjG", function(module, exports) {

$parcel$export(module.exports, "default", () => $26e65ba6df7e3eef$export$2e2bcd8739ae039);

var $3vXh8 = parcelRequire("3vXh8");

var $cEOpo = parcelRequire("cEOpo");

var $4eGN1 = parcelRequire("4eGN1");

var $bl3OJ = parcelRequire("bl3OJ");

var $k39sp = parcelRequire("k39sp");
class $26e65ba6df7e3eef$export$2e2bcd8739ae039 extends (0, $4eGN1.default) {
    constructor(options){
        super(options);
        this.options = options;
    }
    makeRequest(teamId, _orgId) {
        if (!this.options.gatewayGraphqlUrl) throw new Error('Trying to fetch via gateway with no specified config.gatewayGraphqlUrl');
        return (0, $k39sp.getTeamFromAGG)(this.options.gatewayGraphqlUrl, teamId, this.options.cloudId);
    }
    getProfile(teamId, orgId, analytics) {
        if (!teamId) return Promise.reject(new Error('teamId is missing'));
        const cache = this.getCachedProfile(teamId);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $cEOpo.getPageTime)();
            if (analytics) analytics((0, $3vXh8.teamRequestAnalytics)('triggered'));
            this.makeRequest(teamId, orgId).then((data)=>{
                if (this.cache) this.setCachedProfile(teamId, data);
                if (analytics) analytics((0, $3vXh8.teamRequestAnalytics)('succeeded', {
                    duration: (0, $cEOpo.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics((0, $3vXh8.teamRequestAnalytics)('failed', {
                    duration: (0, $cEOpo.getPageTime)() - startTime,
                    ...(0, $bl3OJ.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
}

});
parcelRegister("3vXh8", function(module, exports) {

$parcel$export(module.exports, "fireEvent", () => $3825798267526520$export$43835e9acf248a15);
$parcel$export(module.exports, "cardTriggered", () => $3825798267526520$export$d50ab8a3b6975c);
$parcel$export(module.exports, "teamRequestAnalytics", () => $3825798267526520$export$c9b0e37b229a297b);
$parcel$export(module.exports, "userRequestAnalytics", () => $3825798267526520$export$12dae48763368ac9);
$parcel$export(module.exports, "profileCardRendered", () => $3825798267526520$export$41816a317479160b);
$parcel$export(module.exports, "actionClicked", () => $3825798267526520$export$fdcd134fbeb1f921);
$parcel$export(module.exports, "reportingLinesClicked", () => $3825798267526520$export$93260987012593be);
$parcel$export(module.exports, "moreActionsClicked", () => $3825798267526520$export$79befd155063a6a7);
$parcel$export(module.exports, "teamAvatarClicked", () => $3825798267526520$export$2703289b35687fde);
$parcel$export(module.exports, "moreMembersClicked", () => $3825798267526520$export$b4411a7661cf2d3f);
$parcel$export(module.exports, "errorRetryClicked", () => $3825798267526520$export$c86679da702d560e);

var $cEOpo = parcelRequire("cEOpo");
/** Below lines are copied from teams common analytics */ const $3825798267526520$var$ANALYTICS_CHANNEL = 'peopleTeams';
const $3825798267526520$var$runItLater = (cb)=>{
    const requestIdleCallback = window.requestIdleCallback;
    if (typeof requestIdleCallback === 'function') return requestIdleCallback(cb);
    if (typeof window.requestAnimationFrame === 'function') return window.requestAnimationFrame(cb);
    return ()=>setTimeout(cb);
};
const $3825798267526520$export$43835e9acf248a15 = (createAnalyticsEvent, body)=>{
    if (!createAnalyticsEvent) return;
    $3825798267526520$var$runItLater(()=>{
        createAnalyticsEvent(body).fire($3825798267526520$var$ANALYTICS_CHANNEL);
    });
};
/** Above lines are copied from teams common analytics */ const $3825798267526520$var$TEAM_SUBJECT = 'teamProfileCard';
const $3825798267526520$var$USER_SUBJECT = 'profilecard';
const $3825798267526520$var$createEvent = (eventType, action, actionSubject, actionSubjectId, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: {
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local",
            ...attributes,
            firedAt: Math.round((0, $cEOpo.getPageTime)())
        }
    });
const $3825798267526520$export$d50ab8a3b6975c = (type, method)=>$3825798267526520$var$createEvent('ui', 'triggered', type === 'user' ? $3825798267526520$var$USER_SUBJECT : $3825798267526520$var$TEAM_SUBJECT, undefined, {
        method: method
    });
const $3825798267526520$export$c9b0e37b229a297b = (action, attributes)=>$3825798267526520$var$createEvent('operational', action, $3825798267526520$var$TEAM_SUBJECT, 'request', attributes);
const $3825798267526520$export$12dae48763368ac9 = (action, attributes)=>$3825798267526520$var$createEvent('operational', action, $3825798267526520$var$USER_SUBJECT, 'request', attributes);
const $3825798267526520$export$41816a317479160b = (type, actionSubjectId, attributes)=>$3825798267526520$var$createEvent('ui', 'rendered', type === 'user' ? $3825798267526520$var$USER_SUBJECT : $3825798267526520$var$TEAM_SUBJECT, actionSubjectId, attributes);
const $3825798267526520$export$fdcd134fbeb1f921 = (type, attributes)=>$3825798267526520$var$createEvent('ui', 'clicked', type === 'user' ? $3825798267526520$var$USER_SUBJECT : $3825798267526520$var$TEAM_SUBJECT, 'action', attributes);
const $3825798267526520$export$93260987012593be = (attributes)=>$3825798267526520$var$createEvent('ui', 'clicked', $3825798267526520$var$USER_SUBJECT, 'reportingLines', attributes);
const $3825798267526520$export$79befd155063a6a7 = (type, attributes)=>$3825798267526520$var$createEvent('ui', 'clicked', type === 'user' ? $3825798267526520$var$USER_SUBJECT : $3825798267526520$var$TEAM_SUBJECT, 'moreActions', attributes);
const $3825798267526520$export$2703289b35687fde = (attributes)=>$3825798267526520$var$createEvent('ui', 'clicked', $3825798267526520$var$TEAM_SUBJECT, 'avatar', attributes);
const $3825798267526520$export$b4411a7661cf2d3f = (attributes)=>$3825798267526520$var$createEvent('ui', 'clicked', $3825798267526520$var$TEAM_SUBJECT, 'moreMembers', attributes);
const $3825798267526520$export$c86679da702d560e = (attributes)=>$3825798267526520$var$createEvent('ui', 'clicked', $3825798267526520$var$TEAM_SUBJECT, 'errorRetry', attributes);

});
parcelRegister("cEOpo", function(module, exports) {

$parcel$export(module.exports, "getPageTime", () => $77671953c6d01f45$export$e9faea7c41053334);
const $77671953c6d01f45$var$isPerformanceAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && !!performance.now;
};
const $77671953c6d01f45$var$performanceAvailable = $77671953c6d01f45$var$isPerformanceAvailable();
const $77671953c6d01f45$var$initialPageTime = Date.now();
const $77671953c6d01f45$export$e9faea7c41053334 = ()=>{
    if ($77671953c6d01f45$var$performanceAvailable) return performance.now();
    return Date.now() - $77671953c6d01f45$var$initialPageTime;
};

});


parcelRegister("k39sp", function(module, exports) {

$parcel$export(module.exports, "getTeamFromAGG", () => $b92dd34bfd4aec4a$export$26a8aad0c7182dd6);

var $6WG70 = parcelRequire("6WG70");
const $b92dd34bfd4aec4a$export$5816a09dbb711691 = (ari)=>{
    const slashPos = ari.indexOf('/');
    const id = ari.slice(slashPos + 1);
    return id;
};
const $b92dd34bfd4aec4a$export$681597d03c8a0fd2 = (teamId)=>{
    return `ari:cloud:identity::team/${teamId}`;
};
const $b92dd34bfd4aec4a$export$fce1abb40bf8db94 = (result)=>{
    const { team: team } = result;
    return {
        ...team,
        id: $b92dd34bfd4aec4a$export$5816a09dbb711691(team.id),
        members: team.members?.nodes.map(({ member: member })=>({
                id: member.accountId,
                fullName: member.name,
                avatarUrl: member.picture
            }))
    };
};
// indented so it's
const $b92dd34bfd4aec4a$var$TEAM_FRAGMENT = `
      id
      displayName
      description
      smallHeaderImageUrl
      largeHeaderImageUrl
      smallAvatarImageUrl
      largeAvatarImageUrl
      members {
        nodes {
          member {
            accountId
            name
            picture
          }
        }
      }
`;
const $b92dd34bfd4aec4a$export$4968f4e0119a5d9c = `query TeamCard($teamId: ID!, $siteId: String!) {
  Team: team {
    team: teamV2(id: $teamId, siteId: $siteId) @optIn(to: "Team-v2") {
      ${$b92dd34bfd4aec4a$var$TEAM_FRAGMENT}
    }
  }
}`;
const $b92dd34bfd4aec4a$export$695d743d1401e038 = ({ teamId: teamId, siteId: siteId })=>({
        query: $b92dd34bfd4aec4a$export$4968f4e0119a5d9c,
        variables: {
            teamId: $b92dd34bfd4aec4a$export$681597d03c8a0fd2(teamId),
            siteId: siteId || 'None'
        }
    });
const $b92dd34bfd4aec4a$export$1229c72526c01df2 = (headers)=>{
    headers.append('X-ExperimentalApi', 'teams-beta');
    headers.append('X-ExperimentalApi', 'team-members-beta');
    headers.append('atl-client-name', "platform-pkg");
    headers.append('atl-client-version', "0.0.0-use.local");
    return headers;
};
async function $b92dd34bfd4aec4a$export$26a8aad0c7182dd6(url, teamId, siteId) {
    const query = $b92dd34bfd4aec4a$export$695d743d1401e038({
        teamId: teamId,
        siteId: siteId
    });
    const { Team: Team } = await (0, $6WG70.AGGQuery)(url, query, $b92dd34bfd4aec4a$export$1229c72526c01df2);
    return $b92dd34bfd4aec4a$export$fce1abb40bf8db94(Team);
}

});


parcelRegister("b4hs7", function(module, exports) {

$parcel$export(module.exports, "default", () => $80b3ff2ca38ed950$export$2e2bcd8739ae039);

var $3vXh8 = parcelRequire("3vXh8");

var $cEOpo = parcelRequire("cEOpo");

var $4eGN1 = parcelRequire("4eGN1");

var $bl3OJ = parcelRequire("bl3OJ");

var $6WG70 = parcelRequire("6WG70");
const $80b3ff2ca38ed950$export$b26b7f9bcf400835 = (response)=>{
    const data = {
        ...response.User
    };
    const localWeekdayIndex = new Date().getDay().toString();
    if (data.remoteWeekdayIndex && data.remoteWeekdayIndex !== localWeekdayIndex) data.remoteTimeString = `${data.remoteWeekdayString} ${data.remoteTimeString}`;
    return {
        isBot: data.isBot,
        isCurrentUser: data.isCurrentUser,
        status: data.status,
        statusModifiedDate: data.statusModifiedDate || undefined,
        avatarUrl: data.avatarUrl || undefined,
        email: data.email || undefined,
        fullName: data.fullName || undefined,
        location: data.location || undefined,
        meta: data.meta || undefined,
        nickname: data.nickname || undefined,
        companyName: data.companyName || undefined,
        timestring: data.remoteTimeString || undefined,
        accountType: data.accountType || undefined
    };
};
const $80b3ff2ca38ed950$export$bfbf383663068c37 = (cloudId, userId)=>({
        query: `query User($userId: String!, $cloudId: String!) {
    User: CloudUser(userId: $userId, cloudId: $cloudId) {
      id
      isCurrentUser
      status
      statusModifiedDate
      isBot
      isNotMentionable
      fullName
      nickname
      email
      meta: title
      location
      companyName
      avatarUrl(size: 192)
      remoteWeekdayIndex: localTime(format: "d")
      remoteWeekdayString: localTime(format: "ddd")
      remoteTimeString: localTime(format: "h:mma")
    }
  }`,
        variables: {
            cloudId: cloudId,
            userId: userId
        }
    });
class $80b3ff2ca38ed950$export$2e2bcd8739ae039 extends (0, $4eGN1.default) {
    constructor(options){
        super(options);
        this.options = options;
    }
    async makeRequest(cloudId, userId) {
        if (!this.options.url) throw new Error('options.url is a required parameter');
        const query = $80b3ff2ca38ed950$export$bfbf383663068c37(cloudId, userId);
        const response = await (0, $6WG70.directoryGraphqlQuery)(this.options.url, query);
        return $80b3ff2ca38ed950$export$b26b7f9bcf400835(response);
    }
    getProfile(cloudId, userId, analytics) {
        if (!userId) return Promise.reject(new Error('userId missing'));
        const cacheIdentifier = `${cloudId}/${userId}`;
        const cache = this.getCachedProfile(cacheIdentifier);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $cEOpo.getPageTime)();
            if (analytics) analytics((0, $3vXh8.userRequestAnalytics)('triggered'));
            this.makeRequest(cloudId, userId).then((data)=>{
                if (this.cache) this.setCachedProfile(cacheIdentifier, data);
                if (analytics) analytics((0, $3vXh8.userRequestAnalytics)('succeeded', {
                    duration: (0, $cEOpo.getPageTime)() - startTime
                }));
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics((0, $3vXh8.userRequestAnalytics)('failed', {
                    duration: (0, $cEOpo.getPageTime)() - startTime,
                    ...(0, $bl3OJ.getErrorAttributes)(error)
                }));
                reject(error);
            });
        });
    }
}

});


parcelRegister("94Fw4", function(module, exports) {

$parcel$export(module.exports, "default", () => $b80709e37e35f48e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $2jDha = parcelRequire("2jDha");

var $dx7Op = parcelRequire("dx7Op");
var $btCBO = parcelRequire("btCBO");

var $XHGTv = parcelRequire("XHGTv");

var $3MV1G = parcelRequire("3MV1G");

var $lcnyw = parcelRequire("lcnyw");

var $5Jx7I = parcelRequire("5Jx7I");

var $aCbpp = parcelRequire("aCbpp");

var $3vXh8 = parcelRequire("3vXh8");

var $7NIUg = parcelRequire("7NIUg");


var $cEOpo = parcelRequire("cEOpo");
parcelRequire("iINHb");
var $9Pgj1 = parcelRequire("9Pgj1");

var $j7pJq = parcelRequire("j7pJq");

var $dO06T = parcelRequire("dO06T");
class $b80709e37e35f48e$export$f811dc569217c959 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    static{
        this.defaultProps = {
            actions: [],
            trigger: 'hover',
            position: 'bottom-start',
            triggerLinkType: 'link'
        };
    }
    componentDidMount() {
        this._isMounted = true;
    }
    componentDidUpdate(prevProps) {
        const { orgId: orgId, teamId: teamId, resourceClient: resourceClient } = this.props;
        const { visible: visible } = this.state;
        // just re-fetching data when the card opens
        if (visible && (teamId !== prevProps.teamId || orgId !== prevProps.orgId || resourceClient !== prevProps.resourceClient)) this.setState({
            isLoading: undefined
        }, this.clientFetchProfile);
    }
    componentWillUnmount() {
        this._isMounted = false;
        clearTimeout(this.showTimer);
        clearTimeout(this.hideTimer);
    }
    handleClientSuccess(team, shouldShowGiveKudos) {
        if (!this._isMounted) return;
        this.setState({
            isLoading: false,
            hasError: false,
            data: team,
            shouldShowGiveKudos: shouldShowGiveKudos,
            teamCentralBaseUrl: this.props.resourceClient.getTeamCentralBaseUrl()
        });
    }
    handleClientError(err) {
        if (!this._isMounted) return;
        this.setState({
            isLoading: false,
            hasError: true,
            error: err
        });
    }
    filterActions() {
        const actions = (0, $5Jx7I.default)(this.props.actions, this.state.data);
        if (this.state.shouldShowGiveKudos) {
            const kudosAction = {
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $aCbpp.default).giveKudosButton),
                id: 'give-kudos',
                callback: ()=>{
                    this.openKudosDrawer();
                },
                link: this.kudosUrl()
            };
            return actions.concat([
                kudosAction
            ]);
        }
        return actions;
    }
    renderPopup() {
        if (this.state.renderError) return this.props.children;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Pgj1.ErrorBoundary), {
            onError: this.onErrorBoundary
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
            isOpen: !!this.state.visible,
            onClose: this.onClose,
            placement: this.props.position,
            content: this.renderProfileCard,
            trigger: (triggerProps)=>this.renderTrigger(triggerProps),
            zIndex: (0, $lcnyw.layers).modal(),
            shouldFlip: true,
            autoFocus: this.props.trigger !== 'hover' && !this.openedByHover,
            shouldRenderToParent: (0, $XHGTv.fg)('enable_appropriate_reading_order_in_profile_card')
        }));
    }
    render() {
        if (this.props.children) return this.renderPopup();
        else throw new Error('Component "TeamProfileCardTrigger" must have "children" property');
    }
    constructor(...args){
        super(...args);
        this._isMounted = false;
        this.showTimer = 0;
        this.hideTimer = 0;
        this.openedByHover = false;
        this.openTime = 0;
        this.fireAnalytics = (payload)=>{
            // Don't fire any analytics if the component is unmounted
            if (!this._isMounted) return;
            if (this.props.createAnalyticsEvent) (0, $3vXh8.fireEvent)(this.props.createAnalyticsEvent, payload);
        };
        this.fireAnalyticsWithDuration = (generator)=>{
            const event = generator((0, $cEOpo.getPageTime)() - this.openTime);
            this.fireAnalytics(event);
        };
        this.hideProfilecard = (delay = 0)=>{
            clearTimeout(this.showTimer);
            clearTimeout(this.hideTimer);
            this.hideTimer = window.setTimeout(()=>{
                this.setState({
                    visible: false
                });
            }, delay);
        };
        this.showProfilecard = (delay = 0)=>{
            clearTimeout(this.hideTimer);
            clearTimeout(this.showTimer);
            this.showTimer = window.setTimeout(()=>{
                if (!this.state.visible) {
                    this.clientFetchProfile();
                    this.openTime = (0, $cEOpo.getPageTime)();
                    this.setState({
                        visible: true
                    });
                }
            }, delay);
        };
        this.onClick = (event)=>{
            if (this.props.triggerLinkType === 'link') // We want to prevent navigation occurring on basic click, but it's important that
            // cmd+click, ctrl+click, etc. still work as expected.
            {
                if ((0, $7NIUg.isBasicClick)(event)) event.preventDefault();
            }
            if (this.props.triggerLinkType === 'clickable-link') {
                if (this.props.viewProfileOnClick) this.props.viewProfileOnClick(event);
            }
            if (this.props.trigger !== 'hover') {
                this.openedByHover = false;
                this.showProfilecard(0);
                if (!this.state.visible) this.fireAnalytics((0, $3vXh8.cardTriggered)('team', 'click'));
            }
        };
        this.onMouseEnter = ()=>{
            if (this.props.trigger === 'click') return;
            if (!this.state.visible) {
                this.openedByHover = true;
                this.fireAnalytics((0, $3vXh8.cardTriggered)('team', 'hover'));
            }
            this.showProfilecard((0, $515c9dbc88c31cf4$export$5b956b542f1bc1b3));
        };
        this.onMouseLeave = ()=>{
            if (this.props.trigger === 'click') return;
            if (this.openedByHover) this.hideProfilecard((0, $515c9dbc88c31cf4$export$89a9f35a94d7f196));
        };
        this.onClose = ()=>{
            this.hideProfilecard();
        };
        this.openKudosDrawer = ()=>{
            this.hideProfilecard((0, $515c9dbc88c31cf4$export$89a9f35a94d7f196));
            this.setState({
                kudosDrawerOpen: true
            });
        };
        this.closeKudosDrawer = ()=>{
            this.setState({
                kudosDrawerOpen: false
            });
        };
        this.kudosUrl = ()=>{
            const recipientId = this.props.teamId && `&recipientId=${this.props.teamId}` || '';
            const cloudId = this.props.cloudId && `&cloudId=${this.props.cloudId}` || '';
            return `${this.state.teamCentralBaseUrl}/kudos/give?type=team${recipientId}${cloudId}`;
        };
        this.stopPropagation = (event)=>{
            // We need to stop propagation when users click on the card, so that it
            // doesn't trigger any special effects that occur when clicking the trigger.
            event.stopPropagation();
        };
        this.triggerListeners = {
            onClick: this.onClick,
            onMouseEnter: this.onMouseEnter,
            onMouseLeave: this.onMouseLeave
        };
        this.cardListeners = {
            onClick: this.stopPropagation,
            onMouseEnter: this.onMouseEnter,
            onMouseLeave: this.onMouseLeave
        };
        this.state = {
            visible: false,
            isLoading: undefined,
            hasError: false,
            error: null,
            data: null,
            shouldShowGiveKudos: false,
            teamCentralBaseUrl: undefined,
            kudosDrawerOpen: false
        };
        this.clientFetchProfile = ()=>{
            const { orgId: orgId, teamId: teamId } = this.props;
            const { isLoading: isLoading } = this.state;
            if (isLoading === true) // don't fetch data when fetching is in process
            return;
            this.setState({
                isLoading: true,
                data: null
            }, ()=>{
                const fireEvent = (event)=>{
                    this.fireAnalytics(event);
                };
                const requests = Promise.all([
                    this.props.resourceClient.getTeamProfile(teamId, orgId, fireEvent),
                    this.props.resourceClient.shouldShowGiveKudos()
                ]);
                requests.then((res)=>this.handleClientSuccess(...res), (err)=>this.handleClientError(err)).catch((err)=>this.handleClientError(err));
            });
        };
        this.onErrorBoundary = ()=>{
            this.fireAnalytics((0, $3vXh8.profileCardRendered)('team', 'errorBoundary', {
                duration: 0
            }));
            this.setState({
                renderError: true
            });
        };
        this.renderProfileCard = ()=>{
            const { generateUserLink: generateUserLink, onUserClick: onUserClick, viewingUserId: viewingUserId, viewProfileLink: viewProfileLink, viewProfileOnClick: viewProfileOnClick } = this.props;
            const { data: data, error: error, hasError: hasError, isLoading: isLoading } = this.state;
            const newProps = {
                clientFetchProfile: this.clientFetchProfile,
                actions: this.filterActions(),
                analytics: this.fireAnalyticsWithDuration,
                team: data || undefined,
                generateUserLink: generateUserLink,
                onUserClick: onUserClick,
                viewingUserId: viewingUserId,
                viewProfileLink: viewProfileLink,
                viewProfileOnClick: viewProfileOnClick
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", this.cardListeners, this.state.visible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dO06T.default), {
                    analytics: this.fireAnalyticsWithDuration
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j7pJq.TeamProfileCardLazy), {
                ...newProps,
                isLoading: isLoading,
                hasError: hasError,
                errorType: error
            })));
        };
        this.renderKudosLauncher = ()=>{
            return this.state.shouldShowGiveKudos && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
                fallback: null
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dx7Op.GiveKudosLauncherLazy), {
                isOpen: this.state.kudosDrawerOpen,
                recipient: {
                    type: (0, $btCBO.KudosType).TEAM,
                    recipientId: this.props.teamId
                },
                analyticsSource: "team-profile-card",
                teamCentralBaseUrl: this.state.teamCentralBaseUrl,
                cloudId: this.props.cloudId || '',
                addFlag: this.props.addFlag,
                onClose: this.closeKudosDrawer
            }));
        };
        this.renderTrigger = (triggerProps)=>{
            const { children: children, triggerLinkType: triggerLinkType, viewProfileLink: viewProfileLink } = this.props;
            if (triggerLinkType === 'none') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, this.renderKudosLauncher(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                "data-testid": "team-profilecard-trigger-wrapper",
                ...triggerProps,
                ...this.triggerListeners
            }, children));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, this.renderKudosLauncher(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                "data-testid": "team-profilecard-trigger-wrapper",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: {
                    color: 'initial',
                    textDecoration: 'none'
                },
                href: viewProfileLink,
                ...triggerProps,
                ref: triggerProps.ref,
                ...this.triggerListeners
            }, children));
        };
    }
}
var $b80709e37e35f48e$export$2e2bcd8739ae039 = (0, $2jDha.default)()($b80709e37e35f48e$export$f811dc569217c959);

});
parcelRegister("dx7Op", function(module, exports) {

$parcel$export(module.exports, "GiveKudosLauncherLazy", () => $1be4d1ec21b65937$export$93fe397a02fe8b76);

var $eUqFw = parcelRequire("eUqFw");

const $1be4d1ec21b65937$export$93fe397a02fe8b76 = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("1DAEB")));

});
parcelRegister("1DAEB", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('dSAyy')
        ]);
        const value = parcelRequire('5A0d0');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("dSAyy")
    ]).then(()=>parcelRequire('5A0d0'));
}

});


parcelRegister("btCBO", function(module, exports) {

$parcel$export(module.exports, "KudosType", () => $5cf31a8d69eb9e81$export$4fa2020056771264);
$parcel$export(module.exports, "FlagEventType", () => $5cf31a8d69eb9e81$export$d21f9befaa2961a);
$parcel$export(module.exports, "isFlagEventTypeValue", () => $5cf31a8d69eb9e81$export$7a1fc1a1b0477464);
var $5cf31a8d69eb9e81$export$4fa2020056771264;
(function(KudosType) {
    KudosType["INDIVIDUAL"] = "individual";
    KudosType["TEAM"] = "team";
})($5cf31a8d69eb9e81$export$4fa2020056771264 || ($5cf31a8d69eb9e81$export$4fa2020056771264 = {}));
var $5cf31a8d69eb9e81$export$d21f9befaa2961a;
(function(FlagEventType) {
    FlagEventType["KUDOS_CREATED"] = "kudos-created";
    FlagEventType["JIRA_KUDOS_CREATED"] = "jira-kudos-created";
    FlagEventType["JIRA_KUDOS_FAILED"] = "jira-kudos-failed";
    FlagEventType["DIRTY"] = "dirty";
    FlagEventType["CLOSE"] = "close";
})($5cf31a8d69eb9e81$export$d21f9befaa2961a || ($5cf31a8d69eb9e81$export$d21f9befaa2961a = {}));
const $5cf31a8d69eb9e81$export$7a1fc1a1b0477464 = (value)=>{
    return Object.values($5cf31a8d69eb9e81$export$d21f9befaa2961a).includes(value);
};

});

parcelRegister("5Jx7I", function(module, exports) {

$parcel$export(module.exports, "default", () => $c805980c1a8d0797$export$2e2bcd8739ae039);
const $c805980c1a8d0797$var$filterActions = (actions = [], data)=>{
    return actions.filter((action)=>{
        if (!action.shouldRender) return true;
        else if (typeof action.shouldRender !== 'function') return Boolean(action.shouldRender);
        return action.shouldRender(data);
    });
};
var $c805980c1a8d0797$export$2e2bcd8739ae039 = $c805980c1a8d0797$var$filterActions;

});

parcelRegister("aCbpp", function(module, exports) {

$parcel$export(module.exports, "default", () => $99816a416a8a70ef$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $99816a416a8a70ef$var$messages = (0, $90IgZ.defineMessages)({
    inactiveAccountMsg: {
        id: 'pt.profile-card.inactive.account',
        defaultMessage: 'Account deactivated',
        description: 'A text in a grey lozenge shows that this user is inactive'
    },
    generalDescMsgForDisabledUser: {
        id: 'pt.profile-card.general.msg.disabled.user',
        defaultMessage: 'You can no longer collaborate with this person.',
        description: 'A first sentence of a long text explains this user is inactive/closed'
    },
    inactiveAccountDescMsgNoDate: {
        id: 'pt.profile-card.inactive.account.no.date',
        defaultMessage: 'Their account has been deactivated.',
        description: 'A long text explains this user is inactive when we do not know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateThisWeek: {
        id: 'pt.profile-card.inactive.account.has.date.this.week',
        defaultMessage: 'Their account was deactivated this week.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateThisMonth: {
        id: 'pt.profile-card.inactive.account.has.date.this.month',
        defaultMessage: 'Their account was deactivated this month.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateLastMonth: {
        id: 'pt.profile-card.inactive.account.has.date.last.month',
        defaultMessage: 'Their account was deactivated last month.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateAFewMonths: {
        id: 'pt.profile-card.inactive.account.has.date.a.few.months',
        defaultMessage: 'Their account has been deactivated for a few months.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateSeveralMonths: {
        id: 'pt.profile-card.inactive.account.has.date.several.months',
        defaultMessage: 'Their account has been deactivated for several months.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateMoreThanAYear: {
        id: 'pt.profile-card.inactive.account.has.date.more.than.a.year',
        defaultMessage: 'Their account has been deactivated for more than a year.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    closedAccountMsg: {
        id: 'pt.profile-card.closed.account',
        defaultMessage: 'Account deleted',
        description: 'A text in a grey lozenge shows that this user is closed/deleted'
    },
    closedAccountDescMsgNoDate: {
        id: 'pt.profile-card.closed.account.no.date',
        defaultMessage: 'Their account has been deleted.',
        description: 'A long text explains this user is closed when we do not know the date of starting to close'
    },
    closedAccountDescMsgHasDateThisWeek: {
        id: 'pt.profile-card.closed.account.has.date.this.week',
        defaultMessage: 'Their account was deleted this week.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateThisMonth: {
        id: 'pt.profile-card.closed.account.has.date.this.month',
        defaultMessage: 'Their account was deleted this month.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateLastMonth: {
        id: 'pt.profile-card.closed.account.has.date.last.month',
        defaultMessage: 'Their account was deleted last month.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateAFewMonths: {
        id: 'pt.profile-card.closed.account.has.date.a.few.months',
        defaultMessage: 'Their account has been deleted for a few months.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateSeveralMonths: {
        id: 'pt.profile-card.closed.account.has.date.several.months',
        defaultMessage: 'Their account has been deleted for several months.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateMoreThanAYear: {
        id: 'pt.profile-card.closed.account.has.date.more.than.a.year',
        defaultMessage: 'Their account has been deleted for more than a year.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    disabledAccountDefaultName: {
        id: 'pt.profile-card.disabled.account.default.name',
        defaultMessage: 'Former user',
        description: 'A default name when we cannot get name of an inactive or closed user'
    },
    teamViewProfile: {
        id: 'pt.team-profile-card.team.action.view-profile',
        defaultMessage: 'View profile',
        description: "Button that takes you to view this team\u2019s profile"
    },
    memberCount: {
        id: 'pt.team-profile-card.team.member.count',
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}",
        description: 'Byline to show the number of members in the team'
    },
    memberCountIncludingYou: {
        id: 'pt.team-profile-card.team.member.count-including-you',
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you",
        description: 'Byline to show the number of members in the team and highlight that the user is a member'
    },
    membersMoreThan50: {
        id: 'pt.team-profile-card.team.member.many',
        defaultMessage: "Team \u2022 50+ members",
        description: 'Byline to show the team has more than 50 members'
    },
    membersMoreThan50IncludingYou: {
        id: 'pt.team-profile-card.team.member.many-including-you',
        defaultMessage: "Team \u2022 50+ members, including you",
        description: 'Byline to show the team has more than 50 members and highlight that the user is a member'
    },
    teamErrorTitle: {
        id: 'pt.team-profile-card.error.title',
        defaultMessage: "We\u2019re having trouble retrieving this teams information",
        description: 'Title for an error view explaining that data for this team cannot be accessed'
    },
    teamErrorText: {
        id: 'pt.team-profile-card.error.suggestion',
        defaultMessage: 'Wait a few moments, then try again.',
        description: 'Second line suggesting how to fix the issue'
    },
    teamErrorButton: {
        id: 'pt.team-profile-card.error.refresh-button',
        defaultMessage: 'Try again',
        description: 'Text on a button that will try to get the data again when clicked'
    },
    teamForbiddenErrorStateTitle: {
        id: 'pt.team-profile-card.forbidden-error-state.title',
        defaultMessage: "We can\u2019t show you this team",
        description: 'Title for the error state that is displayed when a user lacks access to the team'
    },
    teamForbiddenErrorStateDescription: {
        id: 'pt.team-profile-card.forbidden-error-state.description',
        defaultMessage: "You don\u2019t have access to view this team.",
        description: 'Description for the error state that is displayed when a user lacks access to the team'
    },
    managerSectionHeading: {
        id: 'pt.team-profile-card.manager.heading',
        defaultMessage: 'Manager',
        description: "Title for a section on the profile card that show the user's direct manager"
    },
    directReportsSectionHeading: {
        id: 'pt.team-profile-card.directReports.heading',
        defaultMessage: 'Direct reports',
        description: "Title for a section on the profile card that show the user's direct reports"
    },
    giveKudosButton: {
        id: 'pt.profile-card.give-kudos',
        defaultMessage: 'Give kudos',
        description: 'Title for the button on the profile card for a user to give a kudos'
    },
    profileCardMoreIconLabel: {
        id: 'pt.profile-card.more-icon-label',
        defaultMessage: 'More',
        description: 'Label for the meatballs icon on the profile card, which when clicked will provide more options'
    }
});
var $99816a416a8a70ef$export$2e2bcd8739ae039 = $99816a416a8a70ef$var$messages;

});

parcelRegister("7NIUg", function(module, exports) {

$parcel$export(module.exports, "isBasicClick", () => $211cf3e2277295bb$export$eddcd8a5b7e09991);
const $211cf3e2277295bb$export$eddcd8a5b7e09991 = (event)=>{
    return !(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

});

const $515c9dbc88c31cf4$export$5b956b542f1bc1b3 = 800;
const $515c9dbc88c31cf4$export$89a9f35a94d7f196 = 200;

parcelRegister("iINHb", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => (parcelRequire("9Pgj1")).ErrorBoundary);
$parcel$export(module.exports, "ErrorIllustration", () => (parcelRequire("8J4a2")).ErrorIllustration);
$parcel$export(module.exports, "ErrorMessage", () => (parcelRequire("4ga2m")).default);

var $9Pgj1 = parcelRequire("9Pgj1");

var $8J4a2 = parcelRequire("8J4a2");

var $4ga2m = parcelRequire("4ga2m");

});
parcelRegister("9Pgj1", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $4fd3e125f285a7c7$export$e926676385687eaf);

var $eUqFw = parcelRequire("eUqFw");
class $4fd3e125f285a7c7$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    componentDidCatch() {
        // Failure analytics here too
        this.props.onError();
    }
    render() {
        return this.props.children;
    }
}
var $4fd3e125f285a7c7$export$2e2bcd8739ae039 = $4fd3e125f285a7c7$export$e926676385687eaf;

});

parcelRegister("8J4a2", function(module, exports) {

$parcel$export(module.exports, "ErrorIllustration", () => $87687304f7d83e3d$export$e0319f52fc2380b1);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $eUqFw = parcelRequire("eUqFw");
const $87687304f7d83e3d$export$e0319f52fc2380b1 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "42",
        height: "53",
        viewBox: "0 0 164 212",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        clipPath: "url(#clip0)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M0.649902 0H163.93V212H0.649902V0Z",
        fill: "var(--ds-surface-overlay, white)",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M95.4299 74.1603L161.87 189.24C167.71 199.36 160.41 212 148.73 212H15.8499C4.16994 212 -3.13006 199.35 2.70994 189.24L69.1499 74.1603C74.9899 64.0403 89.5899 64.0403 95.4299 74.1603ZM87.8699 157.71L90.7499 113.36C91.0899 108.07 86.8899 103.58 81.5899 103.58C76.2799 103.58 72.0799 108.06 72.4299 113.36L75.3099 157.71C75.5299 161.02 78.2699 163.6 81.5899 163.6C84.8999 163.6 87.6499 161.02 87.8699 157.71ZM72.0299 181.25C72.0299 186.91 76.7899 191.35 82.4199 190.83C87.2699 190.38 91.1499 186.33 91.2499 181.46C91.3599 176.01 86.9399 171.52 81.5199 171.52C76.2899 171.51 72.0299 175.89 72.0299 181.25Z",
        fill: "url(#paint0_linear)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.6",
        d: "M93.3498 27.1702L85.9398 0.450216C85.7698 -0.169784 84.8698 -0.129784 84.7498 0.500216L80.0898 25.6002L74.2898 24.5202C73.8498 24.4402 73.4698 24.8502 73.5898 25.2802L80.9998 52.0002C81.1698 52.6202 82.0698 52.5802 82.1898 51.9502L86.8498 26.8502L92.6498 27.9302C93.0998 28.0102 93.4698 27.6002 93.3498 27.1702Z",
        fill: "#C1C7D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.6",
        d: "M66.7699 41.8103L55.8999 33.2603C55.6799 33.0803 55.3699 33.3303 55.4899 33.5903L61.0199 45.0203L58.3599 46.3103C58.1799 46.4003 58.1599 46.6403 58.3099 46.7603L69.1799 55.3103C69.3999 55.4903 69.7099 55.2403 69.5899 54.9803L64.0599 43.5503L66.7199 42.2603C66.8899 42.1803 66.9199 41.9303 66.7699 41.8103Z",
        fill: "#C1C7D0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.6",
        d: "M102.78 56.7501C102.57 56.7501 102.37 56.6901 102.19 56.5601C101.81 56.2801 101.68 55.7801 101.86 55.3701C101.62 54.6001 99.57 52.5201 98.32 51.2601C95.35 48.2501 93.39 46.2601 94.48 44.7701C95.57 43.2901 98.06 44.5501 101.83 46.4701C103.15 47.1401 105.18 48.1701 106.28 48.5001C105.64 47.5501 104.04 45.9201 103 44.8701C100.03 41.8601 98.07 39.8701 99.16 38.3801C100.24 36.9001 102.74 38.1601 106.5 40.0801C107.82 40.7501 109.84 41.7801 110.95 42.1101C110.31 41.1601 108.71 39.5401 107.67 38.4901C104.7 35.4801 102.74 33.4901 103.83 32.0001C104.91 30.5201 107.4 31.7801 111.17 33.7001C112.75 34.5001 115.35 35.8301 116.15 35.8301C116.49 35.5401 117 35.5101 117.39 35.7901C117.84 36.1201 117.93 36.7401 117.61 37.1901C116.52 38.6701 114.04 37.4101 110.27 35.4901C108.95 34.8201 106.93 33.7901 105.83 33.4601C106.47 34.4101 108.07 36.0301 109.11 37.0801C112.08 40.0901 114.04 42.0801 112.95 43.5701C111.87 45.0501 109.38 43.7901 105.61 41.8701C104.29 41.2001 102.26 40.1701 101.16 39.8401C101.8 40.7901 103.4 42.4101 104.44 43.4701C107.41 46.4801 109.37 48.4701 108.28 49.9601C107.19 51.4401 104.7 50.1801 100.93 48.2601C99.61 47.5901 97.58 46.5501 96.48 46.2301C97.12 47.1801 98.72 48.8101 99.76 49.8601C102.73 52.8701 104.69 54.8601 103.6 56.3501C103.39 56.6101 103.09 56.7501 102.78 56.7501Z",
        fill: "#B3BAC5"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.6",
        d: "M108.34 71.0702C107.99 71.0702 107.65 70.8802 107.46 70.5502C106.42 68.6702 105.24 66.5302 106.55 65.3402C107.86 64.1402 109.89 65.5202 112.04 66.9702C112.91 67.5602 114.3 68.5002 114.97 68.6802C114.85 68.0002 114.04 66.5302 113.52 65.6102C112.26 63.3402 111.07 61.2002 112.38 60.0002C113.69 58.8002 115.72 60.1802 117.87 61.6302C118.83 62.2802 120.41 63.3502 120.97 63.3702C121.38 63.0702 121.95 63.1202 122.3 63.5002C122.67 63.9102 122.65 64.5402 122.24 64.9102C120.93 66.1102 118.9 64.7402 116.75 63.2802C115.88 62.6902 114.49 61.7502 113.82 61.5702C113.94 62.2502 114.75 63.7202 115.27 64.6402C116.53 66.9102 117.72 69.0502 116.41 70.2502C115.1 71.4502 113.07 70.0702 110.92 68.6202C110.05 68.0302 108.66 67.0902 107.99 66.9102C108.11 67.5902 108.92 69.0502 109.21 69.5802C109.48 70.0602 109.3 70.6702 108.82 70.9402C108.67 71.0302 108.5 71.0702 108.34 71.0702Z",
        fill: "#B3BAC5"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.6",
        d: "M54.02 68.1797C53.8 68.1797 53.58 68.1397 53.35 68.0397C51.71 67.3497 52.11 64.9297 52.54 62.3697C52.71 61.3297 52.99 59.6697 52.87 58.9897C52.3 59.3797 51.31 60.7397 50.69 61.5897C49.16 63.6797 47.7 65.6597 46.07 64.9697C45.56 64.7597 45.32 64.1697 45.54 63.6597C45.74 63.1797 46.27 62.9397 46.75 63.0897C47.27 62.8797 48.4 61.3397 49.09 60.4097C50.62 58.3197 52.07 56.3297 53.71 57.0297C55.35 57.7197 54.95 60.1397 54.52 62.6997C54.35 63.7397 54.07 65.3997 54.19 66.0797C54.76 65.6897 55.75 64.3297 56.37 63.4797C57.9 61.3897 59.35 59.3997 60.99 60.0997C62.62 60.7897 62.23 63.1897 61.88 65.3097C61.79 65.8497 61.28 66.2197 60.73 66.1397C60.19 66.0497 59.81 65.5397 59.9 64.9897C60 64.3997 60.27 62.7497 60.16 62.0697C59.59 62.4597 58.6 63.8197 57.98 64.6697C56.65 66.4597 55.39 68.1797 54.02 68.1797Z",
        fill: "#B3BAC5"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint0_linear",
        x1: "26.1692",
        y1: "228.621",
        x2: "138.408",
        y2: "116.382",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: "#C1C7D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.297",
        stopColor: "#C6CBD4",
        stopOpacity: "0.8812"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.6301",
        stopColor: "#D3D7DE",
        stopOpacity: "0.748"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.9795",
        stopColor: "#E9EBEF",
        stopOpacity: "0.6082"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: "#EBECF0",
        stopOpacity: "0.6"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("clipPath", {
        id: "clip0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M0.649902 0H163.93V212H0.649902V0Z",
        fill: "white"
    }))));
};

});

parcelRegister("4ga2m", function(module, exports) {

$parcel$export(module.exports, "default", () => $486d3bd21855e22f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $5k4ch = parcelRequire("5k4ch");

var $fnJ1y = parcelRequire("fnJ1y");

var $3vXh8 = parcelRequire("3vXh8");
const $486d3bd21855e22f$var$ErrorMessage = (props)=>{
    const errorType = props.errorType || {
        reason: 'default'
    };
    const errorReason = errorType.reason;
    const { fireAnalytics: fireAnalytics, reload: reload } = props;
    const hasRetry = !!reload;
    (0, $eUqFw.useEffect)(()=>{
        fireAnalytics((0, $3vXh8.profileCardRendered)('user', 'error', {
            hasRetry: hasRetry,
            errorType: errorReason
        }));
    }, [
        errorReason,
        fireAnalytics,
        hasRetry
    ]);
    const errorContent = ()=>{
        if (errorReason === 'NotFound') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fnJ1y.ErrorTitle), null, "The user is no longer available for the site");
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fnJ1y.ErrorTitle), null, "Oops, looks like we\u2019re having issues", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null), reload && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fnJ1y.ErrorText), null, "Try again and we\u2019ll give it another shot"));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fnJ1y.ErrorWrapper), {
        "data-testid": "profilecard-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5k4ch))), {
        label: "icon error",
        size: "xlarge"
    }), errorContent(), reload && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "link",
        onClick: reload
    }, "Try again"));
};
var $486d3bd21855e22f$export$2e2bcd8739ae039 = $486d3bd21855e22f$var$ErrorMessage;

});
parcelRegister("5k4ch", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e02137160dfc264$var$_react = $3e02137160dfc264$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $3e02137160dfc264$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $3e02137160dfc264$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $3e02137160dfc264$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" cx="12" cy="12" r="10"/><path d="M13.477 9.113l-4.36 4.386a1 1 0 101.418 1.41l4.36-4.386a1 1 0 00-1.418-1.41z" fill="inherit"/><path d="M9.084 10.501l4.358 4.377a1 1 0 101.418-1.411L10.5 9.09a1 1 0 00-1.417 1.411z" fill="inherit"/></g></svg>`
    }, props));
$3e02137160dfc264$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $3e02137160dfc264$var$_default = $3e02137160dfc264$var$CrossCircleIcon;
module.exports.default = $3e02137160dfc264$var$_default;

});

parcelRegister("fnJ1y", function(module, exports) {

$parcel$export(module.exports, "ErrorWrapper", () => $0ffb74661b2a3e3e$export$bb27b7e39840238f);
$parcel$export(module.exports, "ErrorTitle", () => $0ffb74661b2a3e3e$export$b065fd053267ec81);
$parcel$export(module.exports, "ErrorText", () => $0ffb74661b2a3e3e$export$7f714e6c560938e5);
$parcel$export(module.exports, "TeamErrorTitle", () => $0ffb74661b2a3e3e$export$d139ade0bdee219d);
$parcel$export(module.exports, "TeamErrorText", () => $0ffb74661b2a3e3e$export$90d92ccfb27352c6);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $PdmhA = parcelRequire("PdmhA");

var $lcnyw = parcelRequire("lcnyw");

var $4lTFP = parcelRequire("4lTFP");

var $5PC5M = parcelRequire("5PC5M");

var $joBf7 = parcelRequire("joBf7");
const $0ffb74661b2a3e3e$export$bb27b7e39840238f = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1g2atxt4"
})({
    textAlign: 'center',
    padding: "var(--ds-space-300, 24px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $5PC5M.errorIconColor)
});
const $0ffb74661b2a3e3e$export$b065fd053267ec81 = /*#__PURE__*/ (0, $joBf7.default)("p", {
    target: "e1g2atxt3"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $5PC5M.errorTitleColor),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    lineHeight: `${(0, $lcnyw.gridSize)() * 3}px`,
    margin: `${"var(--ds-space-100, 8px)"} 0`
});
const $0ffb74661b2a3e3e$export$7f714e6c560938e5 = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "e1g2atxt2"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $5PC5M.errorTextColor)
});
const $0ffb74661b2a3e3e$export$d139ade0bdee219d = /*#__PURE__*/ (0, $joBf7.default)("p", {
    target: "e1g2atxt1"
})((0, $4lTFP.h400));
const $0ffb74661b2a3e3e$export$90d92ccfb27352c6 = /*#__PURE__*/ (0, $joBf7.default)("p", {
    target: "e1g2atxt0"
})({
    color: `var(--ds-text-subtlest, ${(0, $PdmhA.N200)})`,
    marginTop: "var(--ds-space-100, 8px)"
});

});
parcelRegister("5PC5M", function(module, exports) {

$parcel$export(module.exports, "bgColor", () => $94991c92a8b245c9$export$7dcbec377a25efc6);
$parcel$export(module.exports, "headerBgColor", () => $94991c92a8b245c9$export$d3ec0459d8f4bbed);
$parcel$export(module.exports, "teamHeaderBgColor", () => $94991c92a8b245c9$export$afc7ad7e78cf1c79);
$parcel$export(module.exports, "headerBgColorDisabledUser", () => $94991c92a8b245c9$export$ef73fded6fab455c);
$parcel$export(module.exports, "headerTextColor", () => $94991c92a8b245c9$export$5c2df128da90e8de);
$parcel$export(module.exports, "headerTextColorInactive", () => $94991c92a8b245c9$export$a882617dcf7f98a6);
$parcel$export(module.exports, "appLabelBgColor", () => $94991c92a8b245c9$export$6f79b778f6280d31);
$parcel$export(module.exports, "appLabelTextColor", () => $94991c92a8b245c9$export$3db47a978b9599f9);
$parcel$export(module.exports, "labelTextColor", () => $94991c92a8b245c9$export$dd73341f2a5541fa);
$parcel$export(module.exports, "labelIconColor", () => $94991c92a8b245c9$export$5a20f73e634c37e3);
$parcel$export(module.exports, "errorIconColor", () => $94991c92a8b245c9$export$85e73a744c5d1042);
$parcel$export(module.exports, "errorTitleColor", () => $94991c92a8b245c9$export$be3c814f7ed506ed);
$parcel$export(module.exports, "errorTextColor", () => $94991c92a8b245c9$export$ddf766d3bfcf965c);

var $PdmhA = parcelRequire("PdmhA");
const $94991c92a8b245c9$export$7dcbec377a25efc6 = `var(--ds-surface-overlay, ${(0, $PdmhA.N0)})`;
const $94991c92a8b245c9$export$d3ec0459d8f4bbed = `var(--ds-background-brand-bold, ${(0, $PdmhA.B500)})`;
const $94991c92a8b245c9$export$afc7ad7e78cf1c79 = `var(--ds-background-neutral, ${(0, $PdmhA.N50)})`;
const $94991c92a8b245c9$export$ef73fded6fab455c = `var(--ds-background-disabled, ${(0, $PdmhA.N30)})`;
const $94991c92a8b245c9$export$5c2df128da90e8de = `var(--ds-text-inverse, ${(0, $PdmhA.N0)})`;
const $94991c92a8b245c9$export$a882617dcf7f98a6 = `var(--ds-text, ${(0, $PdmhA.N800)})`;
const $94991c92a8b245c9$export$6f79b778f6280d31 = `var(--ds-background-neutral, ${(0, $PdmhA.N20)})`;
const $94991c92a8b245c9$export$3db47a978b9599f9 = `var(--ds-text, ${(0, $PdmhA.N500)})`;
const $94991c92a8b245c9$export$dd73341f2a5541fa = `var(--ds-text, ${(0, $PdmhA.N800)})`;
const $94991c92a8b245c9$export$5a20f73e634c37e3 = `var(--ds-text-subtlest, ${(0, $PdmhA.N60)})`;
const $94991c92a8b245c9$export$85e73a744c5d1042 = `var(--ds-text-disabled, ${(0, $PdmhA.N90)})`;
const $94991c92a8b245c9$export$be3c814f7ed506ed = `var(--ds-text, ${(0, $PdmhA.N800)})`;
const $94991c92a8b245c9$export$ddf766d3bfcf965c = `var(--ds-text-subtlest, ${(0, $PdmhA.N90)})`;

});




parcelRegister("j7pJq", function(module, exports) {

$parcel$export(module.exports, "TeamProfileCardLazy", () => $5ae4a5a4fd9fbf1e$export$82a49d896f41ca78);

var $eUqFw = parcelRequire("eUqFw");

const $5ae4a5a4fd9fbf1e$export$82a49d896f41ca78 = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>Promise.resolve((parcelRequire("g8DVf"))));

});

parcelRegister("dO06T", function(module, exports) {

$parcel$export(module.exports, "default", () => $5aac33fd408e01e7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4Bees = parcelRequire("4Bees");

var $dRbkr = parcelRequire("dRbkr");

var $3vXh8 = parcelRequire("3vXh8");
var $5aac33fd408e01e7$export$2e2bcd8739ae039 = (props)=>{
    const { analytics: analytics } = props;
    (0, $eUqFw.useEffect)(()=>{
        analytics((duration)=>(0, $3vXh8.profileCardRendered)('team', 'spinner', {
                duration: duration
            }));
    }, [
        analytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.CardWrapper), {
        "data-testid": "team-profilecard"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.CardHeader), {
        isLoading: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.CardContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.LoadingWrapper), {
        "data-testid": "team-profilecard-spinner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), null))));
};

});
parcelRegister("dRbkr", function(module, exports) {

$parcel$export(module.exports, "CardWrapper", () => $44bed1e2692b7853$export$6aa22a823032b784);
$parcel$export(module.exports, "TeamForbiddenErrorStateWrapper", () => $44bed1e2692b7853$export$66ecf3d3b7b1c016);
$parcel$export(module.exports, "CardHeader", () => $44bed1e2692b7853$export$5665775b26e26c5d);
$parcel$export(module.exports, "CardContent", () => $44bed1e2692b7853$export$64ef9b8c11710c47);
$parcel$export(module.exports, "TeamName", () => $44bed1e2692b7853$export$8fe6f0aed18a58c7);
$parcel$export(module.exports, "MemberCount", () => $44bed1e2692b7853$export$1cbd03a20253b620);
$parcel$export(module.exports, "AvatarSection", () => $44bed1e2692b7853$export$82a6f3ee677bdbfe);
$parcel$export(module.exports, "DescriptionWrapper", () => $44bed1e2692b7853$export$2bf1f2b0d31b60fc);
$parcel$export(module.exports, "Description", () => $44bed1e2692b7853$export$393edc798c47379d);
$parcel$export(module.exports, "ActionButtons", () => $44bed1e2692b7853$export$88c65d2d98aab183);
$parcel$export(module.exports, "WrappedButton", () => $44bed1e2692b7853$export$44e087c32db6077d);
$parcel$export(module.exports, "MoreButton", () => $44bed1e2692b7853$export$7f94856880993f27);
$parcel$export(module.exports, "LoadingWrapper", () => $44bed1e2692b7853$export$43a792a870d28db2);
$parcel$export(module.exports, "AccessLockSVGWrapper", () => $44bed1e2692b7853$export$71bcd744fda975e5);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $PdmhA = parcelRequire("PdmhA");

var $lcnyw = parcelRequire("lcnyw");

var $4lTFP = parcelRequire("4lTFP");

var $5PC5M = parcelRequire("5PC5M");

var $joBf7 = parcelRequire("joBf7");
function $44bed1e2692b7853$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $44bed1e2692b7853$export$a443be8291b92497 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1kkd6f414"
})({
    name: "ck88l6",
    styles: "display:inherit"
});
const $44bed1e2692b7853$export$6aa22a823032b784 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1kkd6f413"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    backgroundColor: (0, $5PC5M.bgColor),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `${(0, $lcnyw.borderRadius)()}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $lcnyw.gridSize)() * 40}px`,
    position: 'relative',
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale'
});
const $44bed1e2692b7853$export$66ecf3d3b7b1c016 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1kkd6f412"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $lcnyw.gridSize)() * 40}px`,
    position: 'relative'
});
const $44bed1e2692b7853$export$5665775b26e26c5d = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1kkd6f411"
})("background-color:", (props)=>props.isLoading ? `var(--ds-background-neutral, ${0, $PdmhA.N20})` : props.image ? '' : (0, $5PC5M.teamHeaderBgColor), ";background-image:", (props)=>props.image ? `url(${props.image})` : '', ";background-repeat:no-repeat;background-position:center;background-size:cover;box-sizing:content-box;height:", (0, $lcnyw.gridSize)() * 16, "px;");
const $44bed1e2692b7853$export$64ef9b8c11710c47 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1kkd6f410"
})({
    display: 'flex',
    flexDirection: 'column',
    padding: "var(--ds-space-300, 24px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minHeight: `${(0, $lcnyw.gridSize)() * 13}px`
});
const $44bed1e2692b7853$export$8fe6f0aed18a58c7 = /*#__PURE__*/ (0, $joBf7.default)("h6", {
    target: "e1kkd6f49"
})((0, $4lTFP.h600), "text-transform:none;overflow:hidden;max-height:48px;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;");
const $44bed1e2692b7853$export$1cbd03a20253b620 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1kkd6f48"
})({
    color: `var(--ds-text-subtlest, ${(0, $PdmhA.N200)})`,
    marginTop: "var(--ds-space-050, 4px)"
});
const $44bed1e2692b7853$export$82a6f3ee677bdbfe = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1kkd6f47"
})({
    name: "li9rw7",
    styles: "margin-top:var(--ds-space-200, 16px);margin-left:var(--ds-space-negative-025, -2px)"
});
const $44bed1e2692b7853$export$2bf1f2b0d31b60fc = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1kkd6f46"
})({
    name: "vi4bqq",
    styles: "margin-top:var(--ds-space-200, 16px);align-items:center;display:flex"
});
const $44bed1e2692b7853$export$393edc798c47379d = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "e1kkd6f45"
})({
    name: "yog5y2",
    styles: "overflow:hidden;max-height:60px;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical"
});
const $44bed1e2692b7853$export$88c65d2d98aab183 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1kkd6f44"
})({
    width: 'calc(100% + 8px)',
    display: 'flex',
    justifyContent: 'space-between',
    margin: `${"var(--ds-space-300, 24px)"} ${"var(--ds-space-negative-300, -24px)"} 0 ${"var(--ds-space-negative-100, -8px)"}`,
    backgroundColor: "var(--ds-surface-overlay, hsla(0, 100%, 100%, 0.2))"
});
const $44bed1e2692b7853$export$44e087c32db6077d = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1kkd6f43"
})({
    name: "1svotkm",
    styles: "flex-basis:0;flex-grow:1;margin-left:var(--ds-space-100, 8px)"
});
const $44bed1e2692b7853$export$7f94856880993f27 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1kkd6f42"
})({
    name: "9kivhj",
    styles: "margin-left:var(--ds-space-100, 8px)"
});
const $44bed1e2692b7853$export$43a792a870d28db2 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1kkd6f41"
})({
    name: "o13o72",
    styles: "text-align:center;margin-top:var(--ds-space-500, 40px)"
});
const $44bed1e2692b7853$export$71bcd744fda975e5 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1kkd6f40"
})({
    name: "ifz8jz",
    styles: "margin-bottom:var(--ds-space-300, 24px)"
}); // export const LoadingTeamName = styled.div`
 //   width: 175px;
 //   height: ${gridSize () *3)px;
 //   border-radius: ${borderRadius}px;
 //   background-color: #f4f5f7;
 // `;
 // export const LoadingMemberCount = styled.div`
 //   width: 81px;
 //   height: ${gridSize () *2)px;
 //   border-radius: 3px;
 //   background-color: #f4f5f7;
 //   margin: 4px 0;
 // `;

});



parcelRegister("ehM5E", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "ProfilecardInternal", () => $aaa133bbdb29f425$export$64e0275ede8ab792);
$parcel$export(module.exports, "default", () => $aaa133bbdb29f425$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $2jDha = parcelRequire("2jDha");

var $iJlfe = parcelRequire("iJlfe");

var $7u4fN = parcelRequire("7u4fN");

var $51sCz = parcelRequire("51sCz");

var $4Bees = parcelRequire("4Bees");

var $PdmhA = parcelRequire("PdmhA");

var $aCbpp = parcelRequire("aCbpp");

var $kqibQ = parcelRequire("kqibQ");

var $3vXh8 = parcelRequire("3vXh8");

var $7NIUg = parcelRequire("7NIUg");

var $cEOpo = parcelRequire("cEOpo");
parcelRequire("iINHb");
var $4ga2m = parcelRequire("4ga2m");

var $g8EW1 = parcelRequire("g8EW1");

var $gXyvb = parcelRequire("gXyvb");
const $aaa133bbdb29f425$var$GIVE_KUDOS_ACTION_ID = 'give-kudos';
const $aaa133bbdb29f425$var$useKudos = (cloudId, userId, teamCentralBaseUrl, openKudosDrawer)=>{
    const kudosUrl = (0, $eUqFw.useMemo)(()=>{
        const recipientId = userId ? `&recipientId=${userId}` : '';
        const cloudIdParam = cloudId ? `&cloudId=${cloudId}` : '';
        return `${teamCentralBaseUrl || ''}/kudos/give?type=individual${recipientId}${cloudIdParam}`;
    }, [
        cloudId,
        teamCentralBaseUrl,
        userId
    ]);
    const kudosButtonCallback = (0, $eUqFw.useCallback)(()=>{
        if (openKudosDrawer) openKudosDrawer();
        else window.open(kudosUrl);
    }, [
        kudosUrl,
        openKudosDrawer
    ]);
    const kudosAction = (0, $eUqFw.useMemo)(()=>{
        return {
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $aCbpp.default).giveKudosButton),
            id: $aaa133bbdb29f425$var$GIVE_KUDOS_ACTION_ID,
            callback: kudosButtonCallback,
            link: kudosUrl
        };
    }, [
        kudosButtonCallback,
        kudosUrl
    ]);
    return {
        kudosAction: kudosAction,
        kudosButtonCallback: kudosButtonCallback,
        kudosUrl: kudosUrl
    };
};
const $aaa133bbdb29f425$var$Wrapper = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.CardWrapper), {
        "data-testid": "profilecard",
        role: "dialog",
        "aria-labelledby": "profilecard-name-label"
    }, props.children);
const $aaa133bbdb29f425$export$64e0275ede8ab792 = (props)=>{
    const [openTime] = (0, $eUqFw.useState)((0, $cEOpo.getPageTime)());
    const { createAnalyticsEvent: createAnalyticsEvent } = props;
    const fireAnalytics = (0, $eUqFw.useCallback)((payload)=>{
        if (createAnalyticsEvent) (0, $3vXh8.fireEvent)(createAnalyticsEvent, payload);
    }, [
        createAnalyticsEvent
    ]);
    const fireAnalyticsWithDuration = (0, $eUqFw.useCallback)((generator)=>{
        const elapsed = (0, $cEOpo.getPageTime)() - openTime;
        const event = generator(elapsed);
        fireAnalytics(event);
    }, [
        fireAnalytics,
        openTime
    ]);
    const { kudosAction: kudosAction } = $aaa133bbdb29f425$var$useKudos(props.cloudId, props.userId, props.teamCentralBaseUrl, props.openKudosDrawer);
    const { actions: actions = [], isCurrentUser: isCurrentUser, isKudosEnabled: isKudosEnabled, status: status = 'active' } = props;
    const realActions = (0, $eUqFw.useMemo)(()=>{
        if (isCurrentUser || !isKudosEnabled || status !== 'active') return actions;
        return actions.concat([
            kudosAction
        ]);
    }, [
        actions,
        isCurrentUser,
        isKudosEnabled,
        kudosAction,
        status
    ]);
    const { isLoading: isLoading, fullName: fullName, hasError: hasError } = props;
    const canRender = !hasError && !isLoading && !!(fullName || status === 'closed');
    (0, $eUqFw.useEffect)(()=>{
        if (canRender) fireAnalyticsWithDuration((duration)=>(0, $3vXh8.profileCardRendered)('user', 'content', {
                duration: duration,
                numActions: realActions.length
            }));
    }, [
        canRender,
        fireAnalyticsWithDuration,
        realActions
    ]);
    if (hasError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aaa133bbdb29f425$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ga2m.default), {
        reload: props.clientFetchProfile,
        errorType: props.errorType || null,
        fireAnalytics: fireAnalytics
    }));
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aaa133bbdb29f425$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aaa133bbdb29f425$var$LoadingView, {
        fireAnalyticsWithDuration: fireAnalyticsWithDuration
    }));
    if (!canRender) return null;
    const isDisabledUser = status === 'inactive' || status === 'closed';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aaa133bbdb29f425$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.CardContainer), {
        isDisabledUser: isDisabledUser,
        withoutElevation: props.withoutElevation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.ProfileImage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        size: "xlarge",
        src: status !== 'closed' ? props.avatarUrl : undefined,
        borderColor: `var(--ds-shadow-overlay, ${(0, $PdmhA.N0)})`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.CardContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gXyvb.ProfileCardDetails), {
        ...props,
        status: status,
        fireAnalyticsWithDuration: fireAnalyticsWithDuration
    }), realActions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.ActionsFlexSpacer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aaa133bbdb29f425$var$Actions, {
        actions: realActions,
        fireAnalyticsWithDuration: fireAnalyticsWithDuration,
        isTriggeredUsingKeyboard: props.isTriggeredUsingKeyboard
    })))));
};
const $aaa133bbdb29f425$var$Actions = ({ actions: actions, fireAnalyticsWithDuration: fireAnalyticsWithDuration, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard })=>{
    const onActionClick = (0, $eUqFw.useCallback)((action, args, event, index)=>{
        fireAnalyticsWithDuration((duration)=>(0, $3vXh8.actionClicked)('user', {
                duration: duration,
                hasHref: !!action.link,
                hasOnClick: !!action.callback,
                index: index,
                actionId: action.id || 'no-id-specified'
            }));
        if (action.callback && (0, $7NIUg.isBasicClick)(event)) {
            event.preventDefault();
            action.callback(event, ...args);
        }
    }, [
        fireAnalyticsWithDuration
    ]);
    if (!actions || actions.length === 0) return null;
    const regularActions = actions.slice(0, (0, $g8EW1.ACTION_OVERFLOW_THRESHOLD));
    const overflowActions = actions.length > (0, $g8EW1.ACTION_OVERFLOW_THRESHOLD) ? actions.slice((0, $g8EW1.ACTION_OVERFLOW_THRESHOLD)) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.ActionButtonGroup), {
        "data-testid": "profilecard-actions"
    }, regularActions.map((action, index)=>{
        const isKudos = action.id === $aaa133bbdb29f425$var$GIVE_KUDOS_ACTION_ID;
        const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $51sCz.default), {
            isInset: true,
            key: `profile-card-action-focus-ring_${action.id || index}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "default",
            key: action.id || index,
            onClick: (event, ...args)=>onActionClick(action, args, event, index),
            href: action.link,
            autoFocus: index === 0 && isTriggeredUsingKeyboard
        }, action.label, isKudos && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.AnimationWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.KudosBlobAnimation), null))));
        if (isKudos) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.AnimatedKudosButton), {
            key: `profile-card-action-kudos_${action.id || index}`
        }, button);
        return button;
    }), overflowActions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g8EW1.OverflowProfileCardButtons), {
        actions: overflowActions,
        fireAnalyticsWithDuration: fireAnalyticsWithDuration,
        onItemClick: (action, args, event, index)=>onActionClick(action, args, event, index + (0, $g8EW1.ACTION_OVERFLOW_THRESHOLD))
    }));
};
const $aaa133bbdb29f425$var$LoadingView = ({ fireAnalyticsWithDuration: fireAnalyticsWithDuration })=>{
    (0, $eUqFw.useEffect)(()=>{
        fireAnalyticsWithDuration((duration)=>(0, $3vXh8.profileCardRendered)('user', 'spinner', {
                duration: duration
            }));
    }, [
        fireAnalyticsWithDuration
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.SpinnerContainer), {
        "data-testid": "profilecard-spinner-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), null));
};
var $aaa133bbdb29f425$export$2e2bcd8739ae039 = (0, $2jDha.default)()($aaa133bbdb29f425$export$64e0275ede8ab792);

});
parcelRegister("kqibQ", function(module, exports) {

$parcel$export(module.exports, "CardWrapper", () => $9338621abe3237e0$export$6aa22a823032b784);
$parcel$export(module.exports, "ProfileImage", () => $9338621abe3237e0$export$a7a74ab5cffd1455);
$parcel$export(module.exports, "ActionsFlexSpacer", () => $9338621abe3237e0$export$d395c8d16f1e359d);
$parcel$export(module.exports, "KudosBlobAnimation", () => $9338621abe3237e0$export$4a8a956251d4bf6f);
$parcel$export(module.exports, "AnimationWrapper", () => $9338621abe3237e0$export$58517bb1b373a54c);
$parcel$export(module.exports, "AnimatedKudosButton", () => $9338621abe3237e0$export$6196a3f52a6944fe);
$parcel$export(module.exports, "ActionButtonGroup", () => $9338621abe3237e0$export$73d695ae27330056);
$parcel$export(module.exports, "OverflowActionButtonsWrapper", () => $9338621abe3237e0$export$ff778e5b796745a6);
$parcel$export(module.exports, "CardContent", () => $9338621abe3237e0$export$64ef9b8c11710c47);
$parcel$export(module.exports, "DetailsGroup", () => $9338621abe3237e0$export$35cf684daac137ac);
$parcel$export(module.exports, "DisabledInfo", () => $9338621abe3237e0$export$2062e7265a95a823);
$parcel$export(module.exports, "FullNameLabel", () => $9338621abe3237e0$export$1270e9c1fc39142b);
$parcel$export(module.exports, "LozengeWrapper", () => $9338621abe3237e0$export$75180efdd3f4d9c2);
$parcel$export(module.exports, "CustomLozengeContainer", () => $9338621abe3237e0$export$6ebf103500ba5a45);
$parcel$export(module.exports, "JobTitleLabel", () => $9338621abe3237e0$export$d6c0e5f211c8d617);
$parcel$export(module.exports, "AppTitleLabel", () => $9338621abe3237e0$export$4865ffa72a4d5f9);
$parcel$export(module.exports, "SpinnerContainer", () => $9338621abe3237e0$export$a5e06607a5ac6158);
$parcel$export(module.exports, "CardContainer", () => $9338621abe3237e0$export$8a23e74e5cf3ca41);
$parcel$export(module.exports, "DetailsLabel", () => $9338621abe3237e0$export$138a08882ebf7289);
$parcel$export(module.exports, "DetailsLabelIcon", () => $9338621abe3237e0$export$79d7d9b2f6a70c70);
$parcel$export(module.exports, "DetailsLabelText", () => $9338621abe3237e0$export$b0ec2c767a0e0eab);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression -- needs manual remediation */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");

var $lcnyw = parcelRequire("lcnyw");

var $5PC5M = parcelRequire("5PC5M");

var $joBf7 = parcelRequire("joBf7");
function $9338621abe3237e0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9338621abe3237e0$var$getFullNameMargin = (props)=>props.noMeta ? `${"var(--ds-space-400, 32px)"} 0 ${"var(--ds-space-150, 12px)"} 0` : `${"var(--ds-space-150, 12px)"} 0 0 0`;
const $9338621abe3237e0$export$6aa22a823032b784 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo20"
})("background-color:", (0, $5PC5M.bgColor), ";border-radius:var(--ds-border-radius, 3px);width:", (0, $lcnyw.gridSize)() * 45, "px;");
const $9338621abe3237e0$export$a7a74ab5cffd1455 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo19"
})({
    name: "eukccz",
    styles: "position:absolute;top:var(--ds-space-300, 24px);left:var(--ds-space-300, 24px)"
});
const $9338621abe3237e0$export$d395c8d16f1e359d = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo18"
})({
    name: "18pny36",
    styles: "flex:1 0 auto"
});
// eslint-disable-next-line @atlaskit/design-system/no-keyframes-tagged-template-expression -- needs manual remediation
const $9338621abe3237e0$var$kudosButtonAnimationTransformation = (0, $byn9U.keyframes)`
  0%   { transform: translate(-80px, -50px); }
  100% { transform: translate(90px, -70px); }
`;
const $9338621abe3237e0$export$b08abf2f97b92ea5 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo17"
})("display:none;height:150px;width:150px;z-index:-1;position:absolute;top:", (0, $lcnyw.gridSize)() * 4 / (0, $lcnyw.fontSize)(), "em;animation-name:", $9338621abe3237e0$var$kudosButtonAnimationTransformation, ";animation-iteration-count:1;animation-duration:3s;background-image:radial-gradient(\n\t\tcircle,\n\t\tvar(--ds-background-information-pressed, #85B8FF) 0%,\n\t\tvar(--ds-background-discovery-pressed, #B8ACF6) 25%,\n\t\ttransparent 50%\n\t);overflow:hidden;");
const $9338621abe3237e0$export$4a8a956251d4bf6f = (props)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9338621abe3237e0$export$b08abf2f97b92ea5, {
        className: "kudos-blob-animation",
        ...props
    });
const $9338621abe3237e0$export$58517bb1b373a54c = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo16"
})("clip-path:inset(0px 0px 0px 0px round ", (0, $lcnyw.borderRadius)(), "px);position:absolute;top:0;left:0;bottom:0;right:0;");
const $9338621abe3237e0$export$6196a3f52a6944fe = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo15"
})({
    name: "18xp5qc",
    styles: "margin-left:var(--ds-space-100, 8px);&:focus-within .kudos-blob-animation,&:focus .kudos-blob-animation,&:hover .kudos-blob-animation{display:block;}"
});
const $9338621abe3237e0$export$73d695ae27330056 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo14"
})("user-select:none;margin:var(--ds-space-200, 16px) 0 0 0;text-align:right;display:flex;justify-content:flex-end;button,a{position:relative;}button,a,span{margin-left:var(--ds-space-100, 8px);&:first-child{margin-left:var(--ds-space-0, 0px);}}a,button{&:focus{outline-color:", `var(--ds-border-focused, ${(0, $PdmhA.B200)})`, ";outline-offset:var(--ds-border-width, 2px);outline-style:solid;outline-width:var(--ds-border-width, 2px);}}");
const $9338621abe3237e0$export$ff778e5b796745a6 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo13"
})("display:inline-block;width:var(--ds-space-400, 32px);height:var(--ds-space-400, 32px);margin-left:var(--ds-space-100, 8px);button{&:focus{outline-color:", `var(--ds-border-focused, ${(0, $PdmhA.B200)})`, ";outline-offset:var(--ds-border-width, 2px);outline-style:solid;outline-width:var(--ds-border-width, 2px);}}");
const $9338621abe3237e0$export$64ef9b8c11710c47 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo12"
})("display:flex;flex-direction:column;min-height:", (0, $lcnyw.gridSize)() * 17, "px;");
const $9338621abe3237e0$export$35cf684daac137ac = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo11"
})("display:flex;flex-direction:column;margin-left:", (0, $lcnyw.gridSize)() * 14.5, "px;width:", (0, $lcnyw.gridSize)() * 24.5, "px;");
const $9338621abe3237e0$export$2062e7265a95a823 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo10"
})("font-size:", (0, $lcnyw.fontSizeSmall)(), "px;color:", (0, $5PC5M.labelTextColor), ";margin:var(--ds-space-150, 12px) 0 0 0;line-height:16px;");
const $9338621abe3237e0$export$1270e9c1fc39142b = /*#__PURE__*/ (0, $joBf7.default)("h2", {
    target: "e1ebb2vo9"
})("overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:18px;font-weight:400;letter-spacing:normal;color:", (props)=>props.isDisabledAccount ? (0, $5PC5M.headerTextColorInactive) : (0, $5PC5M.headerTextColor), ";margin:", (props)=>$9338621abe3237e0$var$getFullNameMargin(props), ";line-height:", 24 / 18, "em;:first-child{margin:", (props)=>$9338621abe3237e0$var$getFullNameMargin(props), ";}");
const $9338621abe3237e0$export$75180efdd3f4d9c2 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo8"
})({
    name: "m760b1",
    styles: "margin-top:var(--ds-space-200, 16px);text-transform:uppercase;display:block"
});
const $9338621abe3237e0$export$6ebf103500ba5a45 = /*#__PURE__*/ (0, $joBf7.default)($9338621abe3237e0$export$75180efdd3f4d9c2, {
    target: "e1ebb2vo7"
})({
    name: "15oqcei",
    styles: "display:flex;flex-direction:row;flex-wrap:wrap;justify-content:flex-start;margin-top:var(--ds-space-150, 12px);>*{margin-top:var(--ds-space-050, 4px);&:not(:last-child){margin-right:var(--ds-space-050, 4px);}}"
});
const $9338621abe3237e0$export$d6c0e5f211c8d617 = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "e1ebb2vo6"
})("overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:14px;color:", (0, $5PC5M.headerTextColor), ";margin:0 0 var(--ds-space-150, 12px) 0;line-height:", 24 / 14, "em;");
const $9338621abe3237e0$export$4865ffa72a4d5f9 = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "e1ebb2vo5"
})("background:", (0, $5PC5M.appLabelBgColor), ";color:", (0, $5PC5M.appLabelTextColor), ";border-radius:", (0, $lcnyw.borderRadius)(), ";padding:0 var(--ds-space-075, 6px);width:fit-content;font-weight:bold;text-transform:uppercase;font-size:12px;margin:var(--ds-space-050, 4px) 0 var(--ds-space-150, 12px) 0;line-height:", 24 / 14, "em;");
const $9338621abe3237e0$export$a5e06607a5ac6158 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo4"
})("align-items:center;display:flex;height:", (0, $lcnyw.gridSize)() * 12, "px;justify-content:center;position:relative;");
const $9338621abe3237e0$export$8a23e74e5cf3ca41 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo3"
})("position:relative;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-image:linear-gradient(\n\t\tto bottom,\n\t\t", (props)=>props.isDisabledUser ? (0, $5PC5M.headerBgColorDisabledUser) : (0, $5PC5M.headerBgColor), "\n\t\t\t0%,\n\t\t", (props)=>props.isDisabledUser ? (0, $5PC5M.headerBgColorDisabledUser) : (0, $5PC5M.headerBgColor), " 100%\n\t);background-repeat:no-repeat;background-size:100% ", (0, $lcnyw.gridSize)() * 12, "px;box-sizing:content-box;padding:var(--ds-space-300, 24px);box-shadow:", (props)=>props.withoutElevation ? '' : `${`var(--ds-shadow-overlay, ${`0 4px 8px -2px ${0, $PdmhA.N50A}, 0 0 1px ${0, $PdmhA.N60A}`})`}`, ";border-radius:", (props)=>props.withoutElevation ? '' : `${(0, $lcnyw.borderRadius)()}px`, ";overflow:hidden;");
const $9338621abe3237e0$export$138a08882ebf7289 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo2"
})("display:flex;align-items:center;line-height:24px;font-size:", (0, $lcnyw.gridSize)() * 1.5, "px;margin:var(--ds-space-200, 16px) 0 0 0;white-space:nowrap;&+&{margin-top:var(--ds-space-025, 2px);}");
const $9338621abe3237e0$export$79d7d9b2f6a70c70 = /*#__PURE__*/ (0, $joBf7.default)("dt", {
    target: "e1ebb2vo1"
})("display:flex;flex-shrink:0;color:", (0, $5PC5M.labelIconColor), ";width:var(--ds-space-200, 16px);height:var(--ds-space-200, 16px);padding:var(--ds-space-050, 4px);vertical-align:top;svg{width:100%;height:100%;}");
const $9338621abe3237e0$export$b0ec2c767a0e0eab = /*#__PURE__*/ (0, $joBf7.default)("dd", {
    target: "e1ebb2vo0"
})("overflow:hidden;text-overflow:ellipsis;color:", (0, $5PC5M.labelTextColor), ";padding-left:var(--ds-space-050, 4px);margin-inline-start:0;margin-top:0;");

});

parcelRegister("g8EW1", function(module, exports) {

$parcel$export(module.exports, "ACTION_OVERFLOW_THRESHOLD", () => $4d541855ce71e000$export$3e2419a7546ad45e);
$parcel$export(module.exports, "OverflowProfileCardButtons", () => $4d541855ce71e000$export$9d9b53d23c0df7a1);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bbaTG = parcelRequire("bbaTG");

var $6OfWd = parcelRequire("6OfWd");
var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $jG1wZ = parcelRequire("jG1wZ");

var $aCbpp = parcelRequire("aCbpp");

var $kqibQ = parcelRequire("kqibQ");

var $3vXh8 = parcelRequire("3vXh8");
const $4d541855ce71e000$export$3e2419a7546ad45e = 2;
const $4d541855ce71e000$export$9d9b53d23c0df7a1 = (props)=>{
    const intl = (0, $5JgJ2.default)();
    const [, setOpen] = (0, $eUqFw.useState)(false);
    const { actions: actions, onItemClick: onItemClick, fireAnalyticsWithDuration: fireAnalyticsWithDuration } = props;
    const numActions = actions.length + $4d541855ce71e000$export$3e2419a7546ad45e;
    const onOpenChange = (0, $eUqFw.useCallback)(({ isOpen: nextOpen })=>{
        setOpen((prevOpen)=>{
            if (nextOpen && !prevOpen) fireAnalyticsWithDuration((duration)=>(0, $3vXh8.moreActionsClicked)('user', {
                    duration: duration,
                    numActions: numActions
                }));
            return nextOpen;
        });
    }, [
        numActions,
        fireAnalyticsWithDuration
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.OverflowActionButtonsWrapper), {
        "data-testid": "profilecard-actions-overflow"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        onOpenChange: onOpenChange,
        placement: 'bottom-end',
        trigger: ({ triggerRef: triggerRef, isSelected: isSelected, testId: testId, ...providedProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
                type: "button",
                ...providedProps,
                ref: triggerRef,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jG1wZ))), {
                    label: intl.formatMessage((0, $aCbpp.default).profileCardMoreIconLabel)
                })
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, actions.map((action, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
            key: action.id,
            onClick: (event, ...args)=>{
                onItemClick(action, args, event, index);
            },
            href: action.link
        }, action.label)))));
};

});
parcelRegister("6OfWd", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd131b446ad30d0e$export$2e2bcd8739ae039);
/* eslint-disable import/order */ 
var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $6zOB7 = parcelRequire("6zOB7");


var $1lQG9 = parcelRequire("1lQG9");

var $5Q9wj = parcelRequire("5Q9wj");

var $2WwAS = parcelRequire("2WwAS");

var $7PTrT = parcelRequire("7PTrT");

var $86Ndv = parcelRequire("86Ndv");

var $3MV1G = parcelRequire("3MV1G");

var $lcnyw = parcelRequire("lcnyw");

var $dkYal = parcelRequire("dkYal");

var $jiH6M = parcelRequire("jiH6M");

var $7mYCs = parcelRequire("7mYCs");

var $h1Q9j = parcelRequire("h1Q9j");

var $8gwL5 = parcelRequire("8gwL5");
const $cd131b446ad30d0e$var$gridSize = (0, $lcnyw.gridSize)();
const $cd131b446ad30d0e$var$MAX_HEIGHT = `calc(100vh - ${$cd131b446ad30d0e$var$gridSize * 2}px)`;
const $cd131b446ad30d0e$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
const $cd131b446ad30d0e$var$getFallbackPlacements = (placement)=>{
    const placementPieces = placement.split('-');
    const mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        const crossAxis = placementPieces[1];
        return [
            `${mainAxis}`,
            `${mainAxis}-${$cd131b446ad30d0e$var$opposites[crossAxis]}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}-${crossAxis}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}-${$cd131b446ad30d0e$var$opposites[crossAxis]}`,
            'auto'
        ];
    } else return [
        `${mainAxis}-start`,
        `${mainAxis}-end`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}-start`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}-end`,
        `auto`
    ];
};
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ const $cd131b446ad30d0e$var$DropdownMenu = ({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $5Q9wj.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, shouldFlip: shouldFlip = true, shouldRenderToParent: shouldRenderToParent = false, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: zIndex = (0, $lcnyw.layers).modal(), label: label })=>{
    const [isLocalOpen, setLocalIsOpen] = (0, $2WwAS.default)(isOpen, ()=>defaultOpen);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $eUqFw.useState)(false);
    const id = (0, $8gwL5.default)();
    const itemRef = (0, $h1Q9j.default)();
    const fallbackPlacements = (0, $eUqFw.useMemo)(()=>$cd131b446ad30d0e$var$getFallbackPlacements(placement), [
        placement
    ]);
    const handleTriggerClicked = (0, $eUqFw.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    (event)=>{
        const newValue = !isLocalOpen;
        const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef?.current?.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        isLocalOpen,
        setLocalIsOpen
    ]);
    const handleOnClose = (0, $eUqFw.useCallback)((event)=>{
        if (event.key !== 'Escape' && event.key !== 'Tab' && event.target?.closest?.(`[id^=${(0, $8gwL5.PREFIX)}] [aria-haspopup]`)) // Check if it is within dropdown and it is a trigger button
        // if it is a nested dropdown, clicking trigger won't close the dropdown
        // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
        return;
        if (event.key === 'Tab' && event.shiftKey || event.key === 'Escape') requestAnimationFrame(()=>{
            itemRef.current?.focus();
        });
        const newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        onOpenChange,
        setLocalIsOpen,
        itemRef
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $7PTrT.default)();
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $eUqFw.useEffect)(()=>{
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $5Q9wj.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $5Q9wj.default;
        return (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                let isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest(`[id^=${(0, $8gwL5.PREFIX)}] [aria-haspopup]`);
                if (e.key === (0, $54717ce5fa2c74b1$export$a80636c6f41931fe) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $54717ce5fa2c74b1$export$e51a3576c045c8d5) || e.key === (0, $54717ce5fa2c74b1$export$8152f929a25a0ff4)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
	 * The Popup component requires either:
	 * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
	 * or
	 * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
	 *
	 * But not:
	 * - shouldFitContainer={true} and shouldRenderToParent={false}
	 *
	 * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
	 * types are satisfied.
	 */ const conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer
    } : {
        shouldRenderToParent: shouldRenderToParent
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7mYCs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        id: isLocalOpen ? id : undefined,
        shouldFlip: shouldFlip,
        isOpen: isLocalOpen,
        onClose: handleOnClose,
        zIndex: zIndex,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        testId: testId && `${testId}--content`,
        shouldUseCaptureOnOutsideClick: true,
        ...conditionalProps,
        shouldDisableFocusLock: true,
        trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, // DSP-13312 TODO: remove spread props in future major release
        ...rest })=>{
            if (typeof trigger === 'function') return trigger({
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup,
                ...rest,
                ...bindFocus,
                triggerRef: (0, $1lQG9.default)([
                    ref,
                    itemRef
                ]),
                isSelected: isLocalOpen,
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
                ...bindFocus,
                ref: (0, $1lQG9.default)([
                    ref,
                    itemRef
                ]),
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                isSelected: isLocalOpen,
                iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))),
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`,
                "aria-label": label
            }, trigger);
        },
        content: ({ setInitialFocusRef: setInitialFocusRef, update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dkYal.default), {
                onClose: handleOnClose
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jiH6M.default), {
                spacing: spacing,
                maxHeight: $cd131b446ad30d0e$var$MAX_HEIGHT,
                maxWidth: shouldFitContainer ? undefined : 800,
                onClose: handleOnClose,
                onUpdate: update,
                isLoading: isLoading,
                statusLabel: statusLabel,
                setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                autoFocus: autoFocus,
                testId: testId && `${testId}--menu-wrapper`
            }, children))
    }));
};
var $cd131b446ad30d0e$export$2e2bcd8739ae039 = $cd131b446ad30d0e$var$DropdownMenu;

});
/**
 * Character key codes which can be used in keyboard events.
 */ const $54717ce5fa2c74b1$export$390330c10ff2b9a1 = 'ArrowUp';
const $54717ce5fa2c74b1$export$a80636c6f41931fe = 'ArrowDown';
const $54717ce5fa2c74b1$export$4af703091671bc = 'Home';
const $54717ce5fa2c74b1$export$e2bc30913faa5db7 = 'End';
const $54717ce5fa2c74b1$export$10f6869ed0a7d75b = 'Tab';
const $54717ce5fa2c74b1$export$8152f929a25a0ff4 = 'Enter';
const $54717ce5fa2c74b1$export$e51a3576c045c8d5 = 'Space';
const $54717ce5fa2c74b1$export$2bb790b9008907b4 = 'Escape';

parcelRegister("2WwAS", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc974ed9b9ba7adb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $fc974ed9b9ba7adb$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
    const isControlled = propValue !== undefined;
    const [valueState, setValue] = (0, $eUqFw.useState)(getDefaultPropValue);
    const isControlledRef = (0, $eUqFw.useRef)(isControlled);
    (0, $eUqFw.useEffect)(()=>{
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    const value = isControlled ? propValue : valueState;
    const setValueIfUncontrolled = (0, $eUqFw.useCallback)((newValue)=>{
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("7PTrT", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cf74c53325012fd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $2cf74c53325012fd$export$2e2bcd8739ae039() {
    const [isFocused, setIsFocused] = (0, $eUqFw.useState)(false);
    // ensure bindFocus has a stable ref
    const bindFocus = (0, $eUqFw.useRef)({
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    });
    (0, $eUqFw.useEffect)(()=>{
        // handle the case where a component might
        // unmount while being focused.
        return ()=>setIsFocused(false);
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("dkYal", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", () => $cf3cae93cc4408b7$export$f18c1d4fc7326096);
$parcel$export(module.exports, "default", () => $cf3cae93cc4408b7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $5Q9wj = parcelRequire("5Q9wj");

var $eN43R = parcelRequire("eN43R");

var $9wjz6 = parcelRequire("9wjz6");
const $cf3cae93cc4408b7$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    menuItemRefs: [],
    registerRef: (0, $5Q9wj.default)
});
/**
 * Focus manager logic.
 */ const $cf3cae93cc4408b7$var$FocusManager = ({ children: children, onClose: onClose })=>{
    const menuItemRefs = (0, $eUqFw.useRef)([]);
    const registerRef = (0, $eUqFw.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    const { isLayerDisabled: isLayerDisabled } = (0, $eN43R.UNSAFE_useLayering)();
    // Intentionally rebinding on each render
    (0, $eUqFw.useEffect)(()=>{
        return (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: (0, $9wjz6.default)(menuItemRefs.current, isLayerDisabled, onClose)
        });
    });
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cf3cae93cc4408b7$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $cf3cae93cc4408b7$export$2e2bcd8739ae039 = $cf3cae93cc4408b7$var$FocusManager;

});
parcelRegister("9wjz6", function(module, exports) {

$parcel$export(module.exports, "default", () => $66539497081f56cc$export$2e2bcd8739ae039);

const $66539497081f56cc$var$actionMap = {
    [(0, $54717ce5fa2c74b1$export$a80636c6f41931fe)]: 'next',
    [(0, $54717ce5fa2c74b1$export$390330c10ff2b9a1)]: 'prev',
    [(0, $54717ce5fa2c74b1$export$4af703091671bc)]: 'first',
    [(0, $54717ce5fa2c74b1$export$e2bc30913faa5db7)]: 'last'
};
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $66539497081f56cc$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].hasAttribute('disabled');
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $66539497081f56cc$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].hasAttribute('disabled');
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
};
function $66539497081f56cc$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        if (isLayerDisabled()) {
            // if nested dropdown isOpen we need to close on Tab key press
            if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        const action = $66539497081f56cc$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx < refs.length - 1) {
                    const nextFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement?.focus();
                } else {
                    const firstFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, -1);
                    firstFocusableElement?.focus();
                }
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx > 0) {
                    const prevFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement?.focus();
                } else {
                    const lastFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, refs.length);
                    lastFocusableElement?.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, -1);
                nextFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});


parcelRegister("jiH6M", function(module, exports) {

$parcel$export(module.exports, "default", () => $964014f36228d6e8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8PFhw = parcelRequire("8PFhw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");

var $dkYal = parcelRequire("dkYal");

var $fccfd = parcelRequire("fccfd");

var $1g0c9 = parcelRequire("1g0c9");
const $964014f36228d6e8$var$spinnerContainerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    minWidth: '160px',
    padding: 'space.250',
    justifyContent: 'center'
});
const $964014f36228d6e8$var$LoadingIndicator = ({ statusLabel: statusLabel = 'Loading', testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $964014f36228d6e8$var$spinnerContainerStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4Bees.default), {
        size: "small",
        label: statusLabel,
        testId: testId
    }));
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ const $964014f36228d6e8$var$MenuWrapper = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus })=>{
    const { menuItemRefs: menuItemRefs } = (0, $eUqFw.useContext)((0, $dkYal.FocusManagerContext));
    const closeOnMenuItemClick = (e)=>{
        const isTargetMenuItemOrDecendant = menuItemRefs.some((menuItem)=>{
            const isCheckboxOrRadio = (0, $fccfd.default)(menuItem) || (0, $1g0c9.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDecendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $eUqFw.useLayoutEffect)(()=>{
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const firstFocusableRef = menuItemRefs.find((ref)=>!ref.hasAttribute('disabled')) ?? null;
        if (shouldRenderToParent && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef?.focus();
        setInitialFocusRef?.(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8PFhw.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && `${testId}--menu-group`
    }, isLoading ? /*#__PURE__*/ (0, $byn9U.jsx)($964014f36228d6e8$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && `${testId}--loading-indicator`
    }) : children);
};
var $964014f36228d6e8$export$2e2bcd8739ae039 = $964014f36228d6e8$var$MenuWrapper;

});
parcelRegister("fccfd", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cc914649461e3b8$export$2e2bcd8739ae039);
function $2cc914649461e3b8$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("1g0c9", function(module, exports) {

$parcel$export(module.exports, "default", () => $3727e20ee9b5acb1$export$2e2bcd8739ae039);
function $3727e20ee9b5acb1$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});


parcelRegister("7mYCs", function(module, exports) {

$parcel$export(module.exports, "SelectionStoreContext", () => $9b55d88a204a2c6b$export$756f795847463ebd);
$parcel$export(module.exports, "default", () => $9b55d88a204a2c6b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");
const $9b55d88a204a2c6b$export$756f795847463ebd = /*#__PURE__*/ (0, $eUqFw.createContext)({
    setItemState: (0, $5Q9wj.default),
    getItemState: ()=>undefined,
    setGroupState: (0, $5Q9wj.default),
    getGroupState: ()=>({})
});
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ const $9b55d88a204a2c6b$var$SelectionStore = (props)=>{
    const { children: children } = props;
    const store = (0, $eUqFw.useRef)({});
    const context = (0, $eUqFw.useMemo)(()=>({
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group, id)=>{
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: (group, value)=>{
                store.current[group] = value;
            },
            getGroupState: (group)=>{
                return store.current[group] || {};
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9b55d88a204a2c6b$export$756f795847463ebd.Provider, {
        value: context
    }, children);
};
var $9b55d88a204a2c6b$export$2e2bcd8739ae039 = $9b55d88a204a2c6b$var$SelectionStore;

});

parcelRegister("h1Q9j", function(module, exports) {

$parcel$export(module.exports, "default", () => $6def866028b8c887$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dkYal = parcelRequire("dkYal");
// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $6def866028b8c887$var$useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $eUqFw.useContext)((0, $dkYal.FocusManagerContext));
    const itemRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $6def866028b8c887$export$2e2bcd8739ae039 = $6def866028b8c887$var$useRegisterItemWithFocusManager;

});

parcelRegister("8gwL5", function(module, exports) {

$parcel$export(module.exports, "PREFIX", () => $bbafb6080e6e0b27$export$8a682ae47622dbb9);
$parcel$export(module.exports, "default", () => $bbafb6080e6e0b27$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $bbafb6080e6e0b27$export$8a682ae47622dbb9 = 'ds--dropdown--';
const $bbafb6080e6e0b27$var$generateRandomString = ()=>// This string is used only on client side usually triggered after a user interaction.
    // Therefore, so there is no risk of mismatch
    // between server and client generated markup.
    // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    `${$bbafb6080e6e0b27$export$8a682ae47622dbb9}${Math.random().toString(16).substr(2, 8)}`;
function $bbafb6080e6e0b27$export$2e2bcd8739ae039() {
    const cachedId = (0, $eUqFw.useRef)($bbafb6080e6e0b27$var$generateRandomString());
    return cachedId.current;
}

});


parcelRegister("hD6GJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $67738981858b3f25$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1lQG9 = parcelRequire("1lQG9");

var $bULPy = parcelRequire("bULPy");

var $e7PSD = parcelRequire("e7PSD");

var $bo4OB = parcelRequire("bo4OB");

var $h1Q9j = parcelRequire("h1Q9j");
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-item/usage)
 */ const $67738981858b3f25$var$DropdownMenuItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, ...rest }, ref)=>{
    const itemRef = (0, $h1Q9j.default)();
    if (component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e7PSD.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...rest
    }, children);
    else if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        ...rest
    }, children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...rest
    }, children);
});
var $67738981858b3f25$export$2e2bcd8739ae039 = $67738981858b3f25$var$DropdownMenuItem;

});

parcelRegister("fEubG", function(module, exports) {

$parcel$export(module.exports, "default", () => $920365f1041780e0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jFtVs = parcelRequire("jFtVs");

var $8BKky = parcelRequire("8BKky");

var $lmkW0 = parcelRequire("lmkW0");
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ const $920365f1041780e0$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, overrides: overrides, ...rest }, ref)=>{
    const uid = (0, $jFtVs.useUID)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-deprecated-apis
        overrides: overrides,
        ...rest
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lmkW0.default), {
        id: titleId,
        title: title
    }), children);
});
var $920365f1041780e0$export$2e2bcd8739ae039 = $920365f1041780e0$var$DropdownMenuItemGroup;

});
parcelRegister("lmkW0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c8b6b0ed3e98f7b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");

var $4lTFP = parcelRequire("4lTFP");
const $4c8b6b0ed3e98f7b$var$itemHeadingContentHeight = (0, $4lTFP.headingSizes).h100.lineHeight;
const $4c8b6b0ed3e98f7b$var$itemHeadingFontSize = (0, $4lTFP.headingSizes).h100.size;
const $4c8b6b0ed3e98f7b$var$headingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-subtle, ${(0, $PdmhA.N300)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: $4c8b6b0ed3e98f7b$var$itemHeadingFontSize,
    fontWeight: "var(--ds-font-weight-bold, 700)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    lineHeight: $4c8b6b0ed3e98f7b$var$itemHeadingContentHeight / $4c8b6b0ed3e98f7b$var$itemHeadingFontSize,
    paddingBlock: "var(--ds-space-0, 0px)",
    paddingInline: "var(--ds-space-200, 16px)",
    textTransform: 'uppercase'
});
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups
 *
 * @internal
 */ const $4c8b6b0ed3e98f7b$var$GroupTitle = ({ id: id, title: title })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        css: $4c8b6b0ed3e98f7b$var$headingStyles
    }, title);
var $4c8b6b0ed3e98f7b$export$2e2bcd8739ae039 = $4c8b6b0ed3e98f7b$var$GroupTitle;

});



parcelRegister("gXyvb", function(module, exports) {

$parcel$export(module.exports, "ProfileCardDetails", () => $6edf297decc2faf3$export$c0e6870b898eb99d);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $ffiyv = parcelRequire("ffiyv");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $hkN79 = parcelRequire("hkN79");

var $aCbpp = parcelRequire("aCbpp");

var $kqibQ = parcelRequire("kqibQ");
parcelRequire("f8FAx");
var $2XE3d = parcelRequire("2XE3d");

var $4VIvN = parcelRequire("4VIvN");
const $6edf297decc2faf3$var$detailedListWrapperStyles = (0, $1ZAYh.xcss)({
    margin: 'space.0',
    padding: 'space.0'
});
const $6edf297decc2faf3$var$renderName = (nickname, fullName, meta)=>{
    if (!fullName && !nickname) return null;
    const isNicknameRedundant = !nickname || nickname === fullName;
    const shownNickname = ` (${nickname}) `;
    const displayName = isNicknameRedundant ? fullName : `${fullName}${shownNickname}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.FullNameLabel), {
        noMeta: !meta,
        "data-testid": "profilecard-name",
        id: "profilecard-name-label"
    }, displayName);
};
const $6edf297decc2faf3$var$disabledAccountDesc = (statusModifiedDate, disabledAccountMessage, status = 'closed')=>{
    // consumer does not want to use built-in message
    if (disabledAccountMessage) return disabledAccountMessage;
    const date = statusModifiedDate ? new Date(statusModifiedDate * 1000) : null;
    const relativeDateKey = (0, $hkN79.default)(date);
    const msgKey = relativeDateKey ? `${status}AccountDescMsgHasDate${relativeDateKey}` : `${status}AccountDescMsgNoDate`;
    const secondSentence = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $aCbpp.default)[msgKey]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", {
        "data-testid": "profilecard-disabled-account"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $aCbpp.default).generalDescMsgForDisabledUser), " ", secondSentence);
};
const $6edf297decc2faf3$var$CustomLozenges = ({ lozenges: lozenges = [] })=>{
    if (lozenges.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.CustomLozengeContainer), null, lozenges.map(({ text: text, ...otherProps }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
            ...otherProps,
            key: index
        }, text)));
};
const $6edf297decc2faf3$var$BotProfileCardDetails = (props)=>{
    const { fullName: fullName, nickname: nickname } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.DetailsGroup), null, $6edf297decc2faf3$var$renderName(nickname, fullName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.AppTitleLabel), null, "App"));
};
const $6edf297decc2faf3$var$DisabledProfileCardDetails = (props)=>{
    const { companyName: companyName, disabledAccountMessage: disabledAccountMessage, fullName: fullName, hasDisabledAccountLozenge: hasDisabledAccountLozenge = true, nickname: nickname, status: status, statusModifiedDate: statusModifiedDate } = props;
    const name = status === 'inactive' ? fullName || nickname : nickname || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $aCbpp.default).disabledAccountDefaultName);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.DetailsGroup), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.FullNameLabel), {
        noMeta: true,
        isDisabledAccount: true,
        "data-testid": "profilecard-name",
        id: "profilecard-name-label"
    }, name), hasDisabledAccountLozenge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.LozengeWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        appearance: "default",
        isBold: true
    }, status === 'inactive' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $aCbpp.default).inactiveAccountMsg) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $aCbpp.default).closedAccountMsg))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.DisabledInfo), null, $6edf297decc2faf3$var$disabledAccountDesc(statusModifiedDate, disabledAccountMessage, status)), status === 'inactive' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2XE3d.default), {
        icon: "companyName"
    }, companyName));
};
const $6edf297decc2faf3$export$c0e6870b898eb99d = (props)=>{
    const { meta: meta, status: status } = props;
    if (props.isBot) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6edf297decc2faf3$var$BotProfileCardDetails, props);
    if (status === 'inactive' || status === 'closed') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6edf297decc2faf3$var$DisabledProfileCardDetails, {
        ...props,
        status: status
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.DetailsGroup), null, $6edf297decc2faf3$var$renderName(props.nickname, props.fullName, meta), meta && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.JobTitleLabel), null, meta), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6edf297decc2faf3$var$CustomLozenges, {
        lozenges: props.customLozenges
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "dl",
        xcss: $6edf297decc2faf3$var$detailedListWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2XE3d.default), {
        icon: "email"
    }, props.email), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2XE3d.default), {
        icon: "time"
    }, props.timestring), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2XE3d.default), {
        icon: "companyName"
    }, props.companyName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2XE3d.default), {
        icon: "location"
    }, props.location)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4VIvN.default), {
        reportingLines: props.reportingLines,
        reportingLinesProfileUrl: props.reportingLinesProfileUrl,
        onReportingLinesClick: props.onReportingLinesClick,
        fireAnalyticsWithDuration: props.fireAnalyticsWithDuration
    }));
};

});
parcelRegister("hkN79", function(module, exports) {

$parcel$export(module.exports, "default", () => $7be3e2500aef7a3b$export$2e2bcd8739ae039);

var $1raUW = parcelRequire("1raUW");

var $7CyDX = parcelRequire("7CyDX");

var $hX17M = parcelRequire("hX17M");

var $7ueqz = parcelRequire("7ueqz");
function $7be3e2500aef7a3b$export$c03bb0116ee09d4b(date, today = new Date()) {
    return !!date.getTime && (0, $7ueqz.default)(date) && date.getTime() <= today.getTime();
}
function $7be3e2500aef7a3b$export$2e2bcd8739ae039(date, today = new Date()) {
    if (!date || !$7be3e2500aef7a3b$export$c03bb0116ee09d4b(date, today)) return null;
    if ((0, $hX17M.default)(date)) return 'ThisWeek';
    if ((0, $7CyDX.default)(date)) return 'ThisMonth';
    if (date.getFullYear() === today.getFullYear() && date.getMonth() === today.getMonth() - 1) return 'LastMonth';
    const diffInMonths = (0, $1raUW.default)(today, date);
    if (diffInMonths < 6) return 'AFewMonths';
    if (diffInMonths <= 12) return 'SeveralMonths';
    return 'MoreThanAYear';
}

});

parcelRegister("f8FAx", function(module, exports) {

$parcel$export(module.exports, "IconLabel", () => (parcelRequire("2XE3d")).default);

var $2XE3d = parcelRequire("2XE3d");

});
parcelRegister("2XE3d", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b4197d6aec28d50$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8IVhP = parcelRequire("8IVhP");

var $izGRi = parcelRequire("izGRi");

var $bK40S = parcelRequire("bK40S");

var $k6W9R = parcelRequire("k6W9R");

var $kqibQ = parcelRequire("kqibQ");
const $3b4197d6aec28d50$var$icons = {
    location: (0, (/*@__PURE__*/$parcel$interopDefault($izGRi))),
    time: (0, (/*@__PURE__*/$parcel$interopDefault($k6W9R))),
    email: (0, (/*@__PURE__*/$parcel$interopDefault($8IVhP))),
    companyName: (0, (/*@__PURE__*/$parcel$interopDefault($bK40S)))
};
class $3b4197d6aec28d50$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    static{
        this.defaultProps = {
            icon: ''
        };
    }
    render() {
        if (!this.props.children) return null;
        // @ts-ignore
        const IconElement = this.props.icon && $3b4197d6aec28d50$var$icons[this.props.icon];
        const displayIcon = IconElement ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(IconElement, {
            label: `${this.props.icon}`,
            size: "small"
        }) : null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.DetailsLabel), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.DetailsLabelIcon), null, displayIcon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.DetailsLabelText), null, this.props.children));
    }
}

});
parcelRegister("8IVhP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $659edeb603307d4b$var$_react = $659edeb603307d4b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $659edeb603307d4b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $659edeb603307d4b$var$EmailIcon = (props)=>/*#__PURE__*/ $659edeb603307d4b$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M5 7v10h14V7H5zm14-2c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2h14z" fill-rule="nonzero"/><path d="M5.498 6.5H3.124c.149.44.399.854.75 1.205l5.882 5.881a3.117 3.117 0 004.41 0l5.882-5.881c.35-.351.6-.765.749-1.205h-2.373l-5.672 5.672a1.119 1.119 0 01-1.583 0L5.498 6.5z"/></g></svg>`
    }, props));
$659edeb603307d4b$var$EmailIcon.displayName = 'EmailIcon';
var $659edeb603307d4b$var$_default = $659edeb603307d4b$var$EmailIcon;
module.exports.default = $659edeb603307d4b$var$_default;

});

parcelRegister("izGRi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d85cbdb8c81e089a$var$_react = $d85cbdb8c81e089a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $d85cbdb8c81e089a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d85cbdb8c81e089a$var$LocationIcon = (props)=>/*#__PURE__*/ $d85cbdb8c81e089a$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M12 21c-2.28 0-6-8.686-6-12a6 6 0 1112 0c0 3.314-3.72 12-6 12zm0-9a2.912 2.912 0 100-5.824A2.912 2.912 0 0012 12z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$d85cbdb8c81e089a$var$LocationIcon.displayName = 'LocationIcon';
var $d85cbdb8c81e089a$var$_default = $d85cbdb8c81e089a$var$LocationIcon;
module.exports.default = $d85cbdb8c81e089a$var$_default;

});

parcelRegister("bK40S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $88c71a7d3deb32d8$var$_react = $88c71a7d3deb32d8$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $88c71a7d3deb32d8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $88c71a7d3deb32d8$var$OfficeBuildingIcon = (props)=>/*#__PURE__*/ $88c71a7d3deb32d8$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M8 6H5.009C3.902 6 3 6.962 3 8.15v10.7C3 20.04 3.9 21 5.009 21h5.487H8v-2.145c-1.616-.001-3-.003-3-.004 0 0 .005-10.708.009-10.708L8 8.144V6z" fill-rule="nonzero"/><path d="M12 7h2v2h-2zm-6 3h2v2H6zm0 3h2v2H6zm6-3h2v2h-2zm0 3h2v2h-2zm2 3h2v3h-2zm2-9h2v2h-2zm0 3h2v2h-2zm0 3h2v2h-2z"/><path d="M18.991 19C18.998 19 19 4.995 19 4.995c0 .006-7.991.005-7.991.005C11.002 5 11 19 11 19h7.991zM9 4.995C9 3.893 9.902 3 11.009 3h7.982C20.101 3 21 3.893 21 4.995v14.01A2.004 2.004 0 0118.991 21H9V4.995z" fill-rule="nonzero"/></g></svg>`
    }, props));
$88c71a7d3deb32d8$var$OfficeBuildingIcon.displayName = 'OfficeBuildingIcon';
var $88c71a7d3deb32d8$var$_default = $88c71a7d3deb32d8$var$OfficeBuildingIcon;
module.exports.default = $88c71a7d3deb32d8$var$_default;

});



parcelRegister("4VIvN", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea078b29528825bd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $iJlfe = parcelRequire("iJlfe");

var $4XQdE = parcelRequire("4XQdE");

var $7u4fN = parcelRequire("7u4fN");

var $aCbpp = parcelRequire("aCbpp");

var $82aoD = parcelRequire("82aoD");

var $3vXh8 = parcelRequire("3vXh8");
function $ea078b29528825bd$var$getProfileHref(userId, profileUrl) {
    return profileUrl ? profileUrl + userId : undefined;
}
const $ea078b29528825bd$var$ReportingLinesDetails = (props)=>{
    const { fireAnalyticsWithDuration: fireAnalyticsWithDuration, reportingLines: reportingLines = {}, reportingLinesProfileUrl: reportingLinesProfileUrl, onReportingLinesClick: onReportingLinesClick } = props;
    const { managers: managers = [], reports: reports = [] } = reportingLines;
    const manager = managers.length >= 1 ? managers[0] : undefined;
    const hasReports = reports.length > 0;
    const getReportingLinesOnClick = (user, userType)=>onReportingLinesClick ? ()=>{
            fireAnalyticsWithDuration((duration)=>(0, $3vXh8.reportingLinesClicked)({
                    duration: duration,
                    userType: userType
                }));
            onReportingLinesClick(user);
        } : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, manager && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $82aoD.ReportingLinesSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $82aoD.ReportingLinesHeading), {
        style: {
            marginBottom: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $aCbpp.default).managerSectionHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $82aoD.OffsetWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        spacing: "none",
        href: $ea078b29528825bd$var$getProfileHref(manager.accountIdentifier, reportingLinesProfileUrl),
        onClick: getReportingLinesOnClick(manager, 'manager'),
        isDisabled: !onReportingLinesClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $82aoD.ManagerSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        size: "xsmall",
        src: manager.pii?.picture
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $82aoD.ManagerName), null, manager.pii?.name))))), hasReports && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $82aoD.ReportingLinesSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $82aoD.ReportingLinesHeading), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $aCbpp.default).directReportsSectionHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4XQdE.default), {
        appearance: "stack",
        size: "small",
        data: reports.map((member)=>{
            return {
                key: member.accountIdentifier,
                name: member.pii?.name || '',
                src: member.pii?.picture,
                href: $ea078b29528825bd$var$getProfileHref(member.accountIdentifier, reportingLinesProfileUrl),
                onClick: getReportingLinesOnClick(member, 'direct-report')
            };
        }),
        maxCount: 5,
        testId: "profilecard-reports-avatar-group"
    })));
};
var $ea078b29528825bd$export$2e2bcd8739ae039 = $ea078b29528825bd$var$ReportingLinesDetails;

});
parcelRegister("4XQdE", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b6346b768779c72$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $74BVL = parcelRequire("74BVL");

var $iJlfe = parcelRequire("iJlfe");


var $5Q9wj = parcelRequire("5Q9wj");

var $7PTrT = parcelRequire("7PTrT");

var $8BKky = parcelRequire("8BKky");

var $3MV1G = parcelRequire("3MV1G");

var $lcnyw = parcelRequire("lcnyw");

var $8cU5f = parcelRequire("8cU5f");

var $hCcWD = parcelRequire("hCcWD");

var $3Czko = parcelRequire("3Czko");

var $6cUPN = parcelRequire("6cUPN");

var $h5NqH = parcelRequire("h5NqH");

var $5TioN = parcelRequire("5TioN");

var $33ZPs = parcelRequire("33ZPs");

var $bLnyK = parcelRequire("bLnyK");
const $3b6346b768779c72$var$MAX_COUNT = {
    grid: 11,
    stack: 5
};
function $3b6346b768779c72$var$getOverrides(overrides) {
    return {
        AvatarGroupItem: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $byn9U.jsx)(Component, {
                    ...props,
                    key: (0, $bLnyK.composeUniqueKey)(props.avatar, index)
                }),
            ...overrides && overrides.AvatarGroupItem
        },
        Avatar: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $byn9U.jsx)(Component, {
                    ...props,
                    key: (0, $bLnyK.composeUniqueKey)(props, index)
                }),
            ...overrides && overrides.Avatar
        }
    };
}
/**
 * __Avatar group__
 *
 * An avatar group displays a number of avatars grouped together in a stack or grid.
 *
 * - [Examples](https://atlassian.design/components/avatar-group/examples)
 * - [Code](https://atlassian.design/components/avatar-group/code)
 * - [Usage](https://atlassian.design/components/avatar-group/usage)
 */ const $3b6346b768779c72$var$AvatarGroup = ({ appearance: appearance = 'stack', avatar: avatar = (0, $iJlfe.default), borderColor: borderColor, boundariesElement: boundariesElement, data: data, isTooltipDisabled: isTooltipDisabled, maxCount: maxCount, onAvatarClick: onAvatarClick, onMoreClick: onMoreClick, overrides: overrides, showMoreButtonProps: showMoreButtonProps = {}, size: size = 'medium', testId: testId, label: label = 'avatar group', tooltipPosition: tooltipPosition = 'bottom', shouldPopupRenderToParent: shouldPopupRenderToParent = false })=>{
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $eUqFw.useState)(false);
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const onClose = (0, $eUqFw.useCallback)(()=>setIsOpen(false), []);
    const handleTriggerClicked = (0, $eUqFw.useCallback)((event)=>{
        const { clientX: clientX, clientY: clientY, type: type } = event;
        // Hitting enter/space is registered as a click with both clientX and clientY === 0
        if (type === 'keydown' || clientX === 0 || clientY === 0) setTriggeredUsingKeyboard(true);
        setIsOpen((isOpen)=>!isOpen);
    }, []);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $7PTrT.default)();
    // When a trigger is focused, we want to open the popup
    // the user presses the DownArrow
    (0, $eUqFw.useEffect)(()=>{
        // Set initial value if popup is closed
        if (!isOpen) setTriggeredUsingKeyboard(false);
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $5Q9wj.default;
        // Being safe: we don't want to open the popup if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isOpen) return 0, $5Q9wj.default;
        (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $54717ce5fa2c74b1$export$a80636c6f41931fe)) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                }
            }
        });
        const unbind = ()=>{
            (0, $74BVL.bind)(window, {
                type: 'keydown',
                listener: function openOnKeyDown(e) {
                    if (e.key === (0, $54717ce5fa2c74b1$export$a80636c6f41931fe)) {
                        // prevent page scroll
                        e.preventDefault();
                        handleTriggerClicked(e);
                    }
                }
            });
        };
        return unbind;
    }, [
        isFocused,
        isOpen,
        handleTriggerClicked
    ]);
    function renderMoreDropdown(max, total) {
        if (total <= max) return null;
        const renderMoreButton = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $5TioN.default), {
                buttonProps: showMoreButtonProps,
                borderColor: borderColor,
                count: total - max,
                size: size,
                testId: testId && `${testId}--overflow-menu--trigger`,
                isActive: isOpen,
                ...props
            });
        // bail if the consumer wants to handle onClick
        if (typeof onMoreClick === 'function') return renderMoreButton({
            onClick: onMoreClick
        });
        // split boundariesElement into `boundary` and `rootBoundary` props for Popup
        const boundary = boundariesElement === 'scrollParent' ? 'clippingParents' : undefined;
        const rootBoundary = (()=>{
            if (boundariesElement === 'scrollParent') return undefined;
            return boundariesElement === 'window' ? 'document' : 'viewport';
        })();
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $3MV1G.default), {
            isOpen: isOpen,
            onClose: onClose,
            placement: "bottom-end",
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: true,
            zIndex: (0, $lcnyw.layers).modal(),
            shouldRenderToParent: shouldPopupRenderToParent,
            content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $6cUPN.default), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $h5NqH.default), {
                    onClick: (e)=>e.stopPropagation(),
                    minWidth: 250,
                    maxHeight: 300,
                    setInitialFocusRef: isTriggeredUsingKeyboard ? setInitialFocusRef : undefined
                }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8BKky.default), null, data.slice(max).map((avatar, index)=>$3b6346b768779c72$var$getOverrides(overrides).AvatarGroupItem.render((0, $hCcWD.default), {
                        avatar: avatar,
                        onAvatarClick: onAvatarClick,
                        testId: testId && `${testId}--avatar-group-item-${index + max}`,
                        index: index + max
                    }, // This index holds the true index,
                    // adding up the index of non-overflowed avatars and overflowed avatars.
                    index + max))))),
            trigger: (triggerProps)=>renderMoreButton({
                    ...triggerProps,
                    ...bindFocus,
                    onClick: handleTriggerClicked
                }),
            testId: testId && `${testId}--overflow-menu`
        });
    }
    const max = maxCount === undefined || maxCount === 0 ? $3b6346b768779c72$var$MAX_COUNT[appearance] : maxCount;
    const total = data.length;
    const maxAvatar = total > max ? max - 1 : max;
    const Group = appearance === 'stack' ? (0, $33ZPs.default) : (0, $3Czko.default);
    return /*#__PURE__*/ (0, $byn9U.jsx)(Group, {
        testId: testId && `${testId}--avatar-group`,
        "aria-label": label
    }, data.slice(0, maxAvatar).map((avatarData, idx)=>{
        const callback = avatarData.onClick || onAvatarClick;
        const finalAvatar = $3b6346b768779c72$var$getOverrides(overrides).Avatar.render(avatar, {
            ...avatarData,
            size: size,
            borderColor: borderColor || avatarData.borderColor,
            testId: testId && `${testId}--avatar-${idx}`,
            onClick: callback ? (event, analyticsEvent)=>{
                callback(event, analyticsEvent, idx);
            } : undefined,
            stackIndex: max - idx
        }, idx);
        return !isTooltipDisabled && !avatarData.isDisabled ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $8cU5f.default), {
            key: (0, $bLnyK.composeUniqueKey)(avatarData, idx),
            content: avatarData.name,
            testId: testId && `${testId}--tooltip-${idx}`,
            position: tooltipPosition
        }, finalAvatar) : finalAvatar;
    }), renderMoreDropdown(+maxAvatar, total));
};
var $3b6346b768779c72$export$2e2bcd8739ae039 = $3b6346b768779c72$var$AvatarGroup;

});
parcelRegister("hCcWD", function(module, exports) {

$parcel$export(module.exports, "default", () => $19ec5414b121adc7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");

var $1lQG9 = parcelRequire("1lQG9");

var $bULPy = parcelRequire("bULPy");
var $e7PSD = parcelRequire("e7PSD");
var $bo4OB = parcelRequire("bo4OB");

var $jXJS5 = parcelRequire("jXJS5");
const $19ec5414b121adc7$var$AvatarGroupItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { avatar: avatar, onAvatarClick: onAvatarClick, testId: testId, index: index } = props;
    const { href: href, onClick: onClick, ...rest } = avatar;
    const itemRef = (0, $jXJS5.default)();
    const CustomComponent = ({ children: children, ...props })=>{
        return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
            type: "button",
            ...props
        }, children));
    };
    const AvatarIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        ...rest,
        testId: testId && `${testId}--avatar`,
        borderColor: "transparent",
        size: "small",
        name: ""
    });
    // onClick handler provided with avatar data takes precedence, same as with the normal avatar item
    const callback = onClick || onAvatarClick;
    if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        href: href,
        target: avatar.target,
        rel: avatar.target === '_blank' ? 'noopener noreferrer' : undefined,
        iconBefore: AvatarIcon,
        testId: testId,
        onClick: (event)=>callback && callback(event, undefined, index)
    }, avatar.name);
    if (typeof callback === 'function') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        onClick: (event)=>callback && callback(event, undefined, index),
        iconBefore: AvatarIcon,
        testId: testId
    }, avatar.name);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e7PSD.default), {
        iconBefore: AvatarIcon,
        component: CustomComponent,
        testId: testId
    }, avatar.name);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$19ec5414b121adc7$export$2e2bcd8739ae039 = $19ec5414b121adc7$var$AvatarGroupItem;

});
parcelRegister("jXJS5", function(module, exports) {

$parcel$export(module.exports, "default", () => $47a822a3bf76dc75$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6cUPN = parcelRequire("6cUPN");
// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $47a822a3bf76dc75$var$useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $eUqFw.useContext)((0, $6cUPN.FocusManagerContext));
    const itemRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $47a822a3bf76dc75$export$2e2bcd8739ae039 = $47a822a3bf76dc75$var$useRegisterItemWithFocusManager;

});
parcelRegister("6cUPN", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", () => $c9e49b704731182e$export$f18c1d4fc7326096);
$parcel$export(module.exports, "default", () => $c9e49b704731182e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $5Q9wj = parcelRequire("5Q9wj");

var $HPlWp = parcelRequire("HPlWp");
const $c9e49b704731182e$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    menuItemRefs: [],
    registerRef: (0, $5Q9wj.default)
});
/**
 * Focus manager logic
 */ const $c9e49b704731182e$var$FocusManager = ({ children: children })=>{
    const menuItemRefs = (0, $eUqFw.useRef)([]);
    const registerRef = (0, $eUqFw.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    // set focus and intentionally rebinding listener and clean up listener on each render
    (0, $eUqFw.useEffect)(()=>{
        (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: (0, $HPlWp.default)(menuItemRefs.current)
        });
        const unbind = ()=>{
            (0, $74BVL.bind)(window, {
                type: 'keydown',
                listener: (0, $HPlWp.default)(menuItemRefs.current)
            });
        };
        return unbind;
    }, []);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c9e49b704731182e$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $c9e49b704731182e$export$2e2bcd8739ae039 = $c9e49b704731182e$var$FocusManager;

});
parcelRegister("HPlWp", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2eeb0b24006473e$export$2e2bcd8739ae039);

const $b2eeb0b24006473e$var$actionMap = {
    [(0, $54717ce5fa2c74b1$export$a80636c6f41931fe)]: 'next',
    [(0, $54717ce5fa2c74b1$export$390330c10ff2b9a1)]: 'prev',
    [(0, $54717ce5fa2c74b1$export$4af703091671bc)]: 'first',
    [(0, $54717ce5fa2c74b1$export$e2bc30913faa5db7)]: 'last'
};
/**
 * currentFocusedIdx + 1 will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $b2eeb0b24006473e$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
};
/**
 * currentFocusedIdx - 1 will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $b2eeb0b24006473e$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
};
function $b2eeb0b24006473e$export$2e2bcd8739ae039(refs) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        const action = $b2eeb0b24006473e$var$actionMap[e.key];
        switch(action){
            case 'next':
                if (currentFocusedIdx < refs.length - 1) {
                    e.preventDefault();
                    const nextFocusableElement = $b2eeb0b24006473e$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement && nextFocusableElement.focus();
                }
                break;
            case 'prev':
                if (currentFocusedIdx > 0) {
                    e.preventDefault();
                    const prevFocusableElement = $b2eeb0b24006473e$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement && prevFocusableElement.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $b2eeb0b24006473e$var$getNextFocusableElement(refs, -1);
                nextFocusableElement && nextFocusableElement.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $b2eeb0b24006473e$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement && prevFocusableElement.focus();
                break;
            default:
                return;
        }
    };
}

});




parcelRegister("3Czko", function(module, exports) {

$parcel$export(module.exports, "default", () => $f319fa8ea8cddd21$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");
function $f319fa8ea8cddd21$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f319fa8ea8cddd21$var$gutter = "var(--ds-space-negative-050, -4px)";
const $f319fa8ea8cddd21$var$listStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    margin: "var(--ds-space-0, 0px)",
    padding: "var(--ds-space-0, 0px)",
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
    listStyleType: 'none !important',
    marginInlineEnd: $f319fa8ea8cddd21$var$gutter,
    marginInlineStart: $f319fa8ea8cddd21$var$gutter
});
const $f319fa8ea8cddd21$var$listItemStyles = {
    name: "3unxte",
    styles: "margin:var(--ds-space-0, 0px);margin-block-end:var(--ds-space-100, 8px);padding-inline-end:var(--ds-space-050, 4px);padding-inline-start:var(--ds-space-050, 4px)"
};
const $f319fa8ea8cddd21$var$Grid = ({ children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ (0, $byn9U.jsx)("ul", {
        "data-testid": testId,
        "aria-label": label,
        css: $f319fa8ea8cddd21$var$listStyles
    }, (0, $eUqFw.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $byn9U.jsx)("li", {
            css: $f319fa8ea8cddd21$var$listItemStyles
        }, child)));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f319fa8ea8cddd21$export$2e2bcd8739ae039 = $f319fa8ea8cddd21$var$Grid;

});

parcelRegister("h5NqH", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ffca550571fe4d8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8PFhw = parcelRequire("8PFhw");

var $6cUPN = parcelRequire("6cUPN");
/**
 * It sets focus to the first avatar when popup is open.
 */ const $4ffca550571fe4d8$var$PopupAvatarGroup = ({ maxWidth: maxWidth = 800, minWidth: minWidth = 320, setInitialFocusRef: setInitialFocusRef, ...rest })=>{
    const { menuItemRefs: menuItemRefs } = (0, $eUqFw.useContext)((0, $6cUPN.FocusManagerContext));
    (0, $eUqFw.useEffect)(()=>{
        setInitialFocusRef?.(menuItemRefs[0]);
    }, [
        menuItemRefs,
        setInitialFocusRef
    ]);
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)((0, $8PFhw.default), {
        maxWidth: maxWidth,
        minWidth: minWidth,
        ...rest
    }));
};
var $4ffca550571fe4d8$export$2e2bcd8739ae039 = $4ffca550571fe4d8$var$PopupAvatarGroup;

});

parcelRegister("5TioN", function(module, exports) {

$parcel$export(module.exports, "default", () => $80bc7348cf05a7b7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $eri7S = parcelRequire("eri7S");
var $iJlfe = parcelRequire("iJlfe");

var $XHGTv = parcelRequire("XHGTv");

var $PdmhA = parcelRequire("PdmhA");
const $80bc7348cf05a7b7$var$buttonSizes = {
    xsmall: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    medium: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    xlarge: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    xxlarge: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
const $80bc7348cf05a7b7$var$buttonActiveStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&': {
        backgroundColor: `var(--ds-background-selected, ${(0, $PdmhA.B50)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        boxShadow: `0 0 0 ${(0, $eri7S.BORDER_WIDTH)}px ${`var(--ds-border-selected, ${(0, $PdmhA.B300)})`}`,
        color: `var(--ds-text-selected, ${(0, $PdmhA.B400)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transform: `scale(${(0, $eri7S.ACTIVE_SCALE_FACTOR)})`,
        '&:hover': {
            backgroundColor: `var(--ds-background-selected-hovered, ${(0, $PdmhA.N30)})`,
            color: `var(--ds-text-selected, ${(0, $PdmhA.N500)})`
        },
        '&:active': {
            backgroundColor: `var(--ds-background-selected-pressed, ${(0, $PdmhA.B50)})`,
            color: `var(--ds-text-selected, ${(0, $PdmhA.B400)})`
        }
    }
});
const $80bc7348cf05a7b7$var$buttonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&': {
        backgroundColor: `var(--ds-background-neutral, ${(0, $PdmhA.N20)})`,
        color: `var(--ds-text, ${(0, $PdmhA.N500)})`,
        '&:hover': {
            backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $PdmhA.N30)})`,
            color: `var(--ds-text, ${(0, $PdmhA.N500)})`
        },
        '&:active': {
            backgroundColor: `var(--ds-background-neutral-pressed, ${(0, $PdmhA.B50)})`,
            color: `var(--ds-text, ${(0, $PdmhA.B400)})`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&::after': {
            display: 'none'
        }
    }
});
const $80bc7348cf05a7b7$var$MAX_DISPLAY_COUNT = 99;
const $80bc7348cf05a7b7$var$MoreIndicator = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ appearance: appearance = 'circle', borderColor: borderColor = (0, $XHGTv.fg)('platform-component-visual-refresh') ? "var(--ds-surface, #FFFFFF)" : `var(--ds-border-inverse, ${0, $PdmhA.N0})`, size: size = 'medium', count: count = 0, testId: testId, onClick: onClick, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, buttonProps: buttonProps = {}, isActive: isActive }, ref)=>{
    const onClickHander = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        if (buttonProps.onClick) buttonProps.onClick(event);
        onClick(event, analyticsEvent);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        buttonProps.onClick,
        onClick
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $iJlfe.default), {
        appearance: appearance,
        size: size,
        borderColor: borderColor,
        ref: ref,
        onClick: onClickHander
    }, ({ testId: _, className: className, ref: ref, ...props })=>// eslint-disable-next-line @atlaskit/design-system/no-html-button
        /*#__PURE__*/ (0, $byn9U.jsx)("button", {
            type: "submit",
            ...buttonProps,
            ...props,
            ref: ref,
            "data-testid": testId,
            "aria-controls": ariaControls,
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHaspopup,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                font: $80bc7348cf05a7b7$var$buttonSizes[size]
            },
            css: [
                $80bc7348cf05a7b7$var$buttonStyles,
                isActive && $80bc7348cf05a7b7$var$buttonActiveStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className
        }, "+", count > $80bc7348cf05a7b7$var$MAX_DISPLAY_COUNT ? $80bc7348cf05a7b7$var$MAX_DISPLAY_COUNT : count));
});
$80bc7348cf05a7b7$var$MoreIndicator.displayName = 'MoreIndicator';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$80bc7348cf05a7b7$export$2e2bcd8739ae039 = $80bc7348cf05a7b7$var$MoreIndicator;

});

parcelRegister("33ZPs", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e31b31f1a588aba$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $eri7S = parcelRequire("eri7S");

var $lcnyw = parcelRequire("lcnyw");
const $9e31b31f1a588aba$var$gutter = (0, $eri7S.BORDER_WIDTH) * 2 + (0, $lcnyw.gridSize)() / 2;
const $9e31b31f1a588aba$var$listStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    margin: "var(--ds-space-0, 0px)",
    padding: "var(--ds-space-0, 0px)",
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    listStyleType: 'none !important',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineEnd: $9e31b31f1a588aba$var$gutter
});
const $9e31b31f1a588aba$var$listItemStyles = /*#__PURE__*/ (0, $byn9U.css)({
    margin: "var(--ds-space-0, 0px)",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineEnd: -$9e31b31f1a588aba$var$gutter
});
const $9e31b31f1a588aba$var$Stack = ({ children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ (0, $byn9U.jsx)("ul", {
        "data-testid": testId,
        "aria-label": label,
        css: $9e31b31f1a588aba$var$listStyles
    }, (0, $eUqFw.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $byn9U.jsx)("li", {
            css: $9e31b31f1a588aba$var$listItemStyles
        }, child)));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9e31b31f1a588aba$export$2e2bcd8739ae039 = $9e31b31f1a588aba$var$Stack;

});

parcelRegister("bLnyK", function(module, exports) {

$parcel$export(module.exports, "composeUniqueKey", () => $009108df95df64ca$export$b067756944994c79);
const $009108df95df64ca$export$b067756944994c79 = (props, index)=>{
    if (props.key) return props.key;
    return index;
};

});


parcelRegister("82aoD", function(module, exports) {

$parcel$export(module.exports, "ReportingLinesSection", () => $04441ecf0f4a2833$export$ae48ddd79a45b949);
$parcel$export(module.exports, "ReportingLinesHeading", () => $04441ecf0f4a2833$export$abdd342d30bb5b5f);
$parcel$export(module.exports, "ManagerSection", () => $04441ecf0f4a2833$export$2992b481dad9fb03);
$parcel$export(module.exports, "ManagerName", () => $04441ecf0f4a2833$export$98f8ec89e658b052);
$parcel$export(module.exports, "OffsetWrapper", () => $04441ecf0f4a2833$export$56eae56612ce5f3);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lcnyw = parcelRequire("lcnyw");

var $5PC5M = parcelRequire("5PC5M");

var $joBf7 = parcelRequire("joBf7");
function $04441ecf0f4a2833$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $04441ecf0f4a2833$export$ae48ddd79a45b949 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e11fux8a4"
})({
    name: "1m5erzj",
    styles: "margin-left:var(--ds-space-050, 4px);margin-top:var(--ds-space-100, 8px)"
});
const $04441ecf0f4a2833$export$abdd342d30bb5b5f = /*#__PURE__*/ (0, $joBf7.default)("h3", {
    target: "e11fux8a3"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $5PC5M.appLabelTextColor),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: `${(0, $lcnyw.gridSize)() * 1.5}px`,
    fontWeight: 600,
    marginBottom: "var(--ds-space-100, 8px)"
});
const $04441ecf0f4a2833$export$2992b481dad9fb03 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e11fux8a2"
})({
    display: 'flex',
    alignItems: 'center',
    margin: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-050, 4px)"}`
});
const $04441ecf0f4a2833$export$98f8ec89e658b052 = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "e11fux8a1"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: `${(0, $lcnyw.gridSize)() * 1.5}px`,
    marginLeft: "var(--ds-space-100, 8px)"
});
const $04441ecf0f4a2833$export$56eae56612ce5f3 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e11fux8a0"
})({
    name: "ysolxb",
    styles: "margin-top:var(--ds-space-050, 4px);margin-left:var(--ds-space-negative-050, -4px)"
});

});




parcelRegister("6aOtB", function(module, exports) {

$parcel$export(module.exports, "default", () => $184c4f94fc0b4764$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2jDha = parcelRequire("2jDha");

var $dx7Op = parcelRequire("dx7Op");
var $btCBO = parcelRequire("btCBO");

var $5Jx7I = parcelRequire("5Jx7I");

var $kqibQ = parcelRequire("kqibQ");

var $3vXh8 = parcelRequire("3vXh8");
parcelRequire("iINHb");
var $4ga2m = parcelRequire("4ga2m");

var $ehM5E = parcelRequire("ehM5E");

var $ijWKk = parcelRequire("ijWKk");
class $184c4f94fc0b4764$var$ProfileCardResourced extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    static{
        this.defaultProps = {
            actions: []
        };
    }
    componentDidMount() {
        this._isMounted = true;
        this.clientFetchProfile();
    }
    componentDidUpdate(prevProps) {
        const { userId: userId, cloudId: cloudId, resourceClient: resourceClient } = this.props;
        if (userId !== prevProps.userId || cloudId !== prevProps.cloudId || resourceClient !== prevProps.resourceClient) this.setState({
            isLoading: undefined
        }, this.clientFetchProfile);
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    handleClientSuccess(profileData, reportingLinesData, shouldShowGiveKudos) {
        if (!this._isMounted) return;
        this.setState({
            isLoading: false,
            hasError: false,
            data: profileData,
            reportingLinesData: reportingLinesData,
            isKudosEnabled: shouldShowGiveKudos
        });
    }
    handleClientError(err) {
        if (!this._isMounted) return;
        this.setState({
            isLoading: false,
            hasError: true,
            error: err
        });
    }
    render() {
        const { isLoading: isLoading, hasError: hasError, error: error, data: data, reportingLinesData: reportingLinesData, isKudosEnabled: isKudosEnabled } = this.state;
        const { onReportingLinesClick: onReportingLinesClick, cloudId: cloudId, userId: userId, addFlag: addFlag } = this.props;
        const isFetchingOrNotStartToFetchYet = isLoading === true || isLoading === undefined;
        if (isFetchingOrNotStartToFetchYet) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.CardWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ijWKk.default), {
            fireAnalytics: this.fireAnalytics
        }));
        else if (hasError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.CardWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ga2m.default), {
            errorType: error,
            reload: this.clientFetchProfile,
            fireAnalytics: this.fireAnalytics
        }));
        const newProps = {
            hasError: hasError,
            errorType: error,
            clientFetchProfile: this.clientFetchProfile,
            reportingLines: reportingLinesData,
            onReportingLinesClick: onReportingLinesClick,
            cloudId: cloudId,
            userId: userId,
            addFlag: addFlag,
            ...data,
            isKudosEnabled: isKudosEnabled,
            teamCentralBaseUrl: this.props.resourceClient.getTeamCentralBaseUrl(),
            openKudosDrawer: this.openKudosDrawer
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.CardWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, isKudosEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dx7Op.GiveKudosLauncherLazy), {
            isOpen: this.state.kudosDrawerOpen,
            recipient: {
                type: (0, $btCBO.KudosType).INDIVIDUAL,
                recipientId: this.props.userId
            },
            analyticsSource: "profile-card",
            teamCentralBaseUrl: newProps.teamCentralBaseUrl,
            cloudId: this.props.cloudId,
            addFlag: this.props.addFlag,
            onClose: this.closeKudosDrawer
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ehM5E.default), {
            ...newProps,
            actions: this.filterActions()
        })));
    }
    constructor(...args){
        super(...args);
        this._isMounted = false;
        this.state = {
            visible: false,
            isLoading: undefined,
            hasError: false,
            error: null,
            data: null,
            reportingLinesData: undefined,
            isKudosEnabled: false,
            kudosDrawerOpen: false
        };
        this.fireAnalytics = (payload)=>{
            // Don't fire analytics if the component is unmounted
            if (!this._isMounted) return;
            if (this.props.createAnalyticsEvent) (0, $3vXh8.fireEvent)(this.props.createAnalyticsEvent, payload);
        };
        this.clientFetchProfile = ()=>{
            const { cloudId: cloudId, userId: userId } = this.props;
            const { isLoading: isLoading } = this.state;
            if (isLoading === true) // don't fetch data when fetching is in process
            return;
            this.setState({
                isLoading: true,
                hasError: false,
                data: null
            }, ()=>{
                const requests = Promise.all([
                    this.props.resourceClient.getProfile(cloudId, userId, this.fireAnalytics),
                    this.props.resourceClient.getReportingLines(userId),
                    this.props.resourceClient.shouldShowGiveKudos()
                ]);
                requests.then((res)=>this.handleClientSuccess(...res), (err)=>this.handleClientError(err)).catch((err)=>this.handleClientError(err));
            });
        };
        this.filterActions = ()=>(0, $5Jx7I.default)(this.props.actions, this.state.data);
        this.openKudosDrawer = ()=>{
            this.setState({
                kudosDrawerOpen: true
            });
        };
        this.closeKudosDrawer = ()=>{
            this.setState({
                kudosDrawerOpen: false
            });
        };
    }
}
const $184c4f94fc0b4764$export$a6d9ff68ecba3be5 = $184c4f94fc0b4764$var$ProfileCardResourced;
var $184c4f94fc0b4764$export$2e2bcd8739ae039 = (0, $2jDha.default)()($184c4f94fc0b4764$var$ProfileCardResourced);

});
parcelRegister("ijWKk", function(module, exports) {

$parcel$export(module.exports, "default", () => $005cfbb6d85cc048$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4Bees = parcelRequire("4Bees");

var $kqibQ = parcelRequire("kqibQ");

var $3vXh8 = parcelRequire("3vXh8");
const $005cfbb6d85cc048$var$UserLoadingState = ({ fireAnalytics: fireAnalytics })=>{
    (0, $eUqFw.useEffect)(()=>{
        fireAnalytics((0, $3vXh8.profileCardRendered)('user', 'spinner'));
    }, [
        fireAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.SpinnerContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), null));
};
var $005cfbb6d85cc048$export$2e2bcd8739ae039 = $005cfbb6d85cc048$var$UserLoadingState;

});


parcelRegister("1I4cW", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9a11e1a2b837fef$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2jDha = parcelRequire("2jDha");

var $dx7Op = parcelRequire("dx7Op");
var $btCBO = parcelRequire("btCBO");

var $XHGTv = parcelRequire("XHGTv");

var $3MV1G = parcelRequire("3MV1G");

var $lcnyw = parcelRequire("lcnyw");

var $5Jx7I = parcelRequire("5Jx7I");

var $kqibQ = parcelRequire("kqibQ");

var $3vXh8 = parcelRequire("3vXh8");


var $hSM1E = parcelRequire("hSM1E");

var $1gzkS = parcelRequire("1gzkS");

var $ijWKk = parcelRequire("ijWKk");
class $d9a11e1a2b837fef$var$ProfilecardTrigger extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    static{
        this.defaultProps = {
            actions: [],
            trigger: 'hover',
            position: 'bottom-start'
        };
    }
    componentDidMount() {
        this._isMounted = true;
    }
    componentDidUpdate(prevProps) {
        const { userId: userId, cloudId: cloudId, resourceClient: resourceClient } = this.props;
        const { visible: visible } = this.state;
        // just re-fetching data when the card opens
        if (visible && (userId !== prevProps.userId || cloudId !== prevProps.cloudId || resourceClient !== prevProps.resourceClient)) this.setState({
            isLoading: undefined
        }, this.clientFetchProfile);
    }
    componentWillUnmount() {
        this._isMounted = false;
        clearTimeout(this.showTimer);
        clearTimeout(this.hideTimer);
    }
    handleClientSuccess(profileData, reportingLinesData, shouldShowGiveKudos) {
        if (!this._isMounted) return;
        this.setState({
            isLoading: false,
            hasError: false,
            data: profileData,
            reportingLinesData: reportingLinesData,
            shouldShowGiveKudos: shouldShowGiveKudos
        });
    }
    handleClientError(err) {
        if (!this._isMounted) return;
        this.setState({
            isLoading: false,
            hasError: true,
            error: err
        });
    }
    filterActions() {
        return (0, $5Jx7I.default)(this.props.actions, this.state.data);
    }
    renderProfileCard() {
        const newProps = {
            userId: this.props.userId,
            isCurrentUser: this.state.data?.isCurrentUser,
            clientFetchProfile: this.clientFetchProfile,
            ...this.state.data,
            reportingLines: this.state.reportingLinesData,
            onReportingLinesClick: this.props.onReportingLinesClick,
            isKudosEnabled: this.state.shouldShowGiveKudos,
            teamCentralBaseUrl: this.state.teamCentralBaseUrl,
            cloudId: this.props.cloudId,
            openKudosDrawer: this.openKudosDrawer
        };
        const wrapperProps = this.props.trigger === 'hover' ? {
            onMouseEnter: this.onMouseEnter,
            onMouseLeave: this.hideProfilecard,
            onFocus: this.onFocus
        } : {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", wrapperProps, this.state.visible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hSM1E.ProfileCardLazy), {
            ...newProps,
            actions: this.filterActions(),
            hasError: this.state.hasError,
            errorType: this.state.error,
            withoutElevation: true
        })));
    }
    renderWithTrigger() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
            isOpen: !!this.state.visible,
            onClose: this.hideProfilecard,
            placement: this.props.position,
            content: this.renderCard,
            trigger: (triggerProps)=>{
                const { ref: ref, ...innerProps } = triggerProps;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                    ...innerProps,
                    ...this.containerListeners,
                    ref: ref,
                    "data-testid": this.props.testId,
                    role: "button",
                    tabIndex: 0
                }, this.props.children);
            },
            zIndex: (0, $lcnyw.layers).modal(),
            shouldUseCaptureOnOutsideClick: true,
            autoFocus: this.props.autoFocus ?? this.props.trigger === 'click',
            offset: this.props.offset ?? [
                0,
                8
            ],
            shouldRenderToParent: (0, $XHGTv.fg)('enable_appropriate_reading_order_in_profile_card')
        }), this.state.shouldShowGiveKudos && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dx7Op.GiveKudosLauncherLazy), {
            isOpen: this.state.kudosDrawerOpen,
            recipient: {
                type: (0, $btCBO.KudosType).INDIVIDUAL,
                recipientId: this.props.userId
            },
            analyticsSource: "profile-card",
            teamCentralBaseUrl: this.state.teamCentralBaseUrl,
            cloudId: this.props.cloudId,
            addFlag: this.props.addFlag,
            onClose: this.closeKudosDrawer
        })));
    }
    render() {
        if (this.props.children) return this.renderWithTrigger();
        else throw new Error('Component "ProfileCardTrigger" must have "children" property');
    }
    constructor(...args){
        super(...args);
        this._isMounted = false;
        this.showDelay = this.props.trigger === 'click' ? 0 : (0, $515c9dbc88c31cf4$export$5b956b542f1bc1b3);
        this.hideDelay = this.props.trigger === 'click' ? 0 : (0, $515c9dbc88c31cf4$export$89a9f35a94d7f196);
        this.showTimer = 0;
        this.hideTimer = 0;
        this.fireAnalytics = (payload)=>{
            // Don't fire any analytics if the component is unmounted
            if (!this._isMounted) return;
            if (this.props.createAnalyticsEvent) (0, $3vXh8.fireEvent)(this.props.createAnalyticsEvent, payload);
        };
        this.hideProfilecard = ()=>{
            clearTimeout(this.showTimer);
            clearTimeout(this.hideTimer);
            this.hideTimer = window.setTimeout(()=>{
                this.setState({
                    visible: false
                });
            }, this.hideDelay);
        };
        this.showProfilecard = ()=>{
            clearTimeout(this.hideTimer);
            clearTimeout(this.showTimer);
            this.showTimer = window.setTimeout(()=>{
                if (!this.state.visible) {
                    this.clientFetchProfile();
                    this.setState({
                        visible: true
                    });
                }
            }, this.showDelay);
        };
        this.onClick = (event)=>{
            // If the user clicks on the trigger then we don't want that click event to
            // propagate out to parent containers. For example when clicking a mention
            // lozenge in an inline-edit.
            event.stopPropagation();
            this.showProfilecard();
            if (!this.state.visible) this.fireAnalytics((0, $3vXh8.cardTriggered)('user', 'click'));
        };
        this.onMouseEnter = ()=>{
            this.showProfilecard();
            if (!this.state.visible) this.fireAnalytics((0, $3vXh8.cardTriggered)('user', 'hover'));
        };
        this.onKeyPress = (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                this.showProfilecard();
                if (!this.state.visible) this.fireAnalytics((0, $3vXh8.cardTriggered)('user', 'click'));
            }
        };
        this.onFocus = ()=>{
            this.showProfilecard();
        };
        this.containerListeners = this.props.trigger === 'hover' ? {
            onMouseEnter: this.onMouseEnter,
            onMouseLeave: this.hideProfilecard,
            onBlur: this.hideProfilecard,
            onKeyPress: this.onKeyPress
        } : {
            onClick: this.onClick,
            onKeyPress: this.onKeyPress
        };
        this.layerListeners = {
            handleClickOutside: this.hideProfilecard,
            handleEscapeKeydown: this.hideProfilecard
        };
        this.state = {
            visible: false,
            isLoading: undefined,
            hasError: false,
            error: null,
            data: null,
            reportingLinesData: undefined,
            shouldShowGiveKudos: false,
            teamCentralBaseUrl: undefined,
            kudosDrawerOpen: false
        };
        this.clientFetchProfile = ()=>{
            const { cloudId: cloudId, userId: userId } = this.props;
            const { isLoading: isLoading } = this.state;
            if (isLoading === true) // don't fetch data when fetching is in process
            return;
            this.setState({
                teamCentralBaseUrl: this.props.resourceClient.getTeamCentralBaseUrl()
            });
            this.setState({
                isLoading: true,
                hasError: false,
                data: null
            }, ()=>{
                const requests = Promise.all([
                    this.props.resourceClient.getProfile(cloudId || '', userId, this.fireAnalytics),
                    this.props.resourceClient.getReportingLines(userId),
                    this.props.resourceClient.shouldShowGiveKudos()
                ]);
                requests.then((res)=>this.handleClientSuccess(...res), (err)=>this.handleClientError(err)).catch((err)=>this.handleClientError(err));
            });
        };
        this.openKudosDrawer = ()=>{
            this.hideProfilecard();
            this.setState({
                kudosDrawerOpen: true
            });
        };
        this.closeKudosDrawer = ()=>{
            this.setState({
                kudosDrawerOpen: false
            });
        };
        this.renderCard = ()=>{
            const { isLoading: isLoading } = this.state;
            if (isLoading === true || isLoading === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.CardWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ijWKk.default), {
                fireAnalytics: this.fireAnalytics
            }));
            else return this.renderProfileCard();
        };
    }
}
const $d9a11e1a2b837fef$var$ProfilecardTriggerLegacy = (0, $2jDha.default)()($d9a11e1a2b837fef$var$ProfilecardTrigger);
function $d9a11e1a2b837fef$export$2e2bcd8739ae039(props) {
    return (0, $XHGTv.fg)('platform.profile-card-trigger-next') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1gzkS.default), {
        ...props,
        onVisibilityChange: (isVisible)=>{
            if (props.onVisibilityChange) props.onVisibilityChange(isVisible);
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d9a11e1a2b837fef$var$ProfilecardTriggerLegacy, props);
}

});
parcelRegister("hSM1E", function(module, exports) {

$parcel$export(module.exports, "ProfileCardLazy", () => $79ec67bb4c36fbd6$export$403d297463f226af);

var $eUqFw = parcelRequire("eUqFw");

const $79ec67bb4c36fbd6$export$403d297463f226af = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>Promise.resolve((parcelRequire("ehM5E"))));

});

parcelRegister("1gzkS", function(module, exports) {

$parcel$export(module.exports, "default", () => $166988d213f6993a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bFzGY = parcelRequire("bFzGY");

var $dx7Op = parcelRequire("dx7Op");
var $btCBO = parcelRequire("btCBO");

var $XHGTv = parcelRequire("XHGTv");

var $3MV1G = parcelRequire("3MV1G");

var $lcnyw = parcelRequire("lcnyw");

var $5Jx7I = parcelRequire("5Jx7I");

var $l2W2J = parcelRequire("l2W2J");

var $kqibQ = parcelRequire("kqibQ");

var $3vXh8 = parcelRequire("3vXh8");


var $hSM1E = parcelRequire("hSM1E");

var $ijWKk = parcelRequire("ijWKk");
function $166988d213f6993a$export$2e2bcd8739ae039({ autoFocus: autoFocus, trigger: trigger = 'hover', userId: userId, cloudId: cloudId, resourceClient: resourceClient, actions: actions = [], position: position = 'bottom-start', children: children, testId: testId, addFlag: addFlag, onReportingLinesClick: onReportingLinesClick, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, prepopulatedData: prepopulatedData, disabledAriaAttributes: disabledAriaAttributes, onVisibilityChange: onVisibilityChange, offset: offset }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isMounted, setIsMounted] = (0, $eUqFw.useState)(false);
    const showDelay = trigger === 'click' ? 0 : (0, $515c9dbc88c31cf4$export$5b956b542f1bc1b3);
    const hideDelay = trigger === 'click' ? 0 : (0, $515c9dbc88c31cf4$export$89a9f35a94d7f196);
    const showTimer = (0, $eUqFw.useRef)(0);
    const hideTimer = (0, $eUqFw.useRef)(0);
    const [visible, setVisible] = (0, $eUqFw.useState)(false);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(undefined);
    const [hasError, setHasError] = (0, $eUqFw.useState)(false);
    const [error, setError] = (0, $eUqFw.useState)(null);
    const [data, setData] = (0, $eUqFw.useState)(null);
    const [reportingLinesData, setReportingLinesData] = (0, $eUqFw.useState)(undefined);
    const [shouldShowGiveKudos, setShouldShowGiveKudos] = (0, $eUqFw.useState)(false);
    const [teamCentralBaseUrl, setTeamCentralBaseUrl] = (0, $eUqFw.useState)(undefined);
    const [kudosDrawerOpen, setKudosDrawerOpen] = (0, $eUqFw.useState)(false);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $eUqFw.useState)(false);
    const triggerRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        setIsMounted(true);
        return ()=>{
            setIsMounted(false);
            clearTimeout(showTimer.current);
            clearTimeout(hideTimer.current);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        // Reset state when the userId changes
        setIsLoading(undefined);
        setHasError(false);
        setError(null);
        setData(null);
        setReportingLinesData(undefined);
        setShouldShowGiveKudos(false);
        setTeamCentralBaseUrl(undefined);
    }, [
        userId
    ]);
    const fireAnalytics = (0, $eUqFw.useCallback)((payload)=>{
        // Don't fire any analytics if the component is unmounted
        if (!isMounted) return;
        (0, $3vXh8.fireEvent)(createAnalyticsEvent, payload);
    }, [
        createAnalyticsEvent,
        isMounted
    ]);
    const hideProfilecard = (0, $eUqFw.useCallback)(()=>{
        clearTimeout(showTimer.current);
        clearTimeout(hideTimer.current);
        if (!isTriggeredUsingKeyboard) hideTimer.current = window.setTimeout(()=>{
            setVisible(false);
            onVisibilityChange && onVisibilityChange(false);
        }, hideDelay);
    }, [
        hideDelay,
        isTriggeredUsingKeyboard,
        onVisibilityChange
    ]);
    const handleKeyboardClose = (0, $eUqFw.useCallback)((event)=>{
        if (event.key && event.key !== 'Escape') return;
        if (triggerRef.current) triggerRef.current.focus();
        setTriggeredUsingKeyboard(false);
        setVisible(false);
        onVisibilityChange && onVisibilityChange(false);
    }, [
        setTriggeredUsingKeyboard,
        setVisible,
        onVisibilityChange
    ]);
    const handleClientSuccess = (0, $eUqFw.useCallback)((profileData, reportingLinesData, shouldShowGiveKudos)=>{
        if (!isMounted) return;
        setIsLoading(false);
        setHasError(false);
        setData(profileData);
        setReportingLinesData(reportingLinesData);
        setShouldShowGiveKudos(shouldShowGiveKudos);
    }, [
        isMounted,
        setHasError,
        setIsLoading,
        setData,
        setReportingLinesData,
        setShouldShowGiveKudos
    ]);
    const handleClientError = (0, $eUqFw.useCallback)((err)=>{
        if (!isMounted) return;
        setIsLoading(false);
        setHasError(true);
        setError(err);
    }, [
        isMounted,
        setHasError,
        setIsLoading,
        setError
    ]);
    const clientFetchProfile = (0, $eUqFw.useCallback)(async ()=>{
        if (isLoading === true) // don't fetch data when fetching is in process
        return;
        setTeamCentralBaseUrl(resourceClient.getTeamCentralBaseUrl());
        setIsLoading(true);
        setHasError(false);
        setError(null);
        setData(null);
        try {
            const requests = Promise.all([
                resourceClient.getProfile(cloudId || '', userId, fireAnalytics),
                resourceClient.getReportingLines(userId),
                resourceClient.shouldShowGiveKudos()
            ]);
            const responses = await requests;
            handleClientSuccess(...responses);
        } catch (err) {
            handleClientError(err);
        }
    }, [
        cloudId,
        fireAnalytics,
        isLoading,
        resourceClient,
        userId,
        handleClientSuccess,
        handleClientError
    ]);
    const showProfilecard = (0, $eUqFw.useCallback)(()=>{
        clearTimeout(hideTimer.current);
        clearTimeout(showTimer.current);
        showTimer.current = window.setTimeout(()=>{
            if (!visible) {
                clientFetchProfile();
                setVisible(true);
                onVisibilityChange && onVisibilityChange(true);
            }
        }, showDelay);
    }, [
        showDelay,
        visible,
        clientFetchProfile,
        onVisibilityChange
    ]);
    const onClick = (0, $eUqFw.useCallback)((event)=>{
        // If the user clicks on the trigger then we don't want that click event to
        // propagate out to parent containers. For example when clicking a mention
        // lozenge in an inline-edit.
        event.stopPropagation();
        showProfilecard();
        if (!visible) fireAnalytics((0, $3vXh8.cardTriggered)('user', 'click'));
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onMouseEnter = (0, $eUqFw.useCallback)(()=>{
        showProfilecard();
        if (!visible) fireAnalytics((0, $3vXh8.cardTriggered)('user', 'hover'));
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onKeyPress = (0, $eUqFw.useCallback)((event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            setTriggeredUsingKeyboard(true);
            showProfilecard();
            if (!visible) fireAnalytics((0, $3vXh8.cardTriggered)('user', 'click'));
        }
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onFocus = (0, $eUqFw.useCallback)(()=>{
        showProfilecard();
    }, [
        showProfilecard
    ]);
    const containerListeners = (0, $eUqFw.useMemo)(()=>trigger === 'hover' ? {
            onMouseEnter: onMouseEnter,
            onMouseLeave: hideProfilecard,
            onBlur: hideProfilecard,
            onKeyPress: onKeyPress
        } : {
            onClick: onClick,
            onKeyPress: onKeyPress
        }, [
        hideProfilecard,
        onClick,
        onKeyPress,
        onMouseEnter,
        trigger
    ]);
    const filterActions = (0, $eUqFw.useCallback)(()=>{
        return (0, $5Jx7I.default)(actions, data);
    }, [
        actions,
        data
    ]);
    const openKudosDrawer = ()=>{
        hideProfilecard();
        setKudosDrawerOpen(true);
    };
    const closeKudosDrawer = ()=>{
        setKudosDrawerOpen(false);
    };
    const showLoading = isLoading === true || isLoading === undefined;
    const wrapperProps = (0, $eUqFw.useMemo)(()=>trigger === 'hover' ? {
            onMouseEnter: onMouseEnter,
            onMouseLeave: hideProfilecard,
            onFocus: onFocus
        } : {}, [
        hideProfilecard,
        onFocus,
        onMouseEnter,
        trigger
    ]);
    const profilecardProps = {
        userId: userId,
        fullName: prepopulatedData?.fullName,
        isCurrentUser: data?.isCurrentUser,
        clientFetchProfile: clientFetchProfile,
        ...data,
        reportingLines: reportingLinesData,
        onReportingLinesClick: onReportingLinesClick,
        isKudosEnabled: shouldShowGiveKudos,
        teamCentralBaseUrl: teamCentralBaseUrl,
        cloudId: cloudId,
        openKudosDrawer: openKudosDrawer,
        isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
        disabledAriaAttributes: disabledAriaAttributes
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: !!visible,
        onClose: (event)=>{
            hideProfilecard();
            handleKeyboardClose(event);
        },
        placement: position,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", wrapperProps, showLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($166988d213f6993a$var$LoadingView, {
                fireAnalytics: fireAnalytics
            }) : visible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
                fallback: null
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hSM1E.ProfileCardLazy), {
                ...profilecardProps,
                actions: filterActions(),
                hasError: hasError,
                errorType: error,
                withoutElevation: true
            }))),
        trigger: (triggerProps)=>{
            const { ref: callbackRef, ...innerProps } = triggerProps;
            const ref = (element)=>{
                triggerRef.current = element;
                if (typeof callbackRef === 'function') callbackRef(element);
            };
            const { 'aria-expanded': _, 'aria-haspopup': __, ...restInnerProps } = innerProps;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                ...disabledAriaAttributes ? restInnerProps : triggerProps,
                ...containerListeners,
                ref: ref,
                "data-testid": testId,
                "aria-labelledby": ariaLabelledBy,
                ...disabledAriaAttributes ? {} : {
                    role: 'button',
                    tabIndex: 0,
                    'aria-label': (0, $l2W2J.default)(ariaLabel, profilecardProps.fullName, formatMessage)
                }
            }, children);
        },
        zIndex: (0, $lcnyw.layers).modal(),
        shouldUseCaptureOnOutsideClick: true,
        autoFocus: autoFocus ?? trigger === 'click',
        offset: offset ?? [
            0,
            8
        ],
        shouldRenderToParent: (0, $XHGTv.fg)('enable_appropriate_reading_order_in_profile_card')
    }), shouldShowGiveKudos && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dx7Op.GiveKudosLauncherLazy), {
        isOpen: kudosDrawerOpen,
        recipient: {
            type: (0, $btCBO.KudosType).INDIVIDUAL,
            recipientId: userId
        },
        analyticsSource: "profile-card",
        teamCentralBaseUrl: teamCentralBaseUrl,
        cloudId: cloudId,
        addFlag: addFlag,
        onClose: closeKudosDrawer
    })));
}
const $166988d213f6993a$var$LoadingView = ({ fireAnalytics: fireAnalytics })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.CardWrapper), {
        "data-testId": "profilecard.profilecardtrigger.loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ijWKk.default), {
        fireAnalytics: fireAnalytics
    }));

});
parcelRegister("l2W2J", function(module, exports) {

$parcel$export(module.exports, "default", () => $02881092ed20fd17$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $02881092ed20fd17$var$getLabelMessage = (ariaLabelProp, fullName, formatMessage)=>{
    if (ariaLabelProp) return ariaLabelProp;
    return fullName ? formatMessage($02881092ed20fd17$var$messages.label, {
        fullName: fullName
    }) : formatMessage($02881092ed20fd17$var$messages.fallbackLabel);
};
const $02881092ed20fd17$var$messages = (0, $90IgZ.defineMessages)({
    fallbackLabel: {
        id: 'profilecard.user.trigger.fallback-aria-label',
        defaultMessage: 'More information about this user',
        description: 'Label for profile card trigger when we do not have user name'
    },
    label: {
        id: 'profilecard.user.trigger.aria-label',
        defaultMessage: 'More information about {fullName}',
        description: 'Label for profile card trigger'
    }
});
var $02881092ed20fd17$export$2e2bcd8739ae039 = $02881092ed20fd17$var$getLabelMessage;

});



parcelRegister("icLG8", function(module, exports) {

$parcel$export(module.exports, "default", () => $3275fd86a923b35a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");
function $3275fd86a923b35a$export$2e2bcd8739ae039(Component) {
    return class WithOuterListeners extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
        componentDidMount() {
            if (this.props.handleClickOutside) document.addEventListener('click', this.handleClick, false);
            if (this.props.handleEscapeKeydown) document.addEventListener('keydown', this.handleKeydown, false);
        }
        componentWillUnmount() {
            if (this.props.handleClickOutside) document.removeEventListener('click', this.handleClick, false);
            if (this.props.handleEscapeKeydown) document.removeEventListener('keydown', this.handleKeydown, false);
        }
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, this.props);
        }
        constructor(...args){
            super(...args);
            this.handleClick = (evt)=>{
                const { handleClickOutside: handleClickOutside } = this.props;
                if (handleClickOutside) {
                    const domNode = (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).findDOMNode(this); // eslint-disable-line react/no-find-dom-node
                    if (!domNode || evt.target instanceof Node && !domNode.contains(evt.target)) handleClickOutside();
                }
            };
            this.handleKeydown = (evt)=>{
                const { handleEscapeKeydown: handleEscapeKeydown } = this.props;
                if (handleEscapeKeydown && evt.code === 'Escape') handleEscapeKeydown();
            };
        }
    };
}

});

parcelRegister("g8DVf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b92b2ec2eaaa8f9d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $4XQdE = parcelRequire("4XQdE");

var $7opLA = parcelRequire("7opLA");

var $7u4fN = parcelRequire("7u4fN");

var $51sCz = parcelRequire("51sCz");

var $jG1wZ = parcelRequire("jG1wZ");

var $bo4OB = parcelRequire("bo4OB");
var $8PFhw = parcelRequire("8PFhw");

var $XHGTv = parcelRequire("XHGTv");

var $3MV1G = parcelRequire("3MV1G");

var $lcnyw = parcelRequire("lcnyw");

var $8cU5f = parcelRequire("8cU5f");

var $aCbpp = parcelRequire("aCbpp");

var $kqibQ = parcelRequire("kqibQ");

var $fnJ1y = parcelRequire("fnJ1y");

var $dRbkr = parcelRequire("dRbkr");

var $3vXh8 = parcelRequire("3vXh8");

var $7NIUg = parcelRequire("7NIUg");
parcelRequire("iINHb");
var $8J4a2 = parcelRequire("8J4a2");

var $22Tpa = parcelRequire("22Tpa");

var $dO06T = parcelRequire("dO06T");
const $b92b2ec2eaaa8f9d$var$LARGE_MEMBER_COUNT = 50;
const $b92b2ec2eaaa8f9d$var$GIVE_KUDOS_ACTION_ID = 'give-kudos';
function $b92b2ec2eaaa8f9d$var$onMemberClick(callback, userId, analytics, index, hasHref) {
    return (event)=>{
        analytics((duration)=>(0, $3vXh8.teamAvatarClicked)({
                duration: duration,
                hasHref: hasHref,
                hasOnClick: !!callback,
                index: index
            }));
        if (callback) callback(userId, event);
    };
}
const $b92b2ec2eaaa8f9d$var$TeamMembers = ({ analytics: analytics, generateUserLink: generateUserLink, members: members, onUserClick: onUserClick, includingYou: includingYou })=>{
    const count = members ? members.length : 0;
    const message = includingYou ? count >= $b92b2ec2eaaa8f9d$var$LARGE_MEMBER_COUNT ? (0, $aCbpp.default).membersMoreThan50IncludingYou : (0, $aCbpp.default).memberCountIncludingYou : count >= $b92b2ec2eaaa8f9d$var$LARGE_MEMBER_COUNT ? (0, $aCbpp.default).membersMoreThan50 : (0, $aCbpp.default).memberCount;
    // Use a ref to track whether this is currently open, so we can fire events
    // iff the more section is being opened (not closed).
    const isMoreMembersOpen = (0, $eUqFw.useRef)(false);
    const onMoreClick = (0, $eUqFw.useCallback)(()=>{
        const { current: isOpen } = isMoreMembersOpen;
        if (!isOpen) analytics((duration)=>(0, $3vXh8.moreMembersClicked)({
                duration: duration,
                memberCount: count
            }));
        isMoreMembersOpen.current = !isOpen;
    }, [
        analytics,
        count
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.MemberCount), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...message,
        values: {
            count: count
        }
    })), members && members.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.AvatarSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4XQdE.default), {
        appearance: "stack",
        data: members.map((member, index)=>{
            const href = generateUserLink?.(member.id);
            const onClick = $b92b2ec2eaaa8f9d$var$onMemberClick(onUserClick, member.id, analytics, index, !!generateUserLink);
            return {
                key: member.id,
                name: member.fullName,
                src: member.avatarUrl,
                href: href,
                onClick: onClick
            };
        }),
        maxCount: 9,
        showMoreButtonProps: {
            onClick: onMoreClick
        },
        testId: "profilecard-avatar-group"
    })));
};
function $b92b2ec2eaaa8f9d$var$onActionClick(action, analytics, index) {
    return (event, ...args)=>{
        analytics((duration)=>(0, $3vXh8.actionClicked)('team', {
                duration: duration,
                hasHref: !!action.link,
                hasOnClick: !!action.callback,
                index: index,
                actionId: action.id || ''
            }));
        if (action.callback && (0, $7NIUg.isBasicClick)(event)) {
            event.preventDefault();
            action.callback(event, ...args);
        }
    };
}
const $b92b2ec2eaaa8f9d$var$ActionButton = ({ action: action, analytics: analytics, index: index })=>{
    const isGiveKudosActionButton = action.id === $b92b2ec2eaaa8f9d$var$GIVE_KUDOS_ACTION_ID;
    const actionButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $51sCz.default), {
        isInset: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        key: action.id || index,
        onClick: $b92b2ec2eaaa8f9d$var$onActionClick(action, analytics, index),
        href: action.link,
        shouldFitContainer: true
    }, action.label, isGiveKudosActionButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.AnimationWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.KudosBlobAnimation), null))));
    if (isGiveKudosActionButton) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.AnimatedKudosButton), null, actionButton);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.WrappedButton), null, actionButton);
};
const $b92b2ec2eaaa8f9d$var$ExtraActions = ({ actions: actions, analytics: analytics })=>{
    const [isOpen, setOpen] = (0, $eUqFw.useState)(false);
    const count = actions.length;
    const onMoreClick = (0, $eUqFw.useCallback)((shouldBeOpen)=>{
        if (shouldBeOpen) // Only fire this event when OPENING the dropdown
        analytics((duration)=>(0, $3vXh8.moreActionsClicked)('team', {
                duration: duration,
                numActions: count + 2
            }));
        setOpen(shouldBeOpen);
    }, [
        analytics,
        count
    ]);
    if (!count) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.MoreButton), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: isOpen,
        onClose: ()=>setOpen(false),
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8PFhw.default), null, actions.map((action, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
                    onClick: $b92b2ec2eaaa8f9d$var$onActionClick(action, analytics, index + 2),
                    key: action.id || index,
                    href: action.link
                }, action.label))),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                testId: "more-actions-button",
                ...triggerProps,
                isSelected: isOpen,
                onClick: ()=>onMoreClick(!isOpen),
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jG1wZ))), {
                    label: "actions"
                })
            }),
        zIndex: (0, $lcnyw.layers).modal(),
        shouldRenderToParent: (0, $XHGTv.fg)('enable_appropriate_reading_order_in_profile_card')
    }));
};
const $b92b2ec2eaaa8f9d$var$ButtonSection = ({ actions: actions, analytics: analytics })=>{
    if (!actions) return null;
    const extraActions = actions.slice(2);
    const initialActions = actions.slice(0, 2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.ActionButtons), null, initialActions.map((action, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b92b2ec2eaaa8f9d$var$ActionButton, {
            action: action,
            analytics: analytics,
            index: index,
            key: index
        })), extraActions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b92b2ec2eaaa8f9d$var$ExtraActions, {
        actions: extraActions,
        analytics: analytics
    }));
};
const $b92b2ec2eaaa8f9d$var$TeamProfilecardContent = ({ actions: actions, analytics: analytics, team: team, viewingUserId: viewingUserId, generateUserLink: generateUserLink, onUserClick: onUserClick, viewProfileLink: viewProfileLink, viewProfileOnClick: viewProfileOnClick })=>{
    const allActions = [
        {
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $aCbpp.default).teamViewProfile),
            link: viewProfileLink,
            callback: viewProfileOnClick,
            id: 'view-profile'
        },
        ...actions || []
    ];
    const includingYou = team.members && team.members.some((member)=>member.id === viewingUserId);
    (0, $eUqFw.useEffect)(()=>{
        analytics((duration)=>(0, $3vXh8.profileCardRendered)('team', 'content', {
                duration: duration,
                numActions: allActions.length,
                memberCount: team.members?.length,
                includingYou: includingYou,
                descriptionLength: team.description.length,
                titleLength: team.displayName.length
            }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        analytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.CardWrapper), {
        "data-testid": "team-profilecard"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.CardHeader), {
        image: team.largeHeaderImageUrl || team.smallHeaderImageUrl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.CardContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: team.displayName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.TeamName), null, team.displayName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b92b2ec2eaaa8f9d$var$TeamMembers, {
        analytics: analytics,
        members: team.members,
        generateUserLink: generateUserLink,
        includingYou: includingYou,
        onUserClick: onUserClick
    }), team.description.trim() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.DescriptionWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.Description), null, team.description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b92b2ec2eaaa8f9d$var$ButtonSection, {
        actions: allActions,
        analytics: analytics
    })));
};
const $b92b2ec2eaaa8f9d$var$ErrorMessage = ({ analytics: analytics, clientFetchProfile: clientFetchProfile, isLoading: isLoading })=>{
    const hasRetry = !!clientFetchProfile;
    (0, $eUqFw.useEffect)(()=>{
        analytics((duration)=>(0, $3vXh8.profileCardRendered)('team', 'error', {
                duration: duration,
                hasRetry: hasRetry
            }));
    }, [
        analytics,
        hasRetry
    ]);
    const retry = (0, $eUqFw.useCallback)(()=>{
        analytics((duration)=>(0, $3vXh8.errorRetryClicked)({
                duration: duration
            }));
        if (clientFetchProfile) clientFetchProfile();
    }, [
        analytics,
        clientFetchProfile
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fnJ1y.ErrorWrapper), {
        "data-testid": "team-profilecard-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8J4a2.ErrorIllustration), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fnJ1y.TeamErrorTitle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $aCbpp.default).teamErrorTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fnJ1y.TeamErrorText), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $aCbpp.default).teamErrorText)), clientFetchProfile && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.ActionButtons), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.WrappedButton), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
        testId: "client-fetch-profile-button",
        shouldFitContainer: true,
        onClick: retry,
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $aCbpp.default).teamErrorButton)))));
};
const $b92b2ec2eaaa8f9d$var$TeamProfileCard = (props)=>{
    const { analytics: analytics, clientFetchProfile: clientFetchProfile, hasError: hasError, isLoading: isLoading, team: team, errorType: errorType } = props;
    if (hasError) {
        if (errorType?.reason === 'TEAMS_FORBIDDEN') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $22Tpa.default), {
            analytics: analytics
        });
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.CardWrapper), {
            "data-testid": "team-profilecard"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b92b2ec2eaaa8f9d$var$ErrorMessage, {
            analytics: analytics,
            clientFetchProfile: clientFetchProfile,
            isLoading: isLoading
        }));
    }
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dO06T.default), {
        analytics: analytics
    });
    if (team) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b92b2ec2eaaa8f9d$var$TeamProfilecardContent, {
        ...props,
        team: team
    });
    return null;
};
var $b92b2ec2eaaa8f9d$export$2e2bcd8739ae039 = $b92b2ec2eaaa8f9d$var$TeamProfileCard;

});
parcelRegister("22Tpa", function(module, exports) {

$parcel$export(module.exports, "default", () => $479bbf795543ee24$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $220ac = parcelRequire("220ac");

var $aCbpp = parcelRequire("aCbpp");

var $dRbkr = parcelRequire("dRbkr");

var $3vXh8 = parcelRequire("3vXh8");

var $1eRuZ = parcelRequire("1eRuZ");
var $479bbf795543ee24$export$2e2bcd8739ae039 = (props)=>{
    const { analytics: analytics } = props;
    const intl = (0, $5JgJ2.default)();
    (0, $eUqFw.useEffect)(()=>{
        analytics((duration)=>(0, $3vXh8.profileCardRendered)('team', 'error', {
                duration: duration
            }));
    }, [
        analytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.TeamForbiddenErrorStateWrapper), {
        "data-testid": "team-profilecard-forbidden-error-state"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        header: intl.formatMessage((0, $aCbpp.default).teamForbiddenErrorStateTitle),
        description: intl.formatMessage((0, $aCbpp.default).teamForbiddenErrorStateDescription),
        renderImage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.AccessLockSVGWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1eRuZ.default), null))
    }));
};

});
parcelRegister("1eRuZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f333fc6edfa90ad9$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $eUqFw = parcelRequire("eUqFw");
const $f333fc6edfa90ad9$var$AccessLockSVG = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "191",
        height: "222",
        viewBox: "0 0 191 222",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        clipPath: "url(#clip0)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M0 0.400391H190.2V221.9H0V0.400391Z",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M122.7 119.9H49.4V36.9998C49.8906 27.6107 53.9659 18.7679 60.7854 12.2956C67.6048 5.82318 76.6481 2.21484 86.05 2.21484C95.4519 2.21484 104.495 5.82318 111.315 12.2956C118.134 18.7679 122.209 27.6107 122.7 36.9998V119.9ZM61.4 107.9H110.7V36.9998C110.301 30.7336 107.53 24.8546 102.951 20.5583C98.3722 16.2619 92.3289 13.8706 86.05 13.8706C79.7711 13.8706 73.7279 16.2619 69.149 20.5583C64.5701 24.8546 61.7993 30.7336 61.4 36.9998V107.9Z",
        fill: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M160.3 111.601C152.848 97.4396 150.855 81.0347 154.7 65.501C154.883 64.7606 154.894 63.9882 154.733 63.2428C154.572 62.4974 154.242 61.7989 153.769 61.2005C153.296 60.6022 152.693 60.1199 152.005 59.7907C151.317 59.4615 150.563 59.2939 149.8 59.301H19.1C18.348 59.2976 17.605 59.4639 16.9262 59.7874C16.2474 60.111 15.6503 60.5834 15.1794 61.1697C14.7085 61.7559 14.3758 62.4408 14.2063 63.1734C14.0367 63.906 14.0346 64.6675 14.2 65.401C17.9782 81.0252 15.9154 97.4916 8.4 111.701C2.5112 123.071 -0.389112 135.752 -0.0282299 148.551C0.332652 161.351 3.94288 173.848 10.463 184.868C16.9831 195.888 26.1988 205.069 37.2436 211.548C48.2884 218.026 60.7993 221.589 73.6 221.901H91.5C101.565 222.141 111.577 220.365 120.946 216.679C130.315 212.992 138.851 207.469 146.054 200.434C153.257 193.399 158.979 184.995 162.886 175.715C166.792 166.436 168.803 156.469 168.8 146.401C168.86 134.28 165.941 122.33 160.3 111.601Z",
        fill: "#FF991F"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M154.7 65.501C154.883 64.7606 154.894 63.9882 154.733 63.2428C154.572 62.4974 154.242 61.7989 153.769 61.2005C153.296 60.6022 152.693 60.1199 152.005 59.7907C151.317 59.4615 150.563 59.2939 149.8 59.301H36.9C36.154 59.3157 35.4203 59.494 34.7507 59.8232C34.0812 60.1523 33.492 60.6244 33.0247 61.2061C32.5574 61.7878 32.2235 62.4649 32.0464 63.1897C31.8694 63.9146 31.8535 64.6694 32 65.401C35.8087 81.0131 33.7816 97.4789 26.3 111.701C20.3828 123.006 17.4891 135.648 17.9 148.401C18.9 188.401 51.5 220.901 91.5 221.901C101.565 222.141 111.577 220.365 120.946 216.679C130.314 212.992 138.851 207.469 146.054 200.434C153.257 193.399 158.979 184.995 162.886 175.715C166.792 166.436 168.803 156.469 168.8 146.401C168.86 134.28 165.941 122.33 160.3 111.601C152.848 97.4396 150.855 81.0347 154.7 65.501Z",
        fill: "#FFAB00"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M93.4001 214H91.7001C80.2465 213.718 69.0525 210.53 59.1692 204.735C49.2859 198.939 41.0377 190.727 35.1991 180.87C29.3605 171.012 26.1231 159.832 25.7909 148.38C25.4587 136.928 28.0426 125.579 33.3001 115.4C41.036 100.558 43.5711 83.5517 40.5001 67.0996H146.2C143.017 83.4736 145.522 100.444 153.3 115.2C158.352 124.82 160.962 135.534 160.9 146.4C160.926 155.276 159.199 164.07 155.818 172.277C152.436 180.484 147.467 187.942 141.195 194.223C134.923 200.505 127.472 205.485 119.27 208.879C111.068 212.273 102.276 214.013 93.4001 214Z",
        fill: "#FFC400"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        style: {
            mixBlendMode: 'multiply'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M152.8 178.6L84.5 119.6L80.8 123.9L149.9 183.5L152.8 178.6Z",
        fill: "#FFE380"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M90.4 170.601C88.3452 170.598 86.3155 170.15 84.4509 169.287C82.5862 168.424 80.9312 167.166 79.5999 165.601C78.2601 164.053 77.2786 162.229 76.7254 160.259C76.1722 158.288 76.0611 156.219 76.4 154.201L78.3 141.601C75.4643 138.69 73.5294 135.023 72.7277 131.039C71.926 127.055 72.2917 122.925 73.7808 119.144C75.2699 115.363 77.8191 112.093 81.122 109.726C84.4249 107.359 88.3411 105.996 92.4 105.801H93.4C98.996 105.801 104.363 108.024 108.32 111.981C112.277 115.938 114.5 121.305 114.5 126.901C114.496 132.416 112.302 137.703 108.4 141.601L110.4 154.201C110.692 156.226 110.548 158.291 109.979 160.257C109.41 162.222 108.428 164.044 107.1 165.601C105.769 167.166 104.114 168.424 102.249 169.287C100.384 170.15 98.3547 170.598 96.3 170.601H90.4Z",
        fill: "#FFAB00"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M106.6 126.9C106.586 128.711 106.196 130.499 105.456 132.151C104.716 133.803 103.641 135.284 102.3 136.5C101.574 137.222 101.032 138.107 100.719 139.081C100.405 140.056 100.33 141.091 100.5 142.1L102.6 155.4C102.728 156.305 102.662 157.226 102.405 158.103C102.147 158.979 101.706 159.79 101.109 160.482C100.512 161.173 99.7741 161.729 98.9446 162.112C98.1152 162.494 97.2134 162.695 96.3 162.7H90.4C89.4866 162.695 88.5848 162.494 87.7554 162.112C86.926 161.729 86.188 161.173 85.5912 160.482C84.9944 159.79 84.5526 158.979 84.2954 158.103C84.0382 157.226 83.9715 156.305 84.1 155.4L86.2 142C86.3747 140.983 86.2925 139.937 85.9607 138.959C85.6289 137.981 85.058 137.102 84.3 136.4C82.8962 135.116 81.7988 133.532 81.0892 131.767C80.3795 130.001 80.0756 128.099 80.2 126.2C80.2928 122.699 81.7726 119.379 84.3137 116.969C86.8548 114.559 90.2492 113.258 93.75 113.35C97.2509 113.443 100.571 114.923 102.981 117.464C105.391 120.005 106.693 123.399 106.6 126.9Z",
        fill: "#253858"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M149.2 130.901H93.4C92.8286 130.992 92.2443 130.959 91.6872 130.802C91.1302 130.645 90.6138 130.37 90.1736 129.994C89.7334 129.619 89.3799 129.152 89.1375 128.627C88.8951 128.102 88.7695 127.53 88.7695 126.951C88.7695 126.373 88.8951 125.801 89.1375 125.275C89.3799 124.75 89.7334 124.284 90.1736 123.908C90.6138 123.532 91.1302 123.257 91.6872 123.1C92.2443 122.944 92.8286 122.91 93.4 123.001H149.2C150.14 123.151 150.995 123.631 151.613 124.355C152.23 125.079 152.57 126 152.57 126.951C152.57 127.903 152.23 128.823 151.613 129.547C150.995 130.271 150.14 130.751 149.2 130.901Z",
        fill: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M153.1 126.901C153.075 125.875 152.656 124.897 151.93 124.172C151.204 123.446 150.226 123.027 149.2 123.001H112.4C111.829 122.91 111.244 122.944 110.687 123.1C110.13 123.257 109.614 123.532 109.174 123.908C108.733 124.284 108.38 124.75 108.137 125.275C107.895 125.801 107.77 126.373 107.77 126.951C107.77 127.53 107.895 128.102 108.137 128.627C108.38 129.152 108.733 129.619 109.174 129.994C109.614 130.37 110.13 130.645 110.687 130.802C111.244 130.959 111.829 130.992 112.4 130.901H149.2C150.243 130.875 151.235 130.442 151.964 129.695C152.693 128.947 153.1 127.945 153.1 126.901Z",
        fill: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M167.7 149.4C163.25 149.4 158.9 148.081 155.2 145.608C151.5 143.136 148.616 139.622 146.913 135.511C145.21 131.399 144.764 126.875 145.632 122.511C146.5 118.146 148.643 114.137 151.79 110.99C154.937 107.844 158.946 105.701 163.31 104.833C167.675 103.965 172.199 104.41 176.31 106.113C180.422 107.816 183.936 110.7 186.408 114.4C188.88 118.1 190.2 122.45 190.2 126.9C190.2 132.868 187.829 138.591 183.61 142.81C179.39 147.03 173.667 149.4 167.7 149.4ZM167.7 112.3C164.812 112.3 161.99 113.157 159.589 114.761C157.188 116.365 155.316 118.645 154.211 121.313C153.106 123.981 152.817 126.917 153.381 129.749C153.944 132.581 155.334 135.182 157.376 137.224C159.418 139.266 162.02 140.657 164.852 141.22C167.684 141.783 170.619 141.494 173.287 140.389C175.955 139.284 178.235 137.413 179.839 135.012C181.444 132.611 182.3 129.788 182.3 126.9C182.274 123.036 180.727 119.338 177.995 116.606C175.262 113.873 171.564 112.327 167.7 112.3Z",
        fill: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M67.8 165.301H55.6C55.3423 165.278 55.1009 165.166 54.918 164.983C54.7351 164.8 54.6225 164.558 54.6 164.301C54.6 164.036 54.7053 163.781 54.8929 163.594C55.0804 163.406 55.3348 163.301 55.6 163.301H67.8C68.0652 163.301 68.3196 163.406 68.5071 163.594C68.6946 163.781 68.8 164.036 68.8 164.301C68.7775 164.558 68.6649 164.8 68.482 164.983C68.2991 165.166 68.0576 165.278 67.8 165.301Z",
        fill: "#FFFAE5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M62.7999 182.5C62.6675 182.512 62.5342 182.491 62.412 182.438C62.2897 182.386 62.1825 182.304 62.0999 182.2C61.9167 182.013 61.8141 181.761 61.8141 181.5C61.8141 181.238 61.9167 180.987 62.0999 180.8L70.4999 172.3C70.6925 172.155 70.9307 172.085 71.1708 172.102C71.4109 172.119 71.6368 172.222 71.807 172.393C71.9773 172.563 72.0804 172.789 72.0974 173.029C72.1145 173.269 72.0444 173.507 71.8999 173.7L63.4999 182.2C63.3098 182.38 63.0616 182.486 62.7999 182.5Z",
        fill: "#FFFAE5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M79.9 189.6C79.6424 189.577 79.4009 189.464 79.218 189.282C79.0351 189.099 78.9226 188.857 78.9 188.6V175.6C78.9226 175.342 79.0351 175.1 79.218 174.918C79.4009 174.735 79.6424 174.622 79.9 174.6C80.1652 174.6 80.4196 174.705 80.6071 174.893C80.7947 175.08 80.9 175.334 80.9 175.6V188.6C80.9 188.865 80.7947 189.119 80.6071 189.307C80.4196 189.494 80.1652 189.6 79.9 189.6Z",
        fill: "#FFFAE5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M128.8 111.301H116.7C116.565 111.317 116.428 111.302 116.299 111.257C116.17 111.213 116.054 111.14 115.957 111.043C115.861 110.947 115.788 110.83 115.743 110.702C115.699 110.573 115.684 110.436 115.7 110.301C115.7 110.036 115.805 109.781 115.993 109.594C116.18 109.406 116.435 109.301 116.7 109.301H128.8C129.065 109.301 129.32 109.406 129.507 109.594C129.695 109.781 129.8 110.036 129.8 110.301C129.816 110.436 129.801 110.573 129.757 110.702C129.712 110.83 129.639 110.947 129.543 111.043C129.446 111.14 129.33 111.213 129.201 111.257C129.072 111.302 128.935 111.317 128.8 111.301Z",
        fill: "#FFFAE5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M113.2 102.601C112.938 102.587 112.69 102.481 112.5 102.301C112.317 102.114 112.214 101.863 112.214 101.601C112.214 101.339 112.317 101.088 112.5 100.901L121 92.5008C121.193 92.3563 121.431 92.2862 121.671 92.3033C121.911 92.3204 122.137 92.4235 122.307 92.5937C122.477 92.7639 122.58 92.9898 122.597 93.2299C122.615 93.47 122.544 93.7082 122.4 93.9008L113.9 102.301C113.812 102.399 113.704 102.477 113.583 102.528C113.462 102.58 113.331 102.605 113.2 102.601Z",
        fill: "#FFFAE5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M104.5 100C104.235 100 103.98 99.8947 103.793 99.7072C103.605 99.5196 103.5 99.2653 103.5 99.0001V86.1C103.5 85.8348 103.605 85.5805 103.793 85.3929C103.98 85.2054 104.235 85.1 104.5 85.1C104.635 85.084 104.772 85.0988 104.901 85.1433C105.03 85.1879 105.146 85.2611 105.243 85.3574C105.339 85.4536 105.412 85.5705 105.457 85.6991C105.501 85.8278 105.516 85.9649 105.5 86.1V99.0001C105.516 99.1352 105.501 99.2723 105.457 99.401C105.412 99.5296 105.339 99.6465 105.243 99.7428C105.146 99.839 105.03 99.9122 104.901 99.9568C104.772 100.001 104.635 100.016 104.5 100Z",
        fill: "#FFFAE5"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("clipPath", {
        id: "clip0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M0 0.400391H190.2V221.9H0V0.400391Z",
        fill: "white"
    }))));
};
var $f333fc6edfa90ad9$export$2e2bcd8739ae039 = $f333fc6edfa90ad9$var$AccessLockSVG;

});




parcelRegister("cCFSU", function(module, exports) {

$parcel$export(module.exports, "default", () => $f59aa209343f0b13$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5L0Jp = parcelRequire("5L0Jp");

var $kQ0RL = parcelRequire("kQ0RL");
const $f59aa209343f0b13$var$AkFlag = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQ0RL.CommonFlag), {
        flagType: "info",
        ...props
    }));
var $f59aa209343f0b13$export$2e2bcd8739ae039 = $f59aa209343f0b13$var$AkFlag;

});
parcelRegister("kQ0RL", function(module, exports) {

$parcel$export(module.exports, "CommonFlag", () => $2ffdc518941fd08c$export$13d73238a031436b);
$parcel$export(module.exports, "ErrorFlag", () => $2ffdc518941fd08c$export$518ba8e0e60f145f);
$parcel$export(module.exports, "ErrorAutoDismissFlag", () => $2ffdc518941fd08c$export$3f75672bb90a4431);
$parcel$export(module.exports, "InfoFlag", () => $2ffdc518941fd08c$export$6a55b52e74c1e48e);
$parcel$export(module.exports, "SuccessAutoDismissFlag", () => $2ffdc518941fd08c$export$74a3c0748aa31355);
$parcel$export(module.exports, "SuccessFlag", () => $2ffdc518941fd08c$export$93bd4963a1d00fd5);
$parcel$export(module.exports, "WarningFlag", () => $2ffdc518941fd08c$export$23695d8281998f27);
$parcel$export(module.exports, "FlagGroup", () => $2ffdc518941fd08c$export$a2c3479950310d7d);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $1ybV0 = parcelRequire("1ybV0");

var $5L0Jp = parcelRequire("5L0Jp");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintCommonFlag = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("aiVXY")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintCommonFlag = (0, $7rh0R.lazyAfterPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("aiVXY")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintJiraCommonFlag = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("aiVXY")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintJiraCommonFlag = (0, $7rh0R.lazyAfterPaint)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("aiVXY")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});
const $2ffdc518941fd08c$var$CommonFlagImpl = (props)=>{
    if ((0, $1ybV0.ff)('post-office_enable_jira_choreographer')) return __SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintJiraCommonFlag, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintJiraCommonFlag, props);
    return __SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintCommonFlag, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintCommonFlag, props);
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintFlagGroup = (0, $7rh0R.lazyForPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("Tabui")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintFlagGroup = (0, $7rh0R.lazyAfterPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("Tabui")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});
const $2ffdc518941fd08c$var$FlagGroupImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintFlagGroup, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintFlagGroup, props);
const $2ffdc518941fd08c$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, props));
const $2ffdc518941fd08c$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "error",
        ...props
    }));
const $2ffdc518941fd08c$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "error",
        isAutoDismiss: true,
        ...props
    }));
const $2ffdc518941fd08c$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "info",
        ...props
    }));
const $2ffdc518941fd08c$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "success",
        isAutoDismiss: true,
        ...props
    }));
const $2ffdc518941fd08c$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "success",
        ...props
    }));
const $2ffdc518941fd08c$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "warning",
        ...props
    }));
const $2ffdc518941fd08c$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$FlagGroupImpl, props));

});
parcelRegister("aiVXY", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('cCYJs')
        ]);
        const value = parcelRequire('kbpOk');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("cCYJs")
    ]).then(()=>parcelRequire('kbpOk'));
}

});

parcelRegister("Tabui", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hkLGi');
        const value = parcelRequire('jkRT2');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hkLGi").then(()=>parcelRequire('jkRT2'));
}

});



parcelRegister("g8JvH", function(module, exports) {

$parcel$export(module.exports, "AnalyticsEventToProps", () => $4e66802e461455f0$export$3e9ef96ba97ea9dc);

var $2jDha = parcelRequire("2jDha");
const $4e66802e461455f0$export$871de8747c9eaa88 = (props, componentName)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(props).reduce((result, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...result,
            [key]: {
                action: props[key],
                actionSubject: componentName
            }
        }), {});
const $4e66802e461455f0$export$3e9ef96ba97ea9dc = (componentName, eventActions)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (WrappedComponent)=>(0, $2jDha.default)($4e66802e461455f0$export$871de8747c9eaa88(eventActions, componentName))(WrappedComponent);

});

const $7543475b40b0a31d$export$a1455360a24a2234 = 'profileCardNextView';


parcelRegister("4w3h5", function(module, exports) {

$parcel$export(module.exports, "default", () => $125d5ecff4714394$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $asu8X = parcelRequire("asu8X");
parcelRequire("j2NCp");
var $icLG8 = parcelRequire("icLG8");

var $g8JvH = parcelRequire("g8JvH");

var $9Ibob = parcelRequire("9Ibob");
var $8Vu8p = parcelRequire("8Vu8p");

var $jxkjj = parcelRequire("jxkjj");


var $jVcNC = parcelRequire("jVcNC");
const $125d5ecff4714394$var$AnalyticsWrapper = (0, $g8JvH.AnalyticsEventToProps)((0, $099971b93b758534$export$a1455360a24a2234), {
    onAnalytics: 'fired'
});
const $125d5ecff4714394$export$23f88898e1cb6da9 = $125d5ecff4714394$var$AnalyticsWrapper((0, $icLG8.default)((0, $jVcNC.default)));
const $125d5ecff4714394$var$eventListenerOptions = {
    passive: true
};
const $125d5ecff4714394$export$dd0591e04a6e8ce6 = ({ baseUrl: baseUrl, profileClient: profileClient, cloudId: cloudId, onGetActions: onGetActions, onProfileClick: onProfileClick })=>{
    (0, $asu8X.di)(setTimeout);
    // Hooks
    const [userData, setUserData] = (0, $eUqFw.useState)(null);
    const [referenceElement, setReferenceElement] = (0, $eUqFw.useState)(null);
    const [showProfileCard, setShowProfileCard] = (0, $eUqFw.useState)(false);
    const [offset, setOffset] = (0, $eUqFw.useState)(null);
    const showTimeoutId = (0, $eUqFw.useRef)(null);
    const onMouseLeaveCancelShowCard = ()=>{
        if (showTimeoutId.current) // @ts-expect-error - TS2769 - No overload matches this call.
        clearTimeout(showTimeoutId.current);
    };
    const onHideProfileCard = ()=>{
        setShowProfileCard(false);
        onMouseLeaveCancelShowCard();
    };
    const { setTriggerRef: setTriggerRef, setCardRef: setCardRef, unsetTriggerRef: unsetTriggerRef, unsetCardRef: unsetCardRef, getTimeoutId: getTimeoutId } = (0, $8Vu8p.useHideProfileCardDelayed)(true, false, onHideProfileCard);
    // Add event listener using our hook
    // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'HTMLElement | null'.
    (0, $8Vu8p.useEventListener)('mouseleave', unsetTriggerRef, referenceElement, $125d5ecff4714394$var$eventListenerOptions);
    (0, $8Vu8p.useEventListener)('mouseleave', onMouseLeaveCancelShowCard, // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'HTMLElement | null'.
    referenceElement, $125d5ecff4714394$var$eventListenerOptions);
    // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'HTMLElement | null'.
    (0, $8Vu8p.useEventListener)('mouseenter', setTriggerRef, referenceElement, $125d5ecff4714394$var$eventListenerOptions);
    // @ts-expect-error - TS2345 - Argument of type 'Window & typeof globalThis' is not assignable to parameter of type 'HTMLElement | null'.
    (0, $8Vu8p.useEventListener)('scroll', onHideProfileCard, window, $125d5ecff4714394$var$eventListenerOptions);
    const clearHideCardTimeout = (timeoutId)=>{
        if (timeoutId) clearTimeout(timeoutId);
    };
    const setShowProfileCardDelayed = ()=>setTimeout(()=>setShowProfileCard(true), (0, $515c9dbc88c31cf4$export$5b956b542f1bc1b3));
    const setData = (data, ref, offsetValue)=>{
        clearHideCardTimeout(getTimeoutId());
        setOffset(offsetValue || '0, 8px');
        setUserData(data);
        setReferenceElement(ref);
        showTimeoutId.current = setShowProfileCardDelayed();
    };
    const api = {
        setData: setData,
        hideProfileCard: onHideProfileCard
    };
    (0, $jxkjj.default)(api);
    return showProfileCard && referenceElement && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Ibob.ProfileCardLegacyWrapper), {
        onMouseEnter: setCardRef,
        onMouseLeave: unsetCardRef,
        // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'HTMLElement'.
        referenceElement: referenceElement,
        // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'string | null'.
        offset: offset
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($125d5ecff4714394$export$23f88898e1cb6da9, {
            baseUrl: baseUrl,
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            accountId: userData && userData.accountId,
            cloudId: cloudId,
            handleEscapeKeydown: onHideProfileCard,
            handleClickOutside: onHideProfileCard,
            profileClient: profileClient,
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            actions: onGetActions(userData ? userData.accountId : '', ()=>{
                clearHideCardTimeout(getTimeoutId());
                onHideProfileCard();
            }),
            onProfileClick: onProfileClick
        }));
};
var $125d5ecff4714394$export$2e2bcd8739ae039 = $125d5ecff4714394$export$dd0591e04a6e8ce6;

});
parcelRegister("9Ibob", function(module, exports) {

$parcel$export(module.exports, "ProfileCardLegacyWrapper", () => $6a55628c53a0dae8$export$6ef7d4845cf112be);

var $eUqFw = parcelRequire("eUqFw");

var $8blac = parcelRequire("8blac");

var $i6BC8 = parcelRequire("i6BC8");

var $8Vu8p = parcelRequire("8Vu8p");
// Updated version of popper requires tuple but provided value may be a string
const $6a55628c53a0dae8$var$parsePopperOffsetValue = (offset)=>{
    let offsetArray = [
        0,
        0
    ];
    if ((0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(offset)) return offsetArray;
    if (typeof offset === 'string') // @ts-expect-error - TS2322 - Type 'number[]' is not assignable to type '[number | null | undefined, number | null | undefined]'.
    offsetArray = offset.split(',').map((pxValue)=>parseInt(pxValue.replace('px', ''), 10));
    else if (Array.isArray(offset) && offset.length === 2) // @ts-expect-error - TS2322 - Type 'number[]' is not assignable to type '[number | null | undefined, number | null | undefined]'.
    offsetArray = offset;
    return offsetArray.some(Number.isNaN) ? [
        0,
        0
    ] : offsetArray;
};
const $6a55628c53a0dae8$export$6ef7d4845cf112be = ({ onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, referenceElement: referenceElement, offset: offset, children: children, placement: placement })=>{
    const offsetTuple = $6a55628c53a0dae8$var$parsePopperOffsetValue(offset);
    const modifiers = [
        {
            name: 'offset',
            options: {
                offset: offsetTuple
            }
        },
        {
            name: 'preventOverflow',
            options: {
                tether: true
            }
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i6BC8.Popper), {
        referenceElement: referenceElement,
        placement: placement || (0, $8Vu8p.getPlacement)(referenceElement),
        modifiers: modifiers
    }, ({ ref: ref, style: style, forceUpdate: forceUpdate })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            "data-testid": "profilecard-next.common.ui.legacy-profile-card.div",
            ref: ref,
            // eslint-disable-next-line jira/react/no-style-attribute
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                ...style
            },
            onMouseLeave: onMouseLeave,
            onMouseEnter: onMouseEnter
        }, children(forceUpdate)));
};

});
parcelRegister("8Vu8p", function(module, exports) {

$parcel$export(module.exports, "useEventListener", () => $9f1ecee81bf1a8fe$export$7080b3e976bc91ab);
$parcel$export(module.exports, "useHideProfileCardDelayed", () => $9f1ecee81bf1a8fe$export$30416a530a92ed77);
$parcel$export(module.exports, "getPlacement", () => $9f1ecee81bf1a8fe$export$a9fe23cfa43a7b55);

var $eUqFw = parcelRequire("eUqFw");
const $9f1ecee81bf1a8fe$export$7080b3e976bc91ab = (eventName, handler, element, // @ts-expect-error - TS2304 - Cannot find name 'EventListenerOptionsOrUseCapture'.
options)=>{
    // Create a ref that stores handler
    const savedHandler = (0, $eUqFw.useRef)();
    // Update ref.current value if handler changes.
    // This allows our effect below to always get latest handler ...
    // ... without us needing to pass it in effect deps array ...
    // ... and potentially cause effect to re-run every render.
    (0, $eUqFw.useEffect)(()=>{
        savedHandler.current = handler;
    }, [
        handler
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // Create event listener that calls handler function stored in ref
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const eventListener = ()=>savedHandler.current && savedHandler.current();
        // Add event listener
        element && element.addEventListener(eventName, eventListener, options);
        // Remove event listener on cleanup
        return ()=>{
            element && element.removeEventListener(eventName, eventListener, options);
        };
    }, [
        eventName,
        element,
        options
    ]);
};
const $9f1ecee81bf1a8fe$export$30416a530a92ed77 = (initialfirst, initialSecond, callback)=>{
    const triggerRef = (0, $eUqFw.useRef)(initialfirst);
    const cardRef = (0, $eUqFw.useRef)(initialSecond);
    const timeoutId = (0, $eUqFw.useRef)(null);
    const setStateDelayed = ()=>{
        if (timeoutId.current) // @ts-expect-error - TS2769 - No overload matches this call.
        clearTimeout(timeoutId.current);
        timeoutId.current = setTimeout(()=>{
            if (!triggerRef.current && !cardRef.current) callback();
        }, 400);
    };
    const setTriggerRef = ()=>{
        triggerRef.current = true;
        setStateDelayed();
    };
    const unsetTriggerRef = ()=>{
        triggerRef.current = false;
        setStateDelayed();
    };
    const setCardRef = ()=>{
        cardRef.current = true;
        setStateDelayed();
    };
    const unsetCardRef = ()=>{
        cardRef.current = false;
        setStateDelayed();
    };
    const getTimeoutId = ()=>timeoutId.current;
    return {
        setTriggerRef: setTriggerRef,
        setCardRef: setCardRef,
        unsetTriggerRef: unsetTriggerRef,
        unsetCardRef: unsetCardRef,
        getTimeoutId: // @ts-expect-error - TS2322 - Type '() => unknown' is not assignable to type '() => number | null'.
        getTimeoutId
    };
};
const $9f1ecee81bf1a8fe$export$a9fe23cfa43a7b55 = (referenceElement)=>{
    if (referenceElement && typeof referenceElement.id === 'string' && referenceElement.id.indexOf('issue_summary') > -1) return 'left-start';
    return 'top-start';
};

});


parcelRegister("jxkjj", function(module, exports) {

$parcel$export(module.exports, "default", () => $ced5b8453ce5e364$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $ds5Im = parcelRequire("ds5Im");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ced5b8453ce5e364$export$2e2bcd8739ae039 = (api)=>{
    // eslint-disable-next-line jira/wrm/no-load-bridge
    (0, $ds5Im.loadBridgeWeak)({
        name: 'jira/profilecard/bridge'
    }).then((bridge)=>{
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        bridge(api);
    });
};

});
parcelRegister("ds5Im", function(module, exports) {

$parcel$export(module.exports, "loadBridgeWeak", () => $1b3123f198513ce0$export$3cefda82396756a1);

var $1gau4 = parcelRequire("1gau4");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let $1b3123f198513ce0$var$pollingSingleton = null;
const $1b3123f198513ce0$export$3cefda82396756a1 = ({ name: name })=>{
    const getter = $1b3123f198513ce0$var$pollingSingleton ?? (0, $1gau4.createPollingCollection)((v)=>window.require(v), 100);
    $1b3123f198513ce0$var$pollingSingleton = getter;
    return getter(name);
};

});
parcelRegister("1gau4", function(module, exports) {

$parcel$export(module.exports, "createPollingCollection", () => $9f3ee0cd5dcb553b$export$f163446a982a8077);

var $asu8X = parcelRequire("asu8X");

var $eFUPR = parcelRequire("eFUPR");
const $9f3ee0cd5dcb553b$export$f163446a982a8077 = (fn, timeout)=>{
    (0, $asu8X.di)(setTimeout);
    let isPolling = false;
    // Deferred instance is retained for polling
    const deferredMap = new Map();
    // Promise is derived from Deferred and is retained indefinitely
    const promiseMap = new Map();
    // Provided fn will throw until ready, once ready we will resolve and delete the Deferred
    const evaluateForKey = (key)=>{
        let result;
        try {
            result = fn(key);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            return;
        }
        const deferred = deferredMap.get(key);
        if (deferred instanceof (0, $eFUPR.default)) {
            deferred.resolve(result);
            deferredMap.delete(key);
        }
    };
    const maybePoll = ()=>{
        if (!isPolling && deferredMap.size > 0) {
            isPolling = true;
            setTimeout(()=>{
                isPolling = false;
                [
                    ...deferredMap.keys()
                ].forEach(evaluateForKey);
                maybePoll();
            }, timeout);
        }
    };
    const getter = (key)=>{
        if (!promiseMap.has(key)) {
            const deferred = new (0, $eFUPR.default)();
            const promise = deferred.then((v)=>v);
            deferredMap.set(key, deferred);
            promiseMap.set(key, promise);
            evaluateForKey(key);
            maybePoll();
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return promiseMap.get(key);
    };
    return getter;
};

});
parcelRegister("eFUPR", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bee8fab77b1b942$export$2e2bcd8739ae039);
// @ts-expect-error - TS2417 - Class static side 'typeof Deferred' incorrectly extends base class static side '{ all<T>(values: Iterable<T | PromiseLike<T>>): Promise<Awaited<T>[]>; all<T extends readonly unknown[] | []>(values: T): Promise<{ -readonly [P in keyof T]: Awaited<T[P]>; }>; ... 5 more ...; readonly [Symbol.species]: PromiseConstructor; }'.
class $8bee8fab77b1b942$export$2e2bcd8739ae039 extends Promise {
    // go/jfe-eslint
    static resolve(v) {
        const instance = new $8bee8fab77b1b942$export$2e2bcd8739ae039();
        instance.resolve(v);
        return instance;
    }
    // go/jfe-eslint
    static reject(e) {
        const instance = new $8bee8fab77b1b942$export$2e2bcd8739ae039();
        instance.reject(e);
        return instance;
    }
    constructor(){
        // Promise.prototype.then() must be able to call new Deferred(fn)
        // @see https://stackoverflow.com/a/48159603
        // by using arguments flow will ensure we cannot instantiate with constructor parameters
        // eslint-disable-next-line prefer-rest-params
        const [fn] = Array.prototype.slice.call(arguments);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const callbacks = [];
        super(fn ?? callbacks.push.bind(callbacks));
        this.#resolve = callbacks[0];
        this.#reject = callbacks[1];
    }
    #resolve;
    #reject;
    resolve(v) {
        this.#resolve?.(v);
    }
    reject(e) {
        this.#reject?.(e);
    }
}

});




const $099971b93b758534$export$a1455360a24a2234 = 'profileCardNextLegacyView';

parcelRegister("jVcNC", function(module, exports) {

$parcel$export(module.exports, "default", () => $1df69c97362405f1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $j2NCp = parcelRequire("j2NCp");

var $cCFSU = parcelRequire("cCFSU");
var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $bv8gI = parcelRequire("bv8gI");
const $1df69c97362405f1$export$6f67c636e2e30540 = ({ cloudId: cloudId, profileClient: profileClient, accountId: accountId, actions: actions, onProfileClick: onProfileClick })=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    const onReportingLinesClick = onProfileClick ? (user)=>onProfileClick(user.accountIdentifier) : undefined;
    const profileCardProps = {
        userId: accountId,
        cloudId: cloudId,
        actions: (0, $bv8gI.isCustomerAccount)(accountId) ? [] : actions,
        resourceClient: profileClient,
        onReportingLinesClick: onReportingLinesClick
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j2NCp.default), {
        ...profileCardProps,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        addFlag: (flag)=>{
            const flagId = (0, $eo17r.toFlagId)(flag.id);
            showFlag({
                id: flagId,
                render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cCFSU.default), {
                        ...flag,
                        onDismissed: ()=>{
                            dismissFlag(flagId);
                        },
                        ...props
                    })
            });
        }
    });
};
const $1df69c97362405f1$var$ProfileCardResourced = $1df69c97362405f1$export$6f67c636e2e30540;
var $1df69c97362405f1$export$2e2bcd8739ae039 = $1df69c97362405f1$var$ProfileCardResourced;

});
parcelRegister("bv8gI", function(module, exports) {

$parcel$export(module.exports, "restResponseToUserData", () => $cd9a986ac0e3329e$export$66691b1affeb3bc5);
$parcel$export(module.exports, "isCustomerAccount", () => $cd9a986ac0e3329e$export$67a41405362363f0);
$parcel$export(module.exports, "getSpaActions", () => $cd9a986ac0e3329e$export$518f47d656cb4e1a);


var $bncoh = parcelRequire("bncoh");
const $cd9a986ac0e3329e$export$66691b1affeb3bc5 = (userData)=>({
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        avatarUrl: userData.avatarUrls['48x48'],
        email: userData.emailAddress,
        fullName: userData.displayName,
        isBot: false,
        isCurrentUser: false,
        status: userData.active ? 'active' : 'inactive',
        accountType: userData.accountType
    });
const $cd9a986ac0e3329e$export$67a41405362363f0 = (accountId)=>accountId ? accountId.lastIndexOf('qm:', 0) === 0 : false;
const $cd9a986ac0e3329e$var$getSpaViewProfileAction = (// @ts-expect-error - TS7006 - Parameter 'intl' implicitly has an 'any' type.
intl, baseUrl, accountId, onPushAction, onActionCleanup)=>({
        label: intl && intl.formatMessage((0, $bncoh.profileCardMessages).viewProfile),
        id: 'view-profile',
        callback: ()=>{
            onPushAction(`${baseUrl}/jira/people/${accountId}`);
            onActionCleanup && onActionCleanup();
        },
        link: `${baseUrl}/jira/people/${accountId}`,
        shouldRender: (data)=>/*
   * Those without @atlassian.com accounts do not have viewable profiles
   */ data?.accountType !== 'customer'
    });
// @ts-expect-error - TS7006 - Parameter 'intl' implicitly has an 'any' type.
const $cd9a986ac0e3329e$var$getAssignedIssuesAction = (intl, baseUrl, accountId)=>({
        label: intl && intl.formatMessage((0, $bncoh.profileCardMessages).assignedIssues),
        id: 'assigned-issues',
        callback: ()=>{
            const jql = encodeURIComponent(`assignee="${accountId || ''}" AND resolution is empty`);
            const url = `${baseUrl}/issues/?jql=${jql}`;
            window.open(url, '_blank');
        }
    });
// @ts-expect-error - TS7006 - Parameter 'intl' implicitly has an 'any' type.
const $cd9a986ac0e3329e$var$getReportedIssuesAction = (intl, baseUrl, accountId)=>({
        label: intl && intl.formatMessage((0, $bncoh.profileCardMessages).reportedIssues),
        id: 'reported-issues',
        callback: ()=>{
            const jql = encodeURIComponent(`reporter="${accountId || ''}" order by created DESC`);
            const url = `${baseUrl}/issues/?jql=${jql}`;
            window.open(url, '_blank');
        }
    });
// @ts-expect-error - TS7006 - Parameter 'intl' implicitly has an 'any' type.
const $cd9a986ac0e3329e$var$getViewFiltersAction = (intl, accountId)=>({
        label: intl && intl.formatMessage((0, $bncoh.profileCardMessages).viewFilters),
        id: 'view-filters',
        callback: ()=>{
            const url = `/jira/filters?owner=${encodeURIComponent(accountId)}`;
            window.open(url, '_blank');
        }
    });
const $cd9a986ac0e3329e$export$518f47d656cb4e1a = (accountId, baseUrl, intl, onPushAction, actions, onActionCleanup)=>{
    if (actions) return actions.map((action)=>{
        switch(action){
            case 0, $2f37035f7aaf1787$export$23cedd3261bd8015:
                return $cd9a986ac0e3329e$var$getSpaViewProfileAction(intl, baseUrl, accountId, onPushAction, onActionCleanup);
            case 0, $2f37035f7aaf1787$export$6bef782d14a92db8:
                return $cd9a986ac0e3329e$var$getAssignedIssuesAction(intl, baseUrl, accountId);
            case 0, $2f37035f7aaf1787$export$6b36f20db7a18a86:
                return $cd9a986ac0e3329e$var$getReportedIssuesAction(intl, baseUrl, accountId);
            case 0, $2f37035f7aaf1787$export$56da0dd0b0aa67b9:
                return $cd9a986ac0e3329e$var$getViewFiltersAction(intl, accountId);
            default:
                throw new Error('unexpected action');
        }
    });
    return [
        $cd9a986ac0e3329e$var$getSpaViewProfileAction(intl, baseUrl, accountId, onPushAction, onActionCleanup)
    ];
};

});
parcelRegister("bncoh", function(module, exports) {

$parcel$export(module.exports, "profileCardMessages", () => $daa0299e513e1d61$export$49f2d2ccb123fddf);

var $90IgZ = parcelRequire("90IgZ");
const $daa0299e513e1d61$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    view: {
        "id": "profilecard-next",
        "defaultMessage": "View profile"
    }
});
const $daa0299e513e1d61$export$49f2d2ccb123fddf = (0, $90IgZ.defineMessages)({
    assignedIssues: {
        "id": "profilecard-next.assigned-issues",
        "defaultMessage": "Assigned issues"
    },
    viewProfile: {
        "id": "profilecard-next.view-profile",
        "defaultMessage": "View profile"
    },
    reportedIssues: {
        "id": "profilecard-next.reported-issues",
        "defaultMessage": "Reported issues"
    },
    viewFilters: {
        "id": "profilecard-next.view-filters",
        "defaultMessage": "View filters"
    }
});

});




parcelRegister("NILIK", function(module, exports) {

$parcel$export(module.exports, "default", () => $14c4cd19c15bc811$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $g8JvH = parcelRequire("g8JvH");

var $dWLk9 = parcelRequire("dWLk9");
var $d9epm = parcelRequire("d9epm");
var $gd0Sp = parcelRequire("gd0Sp");


var $5lWRu = parcelRequire("5lWRu");
const $14c4cd19c15bc811$var$ProfileCardWrapper = (props)=>{
    const { TenantContextSubscriber: TenantContextSubscriberComponent, externalProfileClient: externalProfileClient, children: children, onLoadError: onLoadError } = props;
    const teamCentralUrl = (0, $d9epm.useTeamCentralUrl)();
    const teamCentralBaseUrl = (0, $d9epm.useTeamCentralBaseUrl)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const renderProfileClientContainerWrapper = (0, $eUqFw.useCallback)((tenantContext)=>{
        if (tenantContext && tenantContext.atlassianAccountId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5lWRu.ProfileClientContainer), {
            fabricPfDirUrl: tenantContext.fabricPfDirUrl,
            baseUrl: tenantContext.baseUrl,
            profileClient: externalProfileClient || null,
            onLoadError: onLoadError,
            isGlobal: true,
            teamCentralUrl: teamCentralUrl,
            teamCentralBaseUrl: teamCentralBaseUrl,
            cloudId: cloudId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5lWRu.ProfileClientSubscriber), null, ({ profileClient: profileClient })=>children(tenantContext.atlassianAccountId, profileClient, tenantContext.cloudId, tenantContext.baseUrl)));
        // When there is no tenantContext, this will cause the child
        // component of <ProfileCard> to render without being wrapped by
        // a profile card and it will do nothing on hover
        return children('', null, '', '');
    }, [
        children,
        externalProfileClient,
        onLoadError,
        teamCentralBaseUrl,
        teamCentralUrl,
        cloudId
    ]);
    if (TenantContextSubscriberComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TenantContextSubscriberComponent, null, ({ tenantContext: tenantContext })=>renderProfileClientContainerWrapper(tenantContext));
    // Here we conditionally call hooks which is frowned upon by React.
    // However this is safe as the value of TenantContextSubscriberComponent doesn't change dynamically
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return renderProfileClientContainerWrapper(tenantContext);
};
$14c4cd19c15bc811$var$ProfileCardWrapper.defaultProps = {
    externalProfileClient: null,
    sourceName: null,
    createAnalyticsEvent: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$14c4cd19c15bc811$export$2e2bcd8739ae039 = (0, $g8JvH.AnalyticsEventToProps)((0, $2f37035f7aaf1787$export$3145fc6c544ad7bf), {
    onLoadError: (0, $2f37035f7aaf1787$export$2549357601611c61)
})($14c4cd19c15bc811$var$ProfileCardWrapper);

});
parcelRegister("dWLk9", function(module, exports) {

$parcel$export(module.exports, "useCloudId", () => $15ea95bdeaf03a79$export$9da0f7c65f28ed16);

var $gd0Sp = parcelRequire("gd0Sp");
const $15ea95bdeaf03a79$export$9da0f7c65f28ed16 = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.cloudId;
};

});

parcelRegister("d9epm", function(module, exports) {

$parcel$export(module.exports, "useTeamCentralUrl", () => $27fe3a2e52ea675c$export$12bf0987a96bab08);
$parcel$export(module.exports, "useTeamCentralBaseUrl", () => $27fe3a2e52ea675c$export$b49e0105c58cb761);

var $3e9vj = parcelRequire("3e9vj");
const $27fe3a2e52ea675c$export$12bf0987a96bab08 = ()=>'/gateway/api/watermelon/graphql';
const $27fe3a2e52ea675c$export$b49e0105c58cb761 = ()=>{
    const env = (0, $3e9vj.useEnvironment)();
    if (env === 'staging' || env === 'dev' || env === 'local') return 'https://team.stg.atlassian.com';
    return 'https://team.atlassian.com';
};

});
parcelRegister("3e9vj", function(module, exports) {

$parcel$export(module.exports, "useEnvironment", () => $f75608ebab912e29$export$ea7ed2425832167d);
$parcel$export(module.exports, "useIsStagingOrDevOrLocal", () => $f75608ebab912e29$export$b0d8f74f433a09c9);

var $gd0Sp = parcelRequire("gd0Sp");
const $f75608ebab912e29$var$ENVIRONMENT = {
    STAGING: 'staging',
    DEV: 'dev',
    LOCAL: 'local',
    PROD: 'prod'
};
const $f75608ebab912e29$export$ea7ed2425832167d = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext?.environment || $f75608ebab912e29$var$ENVIRONMENT.PROD;
};
const $f75608ebab912e29$export$b0d8f74f433a09c9 = ()=>{
    const env = $f75608ebab912e29$export$ea7ed2425832167d();
    return env === $f75608ebab912e29$var$ENVIRONMENT.STAGING || env === $f75608ebab912e29$var$ENVIRONMENT.DEV || env === $f75608ebab912e29$var$ENVIRONMENT.LOCAL;
};

});


parcelRegister("5lWRu", function(module, exports) {

$parcel$export(module.exports, "createUserProfileCardClient", () => $d57808c9e3ca761c$export$c4393c51e6d104c3);
$parcel$export(module.exports, "ProfileClientSubscriber", () => $d57808c9e3ca761c$export$10cad281024d43c8);
$parcel$export(module.exports, "useProfileClient", () => $d57808c9e3ca761c$export$d43dc22a8337ee9f);
$parcel$export(module.exports, "ProfileClientContainer", () => $d57808c9e3ca761c$export$d816ba2709570028);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
var $dYfll = parcelRequire("dYfll");
parcelRequire("j2NCp");
var $lsiAJ = parcelRequire("lsiAJ");

var $2vQty = parcelRequire("2vQty");
const $d57808c9e3ca761c$var$GATEWAY_GRAPHQL_URL = '/gateway/api/graphql';
const $d57808c9e3ca761c$export$c4393c51e6d104c3 = (fabricPfDirUrl, baseUrl, onLoadError, teamCentralUrl, teamCentralBaseUrl, gatewayGraphqlUrl, cloudId)=>{
    const userClient = new (0, $2vQty.CustomProfileClient)(fabricPfDirUrl, baseUrl, onLoadError);
    // From upward version 14 of `@atlaskit/profilecard`, `ProfileClient` class accepts `userClient` and `teamClient` in the 2nd argument.
    return new (0, $lsiAJ.default)({
        cacheMaxAge: 180000,
        cacheSize: 20,
        url: fabricPfDirUrl,
        teamCentralUrl: teamCentralUrl,
        teamCentralBaseUrl: teamCentralBaseUrl,
        productIdentifier: 'jira',
        gatewayGraphqlUrl: gatewayGraphqlUrl,
        cloudId: cloudId
    }, {
        userClient: userClient
    });
};
const $d57808c9e3ca761c$export$36aff1fbb4f5dfc6 = ()=>({ setState: setState }, { fabricPfDirUrl: fabricPfDirUrl, baseUrl: baseUrl, profileClient: profileClient, onLoadError: onLoadError, teamCentralUrl: teamCentralUrl, teamCentralBaseUrl: teamCentralBaseUrl, cloudId: cloudId })=>{
        const finalProfileClient = profileClient || $d57808c9e3ca761c$export$c4393c51e6d104c3(fabricPfDirUrl, baseUrl, onLoadError, teamCentralUrl, teamCentralBaseUrl, $d57808c9e3ca761c$var$GATEWAY_GRAPHQL_URL, cloudId);
        setState({
            profileClient: finalProfileClient
        });
    };
const $d57808c9e3ca761c$export$e324594224ef24da = {
    bootstrap: $d57808c9e3ca761c$export$36aff1fbb4f5dfc6
};
const $d57808c9e3ca761c$export$d4c72bab9d6cc13a = {
    profileClient: null
};
const $d57808c9e3ca761c$export$6f57813fe9f31bf9 = (0, $a61MH.createStore)({
    initialState: $d57808c9e3ca761c$export$d4c72bab9d6cc13a,
    actions: $d57808c9e3ca761c$export$e324594224ef24da
});
const $d57808c9e3ca761c$export$10cad281024d43c8 = (0, $dYfll.createSubscriber)($d57808c9e3ca761c$export$6f57813fe9f31bf9);
const $d57808c9e3ca761c$export$d43dc22a8337ee9f = (0, $ggKAj.createHook)($d57808c9e3ca761c$export$6f57813fe9f31bf9);
const $d57808c9e3ca761c$export$d816ba2709570028 = (0, $heB5U.createContainer)($d57808c9e3ca761c$export$6f57813fe9f31bf9, {
    onInit: ()=>({ dispatch: dispatch })=>dispatch($d57808c9e3ca761c$export$e324594224ef24da.bootstrap())
});

});
parcelRegister("2vQty", function(module, exports) {

$parcel$export(module.exports, "CustomProfileClient", () => $1299391c5e75a14e$export$aa8db43941b8d3a7);
parcelRequire("j2NCp");
var $b4hs7 = parcelRequire("b4hs7");

var $2OdyW = parcelRequire("2OdyW");

var $bv8gI = parcelRequire("bv8gI");
class $1299391c5e75a14e$export$aa8db43941b8d3a7 extends (0, $b4hs7.default) {
    constructor(fabricPfDirUrl, baseUrl, onLoadError){
        super({
            url: fabricPfDirUrl,
            cacheSize: 20,
            cacheMaxAge: 180000
        });
        this.makeRequest = async (cloudId, userId)=>{
            // call old profilerestendpoint
            try {
                if ((0, $bv8gI.isCustomerAccount)(userId)) {
                    const response = await (0, $2OdyW.default)(`${this.baseUrl}/rest/api/3/user?accountId=${userId}`);
                    return (0, $bv8gI.restResponseToUserData)(response);
                }
                return await this.parentMakeRequest(cloudId, userId);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (err) {
                const error = new Error(`Unable to fetch user: ${err.message}`, {
                    cause: err
                });
                this.onLoadError?.(err);
                throw error;
            }
        };
        this.baseUrl = baseUrl;
        this.onLoadError = onLoadError;
        this.parentMakeRequest = super.makeRequest;
    }
}

});






//# sourceMappingURL=async-profilecard.8ca1d650.js.map
